import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Represents untyped JSON */
  JSON: any;
};

export type Activity = {
  __typename?: 'Activity';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  ip?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  owner: User;
  ownerId: Scalars['ID'];
  recipient: ActivityRecipient;
  recipientId: Scalars['ID'];
  recipientType: Scalars['String'];
  trackable: ActivityTrackable;
  trackableId: Scalars['ID'];
  trackableType: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ActivityCollection = {
  __typename?: 'ActivityCollection';
  collection: Array<Activity>;
  metadata: CollectionMetadata;
};

/** Objects which may be recipients of activities */
export type ActivityRecipient = Campaign | Company | Review | User;

/** Objects which may be subject of activities */
export type ActivityTrackable = Campaign | Company | Group | Report | Review | Template | User;

/** Autogenerated input type of AddReviewDocument */
export type AddReviewDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  signedId: Scalars['String'];
};

/** Autogenerated return type of AddReviewDocument */
export type AddReviewDocumentPayload = {
  __typename?: 'AddReviewDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  document: Document;
};

/** Autogenerated input type of AddUserDocument */
export type AddUserDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  signedId: Scalars['String'];
};

/** Autogenerated return type of AddUserDocument */
export type AddUserDocumentPayload = {
  __typename?: 'AddUserDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  document: Document;
};

export type Answer = {
  __typename?: 'Answer';
  canCreate: Scalars['Boolean'];
  canDestroy: Scalars['Boolean'];
  collaborator: User;
  collaboratorId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isCollaborator: Scalars['Boolean'];
  isDraft: Scalars['Boolean'];
  isEmpty: Scalars['Boolean'];
  isGoal?: Maybe<Scalars['Boolean']>;
  normalizedRating?: Maybe<Scalars['Float']>;
  question: Question;
  questionDigest: Scalars['String'];
  questionId: Scalars['ID'];
  report?: Maybe<Report>;
  reportId?: Maybe<Scalars['ID']>;
  review?: Maybe<Review>;
  reviewId?: Maybe<Scalars['ID']>;
  selector?: Maybe<Scalars['JSON']>;
  skill?: Maybe<Skill>;
  skillId?: Maybe<Scalars['ID']>;
  timeSpent?: Maybe<Scalars['Int']>;
  type: AnswerTypeEnum;
  updatedAt: Scalars['String'];
  user: User;
  userId: Scalars['ID'];
  value?: Maybe<Scalars['JSON']>;
  valueSchema?: Maybe<Scalars['String']>;
};

export type AnswerCollection = {
  __typename?: 'AnswerCollection';
  collection: Array<Answer>;
  metadata: CollectionMetadata;
};

export type AnswerInput = {
  collaboratorId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  questionId: Scalars['ID'];
  timeSpent?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  userId: Scalars['ID'];
  value: Scalars['JSON'];
};

export type AnswerMatchingInput = {
  digest?: Maybe<Scalars['String']>;
  lastCreatedAt?: Maybe<Scalars['String']>;
  maximumNormalizedRating?: Maybe<Scalars['Float']>;
  minimumNormalizedRating?: Maybe<Scalars['Float']>;
  skillId?: Maybe<Scalars['ID']>;
};

export type AnswerTypeEnum =
  /** Evaluation answer */
  | 'AnswerEvaluation'
  /** Multiple choice answer */
  | 'AnswerSelectorMultiple'
  /** Single choice answer */
  | 'AnswerSelectorSingle'
  /** Skill answer */
  | 'AnswerSkill'
  /** Text answer */
  | 'AnswerText';

export type Campaign = {
  __typename?: 'Campaign';
  canDestroy: Scalars['Boolean'];
  canInsert: Scalars['Boolean'];
  canShow: Scalars['Boolean'];
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastCheckedReportIds: Array<Scalars['ID']>;
  lastCheckedReports: Array<Report>;
  lastCheckedReportsCount: Scalars['Int'];
  name: Scalars['String'];
  openReportsCount: Scalars['Int'];
  reminderEnabled?: Maybe<Scalars['Boolean']>;
  reminderGap?: Maybe<Scalars['Int']>;
  reportsCount: Scalars['Int'];
  reviewIds: Array<Scalars['ID']>;
  reviews: Array<Review>;
  reviewsCount: Scalars['Int'];
  slug: Scalars['String'];
  unfilledReportsCount: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type CampaignCollection = {
  __typename?: 'CampaignCollection';
  collection: Array<Campaign>;
  metadata: CollectionMetadata;
};

export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  currentPage: Scalars['Int'];
  limitValue: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Company = {
  __typename?: 'Company';
  campaignIds: Array<Scalars['ID']>;
  campaigns: Array<Campaign>;
  campaignsCount: Scalars['Int'];
  createdAt: Scalars['String'];
  customTranslationsEnabled: Scalars['Boolean'];
  groupIds: Array<Scalars['ID']>;
  groups: Array<Group>;
  groupsCount: Scalars['Int'];
  id: Scalars['ID'];
  inlineTemplateUpdateEnabled: Scalars['Boolean'];
  lastCheckedReportIds: Array<Scalars['ID']>;
  lastCheckedReports: Array<Report>;
  lastCheckedReportsCount: Scalars['Int'];
  locale?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  questionOptionsConfigurationIds: Array<Scalars['ID']>;
  questionOptionsConfigurations: Array<QuestionOptionsConfiguration>;
  questionOptionsConfigurationsCount: Scalars['Int'];
  reminderEnabled: Scalars['Boolean'];
  reminderGap?: Maybe<Scalars['Int']>;
  reportSigningEnabled: Scalars['Boolean'];
  slug: Scalars['String'];
  templateIds: Array<Scalars['ID']>;
  templates: Array<Template>;
  templatesCount: Scalars['Int'];
  theme?: Maybe<Theme>;
  translations: Array<Translation>;
  updatedAt: Scalars['String'];
  userIds: Array<Scalars['ID']>;
  users: Array<User>;
  usersCount: Scalars['Int'];
  visualIdentity?: Maybe<Scalars['String']>;
};

export type CompanyCollection = {
  __typename?: 'CompanyCollection';
  collection: Array<Company>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of CreateQuestion */
export type CreateQuestionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  label: Scalars['String'];
  options: Scalars['JSON'];
  skillId?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
};

/** Autogenerated return type of CreateQuestion */
export type CreateQuestionPayload = {
  __typename?: 'CreateQuestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  question: Question;
};

/** Autogenerated input type of CreateReport */
export type CreateReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  reviewId: Scalars['ID'];
  type: Scalars['String'];
};

/** Autogenerated return type of CreateReport */
export type CreateReportPayload = {
  __typename?: 'CreateReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  report: Report;
};

export type Credential = {
  __typename?: 'Credential';
  accessToken: Scalars['String'];
  client: Scalars['String'];
  expiry: Scalars['Int'];
  tokenType: Scalars['String'];
  uid: Scalars['String'];
};

/** Autogenerated input type of DeleteAnswers */
export type DeleteAnswersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  collaboratorId?: Maybe<Scalars['ID']>;
  questionDigest?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Autogenerated return type of DeleteAnswers */
export type DeleteAnswersPayload = {
  __typename?: 'DeleteAnswersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated input type of DeleteAvatar */
export type DeleteAvatarInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Autogenerated return type of DeleteAvatar */
export type DeleteAvatarPayload = {
  __typename?: 'DeleteAvatarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

/** Autogenerated input type of DeleteCampaign */
export type DeleteCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteCampaign */
export type DeleteCampaignPayload = {
  __typename?: 'DeleteCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteGroup */
export type DeleteGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of DeleteGroup */
export type DeleteGroupPayload = {
  __typename?: 'DeleteGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of DeleteProfession */
export type DeleteProfessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteProfession */
export type DeleteProfessionPayload = {
  __typename?: 'DeleteProfessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteProfessionSkill */
export type DeleteProfessionSkillInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  professionId: Scalars['ID'];
  skillId: Scalars['ID'];
};

/** Autogenerated return type of DeleteProfessionSkill */
export type DeleteProfessionSkillPayload = {
  __typename?: 'DeleteProfessionSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of DeleteReport */
export type DeleteReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of DeleteReport */
export type DeleteReportPayload = {
  __typename?: 'DeleteReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteReviewDocument */
export type DeleteReviewDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteReviewDocument */
export type DeleteReviewDocumentPayload = {
  __typename?: 'DeleteReviewDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteReview */
export type DeleteReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteReview */
export type DeleteReviewPayload = {
  __typename?: 'DeleteReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteSkill */
export type DeleteSkillInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteSkill */
export type DeleteSkillPayload = {
  __typename?: 'DeleteSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteTemplate */
export type DeleteTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteTemplate */
export type DeleteTemplatePayload = {
  __typename?: 'DeleteTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteUserDocument */
export type DeleteUserDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteUserDocument */
export type DeleteUserDocumentPayload = {
  __typename?: 'DeleteUserDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type Document = {
  __typename?: 'Document';
  blobId: Scalars['Int'];
  createdAt: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['String'];
  url: Scalars['String'];
};

export type DocusignEnvelopeStatusEnum =
  /** completed */
  | 'completed'
  /** created */
  | 'created'
  /** declined */
  | 'declined'
  /** deleted */
  | 'deleted'
  /** delivered */
  | 'delivered'
  /** draft */
  | 'draft'
  /** processing */
  | 'processing'
  /** sent */
  | 'sent'
  /** signed */
  | 'signed'
  /** voided */
  | 'voided';

export type ExpectedTimeUnitEnum =
  /** Days */
  | 'days'
  /** Hours */
  | 'hours'
  /** Minutes */
  | 'minutes'
  /** Months */
  | 'months'
  /** Weeks */
  | 'weeks'
  /** Years */
  | 'years';

/** Autogenerated input type of FillReferentReport */
export type FillReferentReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of FillReferentReport */
export type FillReferentReportPayload = {
  __typename?: 'FillReferentReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  report: Report;
};

/** Autogenerated input type of FillReport */
export type FillReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of FillReport */
export type FillReportPayload = {
  __typename?: 'FillReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  report: Report;
};

export type Group = {
  __typename?: 'Group';
  canDestroy: Scalars['Boolean'];
  canInsert: Scalars['Boolean'];
  canShow: Scalars['Boolean'];
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kind: GroupKindEnum;
  name: Scalars['String'];
  updatedAt: Scalars['String'];
  userIds: Array<Scalars['ID']>;
  users: Array<User>;
  usersCount: Scalars['Int'];
};

export type GroupCollection = {
  __typename?: 'GroupCollection';
  collection: Array<Group>;
  metadata: CollectionMetadata;
};

export type GroupKindEnum =
  /** Other */
  | 'Other'
  /** Partner */
  | 'Partner'
  /** Subsidiary */
  | 'Subsidiary'
  /** Team */
  | 'Team'
  /** Training Course */
  | 'TrainingCourse';

/** Autogenerated input type of InsertAnswer */
export type InsertAnswerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  collaboratorId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  questionId: Scalars['ID'];
  reportId?: Maybe<Scalars['ID']>;
  timeSpent?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  userId: Scalars['ID'];
  value: Scalars['JSON'];
};

/** Autogenerated return type of InsertAnswer */
export type InsertAnswerPayload = {
  __typename?: 'InsertAnswerPayload';
  answer: Answer;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of InsertCampaign */
export type InsertCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  reminderEnabled?: Maybe<Scalars['Boolean']>;
  reminderGap?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of InsertCampaign */
export type InsertCampaignPayload = {
  __typename?: 'InsertCampaignPayload';
  campaign: Campaign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of InsertGroup */
export type InsertGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userIds?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of InsertGroup */
export type InsertGroupPayload = {
  __typename?: 'InsertGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  group: Group;
};

/** Autogenerated input type of InsertProfession */
export type InsertProfessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of InsertProfession */
export type InsertProfessionPayload = {
  __typename?: 'InsertProfessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  profession: Profession;
};

/** Autogenerated input type of InsertProfessionSkill */
export type InsertProfessionSkillInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  professionId?: Maybe<Scalars['ID']>;
  skillId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of InsertProfessionSkill */
export type InsertProfessionSkillPayload = {
  __typename?: 'InsertProfessionSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  professionSkill: ProfessionSkill;
};

/** Autogenerated input type of InsertReview */
export type InsertReviewInput = {
  allowTemplateUpdateByCollaborator?: Maybe<Scalars['Boolean']>;
  campaignId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  collaboratorId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  referentIds?: Maybe<Array<Scalars['ID']>>;
  reminderEnabled?: Maybe<Scalars['Boolean']>;
  reminderGap?: Maybe<Scalars['Int']>;
  reviewReferentsAttributes?: Maybe<Array<ReviewUserInput>>;
  reviewSupervisorsAttributes?: Maybe<Array<ReviewUserInput>>;
  schedule?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  supervisorIds?: Maybe<Array<Scalars['ID']>>;
  templateAttributes?: Maybe<TemplateInput>;
  title?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of InsertReview */
export type InsertReviewPayload = {
  __typename?: 'InsertReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  review: Review;
};

/** Autogenerated input type of InsertSkill */
export type InsertSkillInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of InsertSkill */
export type InsertSkillPayload = {
  __typename?: 'InsertSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  skill: Skill;
};

/** Autogenerated input type of InsertTemplate */
export type InsertTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  favorite?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  sectionsAttributes?: Maybe<Array<SectionInput>>;
  title?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of InsertTemplate */
export type InsertTemplatePayload = {
  __typename?: 'InsertTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  template: Template;
};

/** Autogenerated input type of InsertTranslation */
export type InsertTranslationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  locale: Scalars['String'];
  value: Scalars['String'];
};

/** Autogenerated return type of InsertTranslation */
export type InsertTranslationPayload = {
  __typename?: 'InsertTranslationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  translation: Translation;
};

/** Autogenerated input type of InsertUser */
export type InsertUserInput = {
  avatar?: Maybe<Scalars['String']>;
  canInsertUser?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  groupIds?: Maybe<Array<Scalars['ID']>>;
  id?: Maybe<Scalars['ID']>;
  isCapableOfCreatingStandaloneAnswers?: Maybe<Scalars['Boolean']>;
  isCapableOfCreatingStandaloneQuestions?: Maybe<Scalars['Boolean']>;
  isCapableOfDeletingAllAnswers?: Maybe<Scalars['Boolean']>;
  isCapableOfDeletingCampaigns?: Maybe<Scalars['Boolean']>;
  isCapableOfDeletingGroups?: Maybe<Scalars['Boolean']>;
  isCapableOfDeletingProfessions?: Maybe<Scalars['Boolean']>;
  isCapableOfDeletingReviews?: Maybe<Scalars['Boolean']>;
  isCapableOfDeletingSkills?: Maybe<Scalars['Boolean']>;
  isCapableOfDeletingTemplates?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingCampaigns?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingGroupMembers?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingGroups?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingProfessionSkills?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingProfessions?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingReviews?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingSkills?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingTemplates?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingTranslations?: Maybe<Scalars['Boolean']>;
  isCapableOfInsertingUsers?: Maybe<Scalars['Boolean']>;
  isCapableOfManagingReports?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingActivities?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingActivitiesIps?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingAllReviews?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingCampaigns?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingGroups?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingQuestions?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingReviews?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingSkills?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingStandaloneAnswers?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingStandaloneQuestions?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingTemplates?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingUserDocuments?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingUserNotes?: Maybe<Scalars['Boolean']>;
  isCapableOfReadingUsers?: Maybe<Scalars['Boolean']>;
  isCapableOfSigningReports?: Maybe<Scalars['Boolean']>;
  isCapableOfUpdatingCompanies?: Maybe<Scalars['Boolean']>;
  isCapableOfUpdatingUserCapabilities?: Maybe<Scalars['Boolean']>;
  isCapableOfUpdatingUserNotes?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of InsertUser */
export type InsertUserPayload = {
  __typename?: 'InsertUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

export type Mutation = {
  __typename?: 'Mutation';
  addReviewDocument?: Maybe<AddReviewDocumentPayload>;
  addUserDocument?: Maybe<AddUserDocumentPayload>;
  createQuestion?: Maybe<CreateQuestionPayload>;
  createReport?: Maybe<CreateReportPayload>;
  deleteAnswers?: Maybe<DeleteAnswersPayload>;
  deleteAvatar?: Maybe<DeleteAvatarPayload>;
  deleteCampaign?: Maybe<DeleteCampaignPayload>;
  deleteCredential?: Maybe<Scalars['String']>;
  deleteGroup?: Maybe<DeleteGroupPayload>;
  deleteProfession?: Maybe<DeleteProfessionPayload>;
  deleteProfessionSkill?: Maybe<DeleteProfessionSkillPayload>;
  deleteReport?: Maybe<DeleteReportPayload>;
  deleteReview?: Maybe<DeleteReviewPayload>;
  /** Delete document from review */
  deleteReviewDocument?: Maybe<DeleteReviewDocumentPayload>;
  deleteSkill?: Maybe<DeleteSkillPayload>;
  deleteTemplate?: Maybe<DeleteTemplatePayload>;
  /** Delete document from user */
  deleteUserDocument?: Maybe<DeleteUserDocumentPayload>;
  fillReferentReport?: Maybe<FillReferentReportPayload>;
  fillReport?: Maybe<FillReportPayload>;
  insertAnswer?: Maybe<InsertAnswerPayload>;
  insertCampaign?: Maybe<InsertCampaignPayload>;
  insertGroup?: Maybe<InsertGroupPayload>;
  insertProfession?: Maybe<InsertProfessionPayload>;
  insertProfessionSkill?: Maybe<InsertProfessionSkillPayload>;
  insertReview?: Maybe<InsertReviewPayload>;
  insertSkill?: Maybe<InsertSkillPayload>;
  insertTemplate?: Maybe<InsertTemplatePayload>;
  insertTranslation?: Maybe<InsertTranslationPayload>;
  insertUser?: Maybe<InsertUserPayload>;
  sendConnectionLink?: Maybe<SendConnectionLinkPayload>;
  setCredential?: Maybe<Scalars['String']>;
  signReport?: Maybe<SignReportPayload>;
  /** Update company */
  updateCompany?: Maybe<UpdateCompanyPayload>;
  updateReport?: Maybe<UpdateReportPayload>;
  /** Update viewer */
  updateViewer?: Maybe<UpdateViewerPayload>;
  userLogin?: Maybe<UserLoginPayload>;
  userLogout?: Maybe<UserLogoutPayload>;
  userResendConfirmation?: Maybe<UserResendConfirmationPayload>;
  userSendPasswordReset?: Maybe<UserSendPasswordResetPayload>;
  userSignUp?: Maybe<UserSignUpPayload>;
  userUpdatePassword?: Maybe<UserUpdatePasswordPayload>;
};


export type MutationAddReviewDocumentArgs = {
  input: AddReviewDocumentInput;
};


export type MutationAddUserDocumentArgs = {
  input: AddUserDocumentInput;
};


export type MutationCreateQuestionArgs = {
  input: CreateQuestionInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationDeleteAnswersArgs = {
  input: DeleteAnswersInput;
};


export type MutationDeleteAvatarArgs = {
  input: DeleteAvatarInput;
};


export type MutationDeleteCampaignArgs = {
  input: DeleteCampaignInput;
};


export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


export type MutationDeleteProfessionArgs = {
  input: DeleteProfessionInput;
};


export type MutationDeleteProfessionSkillArgs = {
  input: DeleteProfessionSkillInput;
};


export type MutationDeleteReportArgs = {
  input: DeleteReportInput;
};


export type MutationDeleteReviewArgs = {
  input: DeleteReviewInput;
};


export type MutationDeleteReviewDocumentArgs = {
  input: DeleteReviewDocumentInput;
};


export type MutationDeleteSkillArgs = {
  input: DeleteSkillInput;
};


export type MutationDeleteTemplateArgs = {
  input: DeleteTemplateInput;
};


export type MutationDeleteUserDocumentArgs = {
  input: DeleteUserDocumentInput;
};


export type MutationFillReferentReportArgs = {
  input: FillReferentReportInput;
};


export type MutationFillReportArgs = {
  input: FillReportInput;
};


export type MutationInsertAnswerArgs = {
  input: InsertAnswerInput;
};


export type MutationInsertCampaignArgs = {
  input: InsertCampaignInput;
};


export type MutationInsertGroupArgs = {
  input: InsertGroupInput;
};


export type MutationInsertProfessionArgs = {
  input: InsertProfessionInput;
};


export type MutationInsertProfessionSkillArgs = {
  input: InsertProfessionSkillInput;
};


export type MutationInsertReviewArgs = {
  input: InsertReviewInput;
};


export type MutationInsertSkillArgs = {
  input: InsertSkillInput;
};


export type MutationInsertTemplateArgs = {
  input: InsertTemplateInput;
};


export type MutationInsertTranslationArgs = {
  input: InsertTranslationInput;
};


export type MutationInsertUserArgs = {
  input: InsertUserInput;
};


export type MutationSendConnectionLinkArgs = {
  input: SendConnectionLinkInput;
};


export type MutationSetCredentialArgs = {
  accessToken: Scalars['String'];
  client: Scalars['String'];
  expiry: Scalars['Int'];
  tokenType: Scalars['String'];
  uid?: Maybe<Scalars['String']>;
};


export type MutationSignReportArgs = {
  input: SignReportInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};


export type MutationUpdateViewerArgs = {
  input: UpdateViewerInput;
};


export type MutationUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUserResendConfirmationArgs = {
  email: Scalars['String'];
  redirectUrl: Scalars['String'];
};


export type MutationUserSendPasswordResetArgs = {
  email: Scalars['String'];
  redirectUrl: Scalars['String'];
};


export type MutationUserSignUpArgs = {
  confirmSuccessUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUserUpdatePasswordArgs = {
  currentPassword?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type Notification = {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Scalars['String'];
  title: Scalars['String'];
};

export type Profession = {
  __typename?: 'Profession';
  canDestroy: Scalars['Boolean'];
  canInsert: Scalars['Boolean'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  locale: Scalars['String'];
  name: Scalars['String'];
  skillIds: Array<Scalars['ID']>;
  skills: Array<Skill>;
  skillsCount: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type ProfessionCollection = {
  __typename?: 'ProfessionCollection';
  collection: Array<Profession>;
  metadata: CollectionMetadata;
};

export type ProfessionSkill = {
  __typename?: 'ProfessionSkill';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  profession: Profession;
  professionId: Scalars['ID'];
  skill: Skill;
  skillId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type PublicUser = {
  __typename?: 'PublicUser';
  email: Scalars['String'];
  samlRedirectUrl?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  activities: ActivityCollection;
  activity: Activity;
  answer: Answer;
  answers: AnswerCollection;
  campaign: Campaign;
  campaigns: CampaignCollection;
  companies: CompanyCollection;
  company: Company;
  credential?: Maybe<Credential>;
  group: Group;
  groups: GroupCollection;
  profession: Profession;
  professions: ProfessionCollection;
  publicUser?: Maybe<PublicUser>;
  question: Question;
  questions: QuestionCollection;
  report: Report;
  reports: ReportCollection;
  review: Review;
  reviews: ReviewCollection;
  skill: Skill;
  skills: SkillCollection;
  template: Template;
  templates: TemplateCollection;
  user: User;
  userCheckPasswordToken: User;
  userConfirmAccount: User;
  users: UserCollection;
  viewer: Viewer;
};


export type QueryActivitiesArgs = {
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  key?: Maybe<Array<Scalars['String']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notKey?: Maybe<Array<Scalars['String']>>;
  notOwnerIds?: Maybe<Array<Scalars['ID']>>;
  notOwnerType?: Maybe<Array<Scalars['String']>>;
  notRecipientIds?: Maybe<Array<Scalars['ID']>>;
  notRecipientType?: Maybe<Array<Scalars['String']>>;
  notTrackableIds?: Maybe<Array<Scalars['ID']>>;
  notTrackableType?: Maybe<Array<Scalars['String']>>;
  ownerId?: Maybe<Scalars['ID']>;
  ownerIds?: Maybe<Array<Scalars['ID']>>;
  ownerIdsStrict?: Maybe<Array<Scalars['ID']>>;
  ownerType?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  recipientId?: Maybe<Scalars['ID']>;
  recipientIds?: Maybe<Array<Scalars['ID']>>;
  recipientIdsStrict?: Maybe<Array<Scalars['ID']>>;
  recipientType?: Maybe<Array<Scalars['String']>>;
  sortBy?: Maybe<Scalars['String']>;
  trackableId?: Maybe<Scalars['ID']>;
  trackableIds?: Maybe<Array<Scalars['ID']>>;
  trackableIdsStrict?: Maybe<Array<Scalars['ID']>>;
  trackableType?: Maybe<Array<Scalars['String']>>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
};


export type QueryActivityArgs = {
  id: Scalars['ID'];
};


export type QueryAnswerArgs = {
  id: Scalars['ID'];
};


export type QueryAnswersArgs = {
  areIsDraft?: Maybe<Scalars['Boolean']>;
  areIsLast?: Maybe<Scalars['Boolean']>;
  areNotIsDraft?: Maybe<Scalars['Boolean']>;
  areNotIsLast?: Maybe<Scalars['Boolean']>;
  collaboratorId?: Maybe<Scalars['ID']>;
  collaboratorIds?: Maybe<Array<Scalars['ID']>>;
  collaboratorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  companyId?: Maybe<Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']>>;
  companyIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupIds?: Maybe<Array<Scalars['ID']>>;
  groupIdsStrict?: Maybe<Array<Scalars['ID']>>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  isCheckedReport?: Maybe<Scalars['Boolean']>;
  isCollaborator?: Maybe<Scalars['Boolean']>;
  lastCreatedAt?: Maybe<Scalars['String']>;
  normalizedRatingEqual?: Maybe<Scalars['Float']>;
  normalizedRatingGreaterThan?: Maybe<Scalars['Float']>;
  normalizedRatingGreaterThanOrEqualTo?: Maybe<Scalars['Float']>;
  normalizedRatingLessThan?: Maybe<Scalars['Float']>;
  normalizedRatingLessThanOrEqualTo?: Maybe<Scalars['Float']>;
  notCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  notCompanyIds?: Maybe<Array<Scalars['ID']>>;
  notGroupIds?: Maybe<Array<Scalars['ID']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notQuestionDigest?: Maybe<Array<Scalars['String']>>;
  notQuestionIds?: Maybe<Array<Scalars['ID']>>;
  notReportIds?: Maybe<Array<Scalars['ID']>>;
  notReviewIds?: Maybe<Array<Scalars['ID']>>;
  notSkillIds?: Maybe<Array<Scalars['ID']>>;
  notType?: Maybe<Array<Scalars['String']>>;
  notUserIds?: Maybe<Array<Scalars['ID']>>;
  notVisibility?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  questionDigest?: Maybe<Array<Scalars['String']>>;
  questionId?: Maybe<Scalars['ID']>;
  questionIds?: Maybe<Array<Scalars['ID']>>;
  questionIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reportId?: Maybe<Scalars['ID']>;
  reportIds?: Maybe<Array<Scalars['ID']>>;
  reportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewId?: Maybe<Scalars['ID']>;
  reviewIds?: Maybe<Array<Scalars['ID']>>;
  reviewIdsStrict?: Maybe<Array<Scalars['ID']>>;
  skillId?: Maybe<Scalars['ID']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
  skillIdsStrict?: Maybe<Array<Scalars['ID']>>;
  skillQ?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
  timeSpentEqual?: Maybe<Scalars['Int']>;
  timeSpentGreaterThan?: Maybe<Scalars['Int']>;
  timeSpentGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  timeSpentLessThan?: Maybe<Scalars['Int']>;
  timeSpentLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  type?: Maybe<Array<Scalars['String']>>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userIds?: Maybe<Array<Scalars['ID']>>;
  userIdsStrict?: Maybe<Array<Scalars['ID']>>;
  visibility?: Maybe<Array<Scalars['String']>>;
};


export type QueryCampaignArgs = {
  id: Scalars['ID'];
};


export type QueryCampaignsArgs = {
  activityId?: Maybe<Scalars['ID']>;
  activityIds?: Maybe<Array<Scalars['ID']>>;
  activityIdsStrict?: Maybe<Array<Scalars['ID']>>;
  areNotReminderEnabled?: Maybe<Scalars['Boolean']>;
  areReminderEnabled?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']>>;
  companyIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  lastCheckedReportId?: Maybe<Scalars['ID']>;
  lastCheckedReportIds?: Maybe<Array<Scalars['ID']>>;
  lastCheckedReportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  name?: Maybe<Array<Scalars['String']>>;
  notActivityIds?: Maybe<Array<Scalars['ID']>>;
  notCompanyIds?: Maybe<Array<Scalars['ID']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notLastCheckedReportIds?: Maybe<Array<Scalars['ID']>>;
  notName?: Maybe<Array<Scalars['String']>>;
  notReportIds?: Maybe<Array<Scalars['ID']>>;
  notReviewIds?: Maybe<Array<Scalars['ID']>>;
  notSlug?: Maybe<Array<Scalars['String']>>;
  notSlugIds?: Maybe<Array<Scalars['ID']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  reminderGapEqual?: Maybe<Scalars['Int']>;
  reminderGapGreaterThan?: Maybe<Scalars['Int']>;
  reminderGapGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  reminderGapLessThan?: Maybe<Scalars['Int']>;
  reminderGapLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  reportId?: Maybe<Scalars['ID']>;
  reportIds?: Maybe<Array<Scalars['ID']>>;
  reportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewId?: Maybe<Scalars['ID']>;
  reviewIds?: Maybe<Array<Scalars['ID']>>;
  reviewIdsStrict?: Maybe<Array<Scalars['ID']>>;
  slug?: Maybe<Array<Scalars['String']>>;
  slugId?: Maybe<Scalars['ID']>;
  slugIds?: Maybe<Array<Scalars['ID']>>;
  slugIdsStrict?: Maybe<Array<Scalars['ID']>>;
  sortBy?: Maybe<Scalars['String']>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
};


export type QueryCompaniesArgs = {
  activityId?: Maybe<Scalars['ID']>;
  activityIds?: Maybe<Array<Scalars['ID']>>;
  activityIdsStrict?: Maybe<Array<Scalars['ID']>>;
  areCustomTranslationsEnabled?: Maybe<Scalars['Boolean']>;
  areInlineTemplateUpdateEnabled?: Maybe<Scalars['Boolean']>;
  areNotCustomTranslationsEnabled?: Maybe<Scalars['Boolean']>;
  areNotInlineTemplateUpdateEnabled?: Maybe<Scalars['Boolean']>;
  areNotReminderEnabled?: Maybe<Scalars['Boolean']>;
  areNotReportSigningEnabled?: Maybe<Scalars['Boolean']>;
  areReminderEnabled?: Maybe<Scalars['Boolean']>;
  areReportSigningEnabled?: Maybe<Scalars['Boolean']>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignIds?: Maybe<Array<Scalars['ID']>>;
  campaignIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupIds?: Maybe<Array<Scalars['ID']>>;
  groupIdsStrict?: Maybe<Array<Scalars['ID']>>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  lastCheckedReportId?: Maybe<Scalars['ID']>;
  lastCheckedReportIds?: Maybe<Array<Scalars['ID']>>;
  lastCheckedReportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  locale?: Maybe<Array<Scalars['String']>>;
  logo?: Maybe<Array<Scalars['String']>>;
  mailerFrom?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  notActivityIds?: Maybe<Array<Scalars['ID']>>;
  notCampaignIds?: Maybe<Array<Scalars['ID']>>;
  notGroupIds?: Maybe<Array<Scalars['ID']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notLastCheckedReportIds?: Maybe<Array<Scalars['ID']>>;
  notLocale?: Maybe<Array<Scalars['String']>>;
  notLogo?: Maybe<Array<Scalars['String']>>;
  notMailerFrom?: Maybe<Array<Scalars['String']>>;
  notName?: Maybe<Array<Scalars['String']>>;
  notProfessionIds?: Maybe<Array<Scalars['ID']>>;
  notQuestionOptionsConfigurationIds?: Maybe<Array<Scalars['ID']>>;
  notReviewIds?: Maybe<Array<Scalars['ID']>>;
  notSftpHost?: Maybe<Array<Scalars['String']>>;
  notSftpPath?: Maybe<Array<Scalars['String']>>;
  notSftpUser?: Maybe<Array<Scalars['String']>>;
  notSkillIds?: Maybe<Array<Scalars['ID']>>;
  notSlug?: Maybe<Array<Scalars['String']>>;
  notSlugIds?: Maybe<Array<Scalars['ID']>>;
  notTemplateIds?: Maybe<Array<Scalars['ID']>>;
  notUserIds?: Maybe<Array<Scalars['ID']>>;
  notVisualIdentityAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  notVisualIdentityBlobIds?: Maybe<Array<Scalars['ID']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  professionId?: Maybe<Scalars['ID']>;
  professionIds?: Maybe<Array<Scalars['ID']>>;
  professionIdsStrict?: Maybe<Array<Scalars['ID']>>;
  questionOptionsConfigurationId?: Maybe<Scalars['ID']>;
  questionOptionsConfigurationIds?: Maybe<Array<Scalars['ID']>>;
  questionOptionsConfigurationIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reminderGapEqual?: Maybe<Scalars['Int']>;
  reminderGapGreaterThan?: Maybe<Scalars['Int']>;
  reminderGapGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  reminderGapLessThan?: Maybe<Scalars['Int']>;
  reminderGapLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['ID']>;
  reviewIds?: Maybe<Array<Scalars['ID']>>;
  reviewIdsStrict?: Maybe<Array<Scalars['ID']>>;
  sftpHost?: Maybe<Array<Scalars['String']>>;
  sftpPath?: Maybe<Array<Scalars['String']>>;
  sftpUser?: Maybe<Array<Scalars['String']>>;
  skillId?: Maybe<Scalars['ID']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
  skillIdsStrict?: Maybe<Array<Scalars['ID']>>;
  slug?: Maybe<Array<Scalars['String']>>;
  slugId?: Maybe<Scalars['ID']>;
  slugIds?: Maybe<Array<Scalars['ID']>>;
  slugIdsStrict?: Maybe<Array<Scalars['ID']>>;
  templateId?: Maybe<Scalars['ID']>;
  templateIds?: Maybe<Array<Scalars['ID']>>;
  templateIdsStrict?: Maybe<Array<Scalars['ID']>>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userIds?: Maybe<Array<Scalars['ID']>>;
  userIdsStrict?: Maybe<Array<Scalars['ID']>>;
  visualIdentityAttachmentId?: Maybe<Scalars['ID']>;
  visualIdentityAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  visualIdentityAttachmentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  visualIdentityBlobId?: Maybe<Scalars['ID']>;
  visualIdentityBlobIds?: Maybe<Array<Scalars['ID']>>;
  visualIdentityBlobIdsStrict?: Maybe<Array<Scalars['ID']>>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryGroupArgs = {
  id: Scalars['ID'];
};


export type QueryGroupsArgs = {
  activityId?: Maybe<Scalars['ID']>;
  activityIds?: Maybe<Array<Scalars['ID']>>;
  activityIdsStrict?: Maybe<Array<Scalars['ID']>>;
  companyId?: Maybe<Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']>>;
  companyIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  description?: Maybe<Array<Scalars['String']>>;
  direction?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  kind?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  notActivityIds?: Maybe<Array<Scalars['ID']>>;
  notCompanyIds?: Maybe<Array<Scalars['ID']>>;
  notDescription?: Maybe<Array<Scalars['String']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notKind?: Maybe<Array<Scalars['String']>>;
  notName?: Maybe<Array<Scalars['String']>>;
  notUserIds?: Maybe<Array<Scalars['ID']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userIds?: Maybe<Array<Scalars['ID']>>;
  userIdsStrict?: Maybe<Array<Scalars['ID']>>;
};


export type QueryProfessionArgs = {
  id: Scalars['ID'];
};


export type QueryProfessionsArgs = {
  companyId?: Maybe<Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']>>;
  companyIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Array<Scalars['String']>>;
  notCompanyIds?: Maybe<Array<Scalars['ID']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notLocale?: Maybe<Array<Scalars['String']>>;
  notName?: Maybe<Array<Scalars['String']>>;
  notProfessionSkillIds?: Maybe<Array<Scalars['ID']>>;
  notSkillIds?: Maybe<Array<Scalars['ID']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  professionSkillId?: Maybe<Scalars['ID']>;
  professionSkillIds?: Maybe<Array<Scalars['ID']>>;
  professionSkillIdsStrict?: Maybe<Array<Scalars['ID']>>;
  q?: Maybe<Scalars['String']>;
  referenceEqual?: Maybe<Scalars['Int']>;
  referenceGreaterThan?: Maybe<Scalars['Int']>;
  referenceGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  referenceLessThan?: Maybe<Scalars['Int']>;
  referenceLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  skillId?: Maybe<Scalars['ID']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
  skillIdsStrict?: Maybe<Array<Scalars['ID']>>;
  sortBy?: Maybe<Scalars['String']>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
};


export type QueryPublicUserArgs = {
  email: Scalars['String'];
};


export type QueryQuestionArgs = {
  id: Scalars['ID'];
};


export type QueryQuestionsArgs = {
  answerId?: Maybe<Scalars['ID']>;
  answerIds?: Maybe<Array<Scalars['ID']>>;
  answerIdsStrict?: Maybe<Array<Scalars['ID']>>;
  areNotRequired?: Maybe<Scalars['Boolean']>;
  areNotTimeTracked?: Maybe<Scalars['Boolean']>;
  areRequired?: Maybe<Scalars['Boolean']>;
  areTimeTracked?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']>>;
  companyIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  digest?: Maybe<Array<Scalars['String']>>;
  direction?: Maybe<Scalars['String']>;
  distinctByDigest?: Maybe<Scalars['Boolean']>;
  documentsAttachmentId?: Maybe<Scalars['ID']>;
  documentsAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  documentsAttachmentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  documentsBlobId?: Maybe<Scalars['ID']>;
  documentsBlobIds?: Maybe<Array<Scalars['ID']>>;
  documentsBlobIdsStrict?: Maybe<Array<Scalars['ID']>>;
  expectedTimeUnit?: Maybe<Array<Scalars['String']>>;
  expectedTimeValueEqual?: Maybe<Scalars['Int']>;
  expectedTimeValueGreaterThan?: Maybe<Scalars['Int']>;
  expectedTimeValueGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  expectedTimeValueLessThan?: Maybe<Scalars['Int']>;
  expectedTimeValueLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  havingAnswers?: Maybe<Scalars['Boolean']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  label?: Maybe<Array<Scalars['String']>>;
  notAnswerIds?: Maybe<Array<Scalars['ID']>>;
  notCompanyIds?: Maybe<Array<Scalars['ID']>>;
  notDigest?: Maybe<Array<Scalars['String']>>;
  notDocumentsAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  notDocumentsBlobIds?: Maybe<Array<Scalars['ID']>>;
  notExpectedTimeUnit?: Maybe<Array<Scalars['String']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notLabel?: Maybe<Array<Scalars['String']>>;
  notReportTypes?: Maybe<Array<Scalars['String']>>;
  notReviewIds?: Maybe<Array<Scalars['ID']>>;
  notSectionIds?: Maybe<Array<Scalars['ID']>>;
  notSkillIds?: Maybe<Array<Scalars['ID']>>;
  notTemplateIds?: Maybe<Array<Scalars['ID']>>;
  notType?: Maybe<Array<Scalars['String']>>;
  notVisibility?: Maybe<Array<Scalars['String']>>;
  orderEqual?: Maybe<Scalars['Int']>;
  orderGreaterThan?: Maybe<Scalars['Int']>;
  orderGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  orderLessThan?: Maybe<Scalars['Int']>;
  orderLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  reportTypes?: Maybe<Array<Scalars['String']>>;
  reviewId?: Maybe<Scalars['ID']>;
  reviewIds?: Maybe<Array<Scalars['ID']>>;
  reviewIdsStrict?: Maybe<Array<Scalars['ID']>>;
  sectionId?: Maybe<Scalars['ID']>;
  sectionIds?: Maybe<Array<Scalars['ID']>>;
  sectionIdsStrict?: Maybe<Array<Scalars['ID']>>;
  skillId?: Maybe<Scalars['ID']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
  skillIdsStrict?: Maybe<Array<Scalars['ID']>>;
  templateId?: Maybe<Scalars['ID']>;
  templateIds?: Maybe<Array<Scalars['ID']>>;
  templateIdsStrict?: Maybe<Array<Scalars['ID']>>;
  type?: Maybe<Array<Scalars['String']>>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
  visibility?: Maybe<Array<Scalars['String']>>;
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QueryReportsArgs = {
  activityId?: Maybe<Scalars['ID']>;
  activityIds?: Maybe<Array<Scalars['ID']>>;
  activityIdsStrict?: Maybe<Array<Scalars['ID']>>;
  answerId?: Maybe<Scalars['ID']>;
  answerIds?: Maybe<Array<Scalars['ID']>>;
  answerIdsStrict?: Maybe<Array<Scalars['ID']>>;
  answersSelectorMultipleId?: Maybe<Scalars['ID']>;
  answersSelectorMultipleIds?: Maybe<Array<Scalars['ID']>>;
  answersSelectorMultipleIdsStrict?: Maybe<Array<Scalars['ID']>>;
  answersSelectorSingleId?: Maybe<Scalars['ID']>;
  answersSelectorSingleIds?: Maybe<Array<Scalars['ID']>>;
  answersSelectorSingleIdsStrict?: Maybe<Array<Scalars['ID']>>;
  answersTextId?: Maybe<Scalars['ID']>;
  answersTextIds?: Maybe<Array<Scalars['ID']>>;
  answersTextIdsStrict?: Maybe<Array<Scalars['ID']>>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignIds?: Maybe<Array<Scalars['ID']>>;
  campaignIdsStrict?: Maybe<Array<Scalars['ID']>>;
  checkedAfter?: Maybe<Scalars['String']>;
  checkedAfterIncluding?: Maybe<Scalars['String']>;
  checkedBefore?: Maybe<Scalars['String']>;
  checkedBeforeIncluding?: Maybe<Scalars['String']>;
  collaboratorId?: Maybe<Scalars['ID']>;
  collaboratorIds?: Maybe<Array<Scalars['ID']>>;
  collaboratorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  documentAttachmentId?: Maybe<Scalars['ID']>;
  documentAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  documentAttachmentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  documentBlobId?: Maybe<Scalars['ID']>;
  documentBlobIds?: Maybe<Array<Scalars['ID']>>;
  documentBlobIdsStrict?: Maybe<Array<Scalars['ID']>>;
  docusignEnvelopeReference?: Maybe<Array<Scalars['String']>>;
  docusignEnvelopeStatus?: Maybe<Array<Scalars['String']>>;
  filledAfter?: Maybe<Scalars['String']>;
  filledAfterIncluding?: Maybe<Scalars['String']>;
  filledBefore?: Maybe<Scalars['String']>;
  filledBeforeIncluding?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  lastCheckedAt?: Maybe<Scalars['String']>;
  notActivityIds?: Maybe<Array<Scalars['ID']>>;
  notAnswerIds?: Maybe<Array<Scalars['ID']>>;
  notAnswersSelectorMultipleIds?: Maybe<Array<Scalars['ID']>>;
  notAnswersSelectorSingleIds?: Maybe<Array<Scalars['ID']>>;
  notAnswersTextIds?: Maybe<Array<Scalars['ID']>>;
  notCampaignIds?: Maybe<Array<Scalars['ID']>>;
  notCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  notDocumentAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  notDocumentBlobIds?: Maybe<Array<Scalars['ID']>>;
  notDocusignEnvelopeReference?: Maybe<Array<Scalars['String']>>;
  notDocusignEnvelopeStatus?: Maybe<Array<Scalars['String']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notReferentIds?: Maybe<Array<Scalars['ID']>>;
  notReportReferentIds?: Maybe<Array<Scalars['ID']>>;
  notReportSignatoryIds?: Maybe<Array<Scalars['ID']>>;
  notReviewIds?: Maybe<Array<Scalars['ID']>>;
  notSignatoryIds?: Maybe<Array<Scalars['ID']>>;
  notTemplateIds?: Maybe<Array<Scalars['ID']>>;
  notType?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  referentId?: Maybe<Scalars['ID']>;
  referentIds?: Maybe<Array<Scalars['ID']>>;
  referentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reportReferentId?: Maybe<Scalars['ID']>;
  reportReferentIds?: Maybe<Array<Scalars['ID']>>;
  reportReferentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reportSignatoryId?: Maybe<Scalars['ID']>;
  reportSignatoryIds?: Maybe<Array<Scalars['ID']>>;
  reportSignatoryIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewId?: Maybe<Scalars['ID']>;
  reviewIds?: Maybe<Array<Scalars['ID']>>;
  reviewIdsStrict?: Maybe<Array<Scalars['ID']>>;
  signatoryId?: Maybe<Scalars['ID']>;
  signatoryIds?: Maybe<Array<Scalars['ID']>>;
  signatoryIdsStrict?: Maybe<Array<Scalars['ID']>>;
  templateId?: Maybe<Scalars['ID']>;
  templateIds?: Maybe<Array<Scalars['ID']>>;
  templateIdsStrict?: Maybe<Array<Scalars['ID']>>;
  type?: Maybe<Array<Scalars['String']>>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
};


export type QueryReviewArgs = {
  id: Scalars['ID'];
};


export type QueryReviewsArgs = {
  activityId?: Maybe<Scalars['ID']>;
  activityIds?: Maybe<Array<Scalars['ID']>>;
  activityIdsStrict?: Maybe<Array<Scalars['ID']>>;
  answerId?: Maybe<Scalars['ID']>;
  answerIds?: Maybe<Array<Scalars['ID']>>;
  answerIdsStrict?: Maybe<Array<Scalars['ID']>>;
  areAllowTemplateUpdateByCollaborator?: Maybe<Scalars['Boolean']>;
  areNotAllowTemplateUpdateByCollaborator?: Maybe<Scalars['Boolean']>;
  areNotReminderEnabled?: Maybe<Scalars['Boolean']>;
  areReminderEnabled?: Maybe<Scalars['Boolean']>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignIds?: Maybe<Array<Scalars['ID']>>;
  campaignIdsStrict?: Maybe<Array<Scalars['ID']>>;
  collaboratorId?: Maybe<Scalars['ID']>;
  collaboratorIds?: Maybe<Array<Scalars['ID']>>;
  collaboratorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  documentsAttachmentId?: Maybe<Scalars['ID']>;
  documentsAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  documentsAttachmentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  documentsBlobId?: Maybe<Scalars['ID']>;
  documentsBlobIds?: Maybe<Array<Scalars['ID']>>;
  documentsBlobIdsStrict?: Maybe<Array<Scalars['ID']>>;
  endAfter?: Maybe<Scalars['String']>;
  endAfterIncluding?: Maybe<Scalars['String']>;
  endBefore?: Maybe<Scalars['String']>;
  endBeforeIncluding?: Maybe<Scalars['String']>;
  finalReportId?: Maybe<Scalars['ID']>;
  finalReportIds?: Maybe<Array<Scalars['ID']>>;
  finalReportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  firstReportId?: Maybe<Scalars['ID']>;
  firstReportIds?: Maybe<Array<Scalars['ID']>>;
  firstReportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  intermediateReportId?: Maybe<Scalars['ID']>;
  intermediateReportIds?: Maybe<Array<Scalars['ID']>>;
  intermediateReportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  lastCheckedReportId?: Maybe<Scalars['ID']>;
  lastCheckedReportIds?: Maybe<Array<Scalars['ID']>>;
  lastCheckedReportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  lastReportId?: Maybe<Scalars['ID']>;
  lastReportIds?: Maybe<Array<Scalars['ID']>>;
  lastReportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  notActivityIds?: Maybe<Array<Scalars['ID']>>;
  notAnswerIds?: Maybe<Array<Scalars['ID']>>;
  notCampaignIds?: Maybe<Array<Scalars['ID']>>;
  notCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  notDocumentsAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  notDocumentsBlobIds?: Maybe<Array<Scalars['ID']>>;
  notFinalReportIds?: Maybe<Array<Scalars['ID']>>;
  notFirstReportIds?: Maybe<Array<Scalars['ID']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notIntermediateReportIds?: Maybe<Array<Scalars['ID']>>;
  notLastCheckedReportIds?: Maybe<Array<Scalars['ID']>>;
  notLastReportIds?: Maybe<Array<Scalars['ID']>>;
  notOriginalTemplateIds?: Maybe<Array<Scalars['ID']>>;
  notReferentIds?: Maybe<Array<Scalars['ID']>>;
  notReportIds?: Maybe<Array<Scalars['ID']>>;
  notReviewReferentIds?: Maybe<Array<Scalars['ID']>>;
  notReviewSupervisorIds?: Maybe<Array<Scalars['ID']>>;
  notReviewUserIds?: Maybe<Array<Scalars['ID']>>;
  notSchedule?: Maybe<Array<Scalars['String']>>;
  notSupervisorIds?: Maybe<Array<Scalars['ID']>>;
  notTemplateIds?: Maybe<Array<Scalars['ID']>>;
  notUserIds?: Maybe<Array<Scalars['ID']>>;
  originalTemplateId?: Maybe<Scalars['ID']>;
  originalTemplateIds?: Maybe<Array<Scalars['ID']>>;
  originalTemplateIdsStrict?: Maybe<Array<Scalars['ID']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  referentId?: Maybe<Scalars['ID']>;
  referentIds?: Maybe<Array<Scalars['ID']>>;
  referentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reminderGapEqual?: Maybe<Scalars['Int']>;
  reminderGapGreaterThan?: Maybe<Scalars['Int']>;
  reminderGapGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  reminderGapLessThan?: Maybe<Scalars['Int']>;
  reminderGapLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  reportId?: Maybe<Scalars['ID']>;
  reportIds?: Maybe<Array<Scalars['ID']>>;
  reportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewReferentId?: Maybe<Scalars['ID']>;
  reviewReferentIds?: Maybe<Array<Scalars['ID']>>;
  reviewReferentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewSupervisorId?: Maybe<Scalars['ID']>;
  reviewSupervisorIds?: Maybe<Array<Scalars['ID']>>;
  reviewSupervisorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewUserId?: Maybe<Scalars['ID']>;
  reviewUserIds?: Maybe<Array<Scalars['ID']>>;
  reviewUserIdsStrict?: Maybe<Array<Scalars['ID']>>;
  schedule?: Maybe<Array<Scalars['String']>>;
  sortBy?: Maybe<Scalars['String']>;
  startAfter?: Maybe<Scalars['String']>;
  startAfterIncluding?: Maybe<Scalars['String']>;
  startBefore?: Maybe<Scalars['String']>;
  startBeforeIncluding?: Maybe<Scalars['String']>;
  supervisorId?: Maybe<Scalars['ID']>;
  supervisorIds?: Maybe<Array<Scalars['ID']>>;
  supervisorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  templateId?: Maybe<Scalars['ID']>;
  templateIds?: Maybe<Array<Scalars['ID']>>;
  templateIdsStrict?: Maybe<Array<Scalars['ID']>>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userIds?: Maybe<Array<Scalars['ID']>>;
  userIdsStrict?: Maybe<Array<Scalars['ID']>>;
};


export type QuerySkillArgs = {
  id: Scalars['ID'];
};


export type QuerySkillsArgs = {
  answerId?: Maybe<Scalars['ID']>;
  answerIds?: Maybe<Array<Scalars['ID']>>;
  answerIdsStrict?: Maybe<Array<Scalars['ID']>>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignIds?: Maybe<Array<Scalars['ID']>>;
  campaignIdsStrict?: Maybe<Array<Scalars['ID']>>;
  collaboratorId?: Maybe<Scalars['ID']>;
  collaboratorIds?: Maybe<Array<Scalars['ID']>>;
  collaboratorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  companyId?: Maybe<Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']>>;
  companyIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  havingAnswers?: Maybe<Scalars['Boolean']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  kind?: Maybe<Array<Scalars['String']>>;
  lastAnswerId?: Maybe<Scalars['ID']>;
  lastAnswerIds?: Maybe<Array<Scalars['ID']>>;
  lastAnswerIdsStrict?: Maybe<Array<Scalars['ID']>>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Array<Scalars['String']>>;
  notAnswerIds?: Maybe<Array<Scalars['ID']>>;
  notCampaignIds?: Maybe<Array<Scalars['ID']>>;
  notCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  notCompanyIds?: Maybe<Array<Scalars['ID']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notKind?: Maybe<Array<Scalars['String']>>;
  notLastAnswerIds?: Maybe<Array<Scalars['ID']>>;
  notLocale?: Maybe<Array<Scalars['String']>>;
  notName?: Maybe<Array<Scalars['String']>>;
  notProfessionIds?: Maybe<Array<Scalars['ID']>>;
  notProfessionSkillIds?: Maybe<Array<Scalars['ID']>>;
  notQuestionIds?: Maybe<Array<Scalars['ID']>>;
  notReportIds?: Maybe<Array<Scalars['ID']>>;
  notReviewIds?: Maybe<Array<Scalars['ID']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  professionId?: Maybe<Scalars['ID']>;
  professionIds?: Maybe<Array<Scalars['ID']>>;
  professionIdsStrict?: Maybe<Array<Scalars['ID']>>;
  professionSkillId?: Maybe<Scalars['ID']>;
  professionSkillIds?: Maybe<Array<Scalars['ID']>>;
  professionSkillIdsStrict?: Maybe<Array<Scalars['ID']>>;
  q?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['ID']>;
  questionIds?: Maybe<Array<Scalars['ID']>>;
  questionIdsStrict?: Maybe<Array<Scalars['ID']>>;
  referenceEqual?: Maybe<Scalars['Int']>;
  referenceGreaterThan?: Maybe<Scalars['Int']>;
  referenceGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  referenceLessThan?: Maybe<Scalars['Int']>;
  referenceLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  reportId?: Maybe<Scalars['ID']>;
  reportIds?: Maybe<Array<Scalars['ID']>>;
  reportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewId?: Maybe<Scalars['ID']>;
  reviewIds?: Maybe<Array<Scalars['ID']>>;
  reviewIdsStrict?: Maybe<Array<Scalars['ID']>>;
  sortBy?: Maybe<Scalars['String']>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
};


export type QueryTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryTemplatesArgs = {
  activityId?: Maybe<Scalars['ID']>;
  activityIds?: Maybe<Array<Scalars['ID']>>;
  activityIdsStrict?: Maybe<Array<Scalars['ID']>>;
  areFavorite?: Maybe<Scalars['Boolean']>;
  areNotFavorite?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']>>;
  companyIdsStrict?: Maybe<Array<Scalars['ID']>>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  notActivityIds?: Maybe<Array<Scalars['ID']>>;
  notCompanyIds?: Maybe<Array<Scalars['ID']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notQuestionIds?: Maybe<Array<Scalars['ID']>>;
  notReferentIds?: Maybe<Array<Scalars['ID']>>;
  notReportIds?: Maybe<Array<Scalars['ID']>>;
  notReviewIds?: Maybe<Array<Scalars['ID']>>;
  notReviewsAsOriginalTemplateIds?: Maybe<Array<Scalars['ID']>>;
  notSectionIds?: Maybe<Array<Scalars['ID']>>;
  notSlug?: Maybe<Array<Scalars['String']>>;
  notSlugIds?: Maybe<Array<Scalars['ID']>>;
  notTemplateSectionIds?: Maybe<Array<Scalars['ID']>>;
  notTitle?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['ID']>;
  questionIds?: Maybe<Array<Scalars['ID']>>;
  questionIdsStrict?: Maybe<Array<Scalars['ID']>>;
  referentId?: Maybe<Scalars['ID']>;
  referentIds?: Maybe<Array<Scalars['ID']>>;
  referentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reportId?: Maybe<Scalars['ID']>;
  reportIds?: Maybe<Array<Scalars['ID']>>;
  reportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewId?: Maybe<Scalars['ID']>;
  reviewIds?: Maybe<Array<Scalars['ID']>>;
  reviewIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewsAsOriginalTemplateId?: Maybe<Scalars['ID']>;
  reviewsAsOriginalTemplateIds?: Maybe<Array<Scalars['ID']>>;
  reviewsAsOriginalTemplateIdsStrict?: Maybe<Array<Scalars['ID']>>;
  sectionId?: Maybe<Scalars['ID']>;
  sectionIds?: Maybe<Array<Scalars['ID']>>;
  sectionIdsStrict?: Maybe<Array<Scalars['ID']>>;
  slug?: Maybe<Array<Scalars['String']>>;
  slugId?: Maybe<Scalars['ID']>;
  slugIds?: Maybe<Array<Scalars['ID']>>;
  slugIdsStrict?: Maybe<Array<Scalars['ID']>>;
  sortBy?: Maybe<Scalars['String']>;
  templateSectionId?: Maybe<Scalars['ID']>;
  templateSectionIds?: Maybe<Array<Scalars['ID']>>;
  templateSectionIdsStrict?: Maybe<Array<Scalars['ID']>>;
  title?: Maybe<Array<Scalars['String']>>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserCheckPasswordTokenArgs = {
  redirectUrl?: Maybe<Scalars['String']>;
  resetPasswordToken: Scalars['String'];
};


export type QueryUserConfirmAccountArgs = {
  confirmationToken: Scalars['String'];
  redirectUrl: Scalars['String'];
};


export type QueryUsersArgs = {
  activityId?: Maybe<Scalars['ID']>;
  activityIds?: Maybe<Array<Scalars['ID']>>;
  activityIdsStrict?: Maybe<Array<Scalars['ID']>>;
  answerId?: Maybe<Scalars['ID']>;
  answerIds?: Maybe<Array<Scalars['ID']>>;
  answerIdsStrict?: Maybe<Array<Scalars['ID']>>;
  answersAsCollaboratorId?: Maybe<Scalars['ID']>;
  answersAsCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  answersAsCollaboratorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  areAllowPasswordChange?: Maybe<Scalars['Boolean']>;
  areEnabled?: Maybe<Scalars['Boolean']>;
  areIsCapableOfCreatingStandaloneAnswers?: Maybe<Scalars['Boolean']>;
  areIsCapableOfCreatingStandaloneQuestions?: Maybe<Scalars['Boolean']>;
  areIsCapableOfDeletingAllAnswers?: Maybe<Scalars['Boolean']>;
  areIsCapableOfDeletingCampaigns?: Maybe<Scalars['Boolean']>;
  areIsCapableOfDeletingGroups?: Maybe<Scalars['Boolean']>;
  areIsCapableOfDeletingProfessions?: Maybe<Scalars['Boolean']>;
  areIsCapableOfDeletingReviews?: Maybe<Scalars['Boolean']>;
  areIsCapableOfDeletingSkills?: Maybe<Scalars['Boolean']>;
  areIsCapableOfDeletingTemplates?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingCampaigns?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingGroupMembers?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingGroups?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingProfessionSkills?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingProfessions?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingReviews?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingSkills?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingTemplates?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingTranslations?: Maybe<Scalars['Boolean']>;
  areIsCapableOfInsertingUsers?: Maybe<Scalars['Boolean']>;
  areIsCapableOfManagingReports?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingActivities?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingActivitiesIps?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingAllReviews?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingCampaigns?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingGroups?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingQuestions?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingReviews?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingSkills?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingStandaloneAnswers?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingStandaloneQuestions?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingTemplates?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingUserDocuments?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingUserNotes?: Maybe<Scalars['Boolean']>;
  areIsCapableOfReadingUsers?: Maybe<Scalars['Boolean']>;
  areIsCapableOfSigningReports?: Maybe<Scalars['Boolean']>;
  areIsCapableOfUpdatingCompanies?: Maybe<Scalars['Boolean']>;
  areIsCapableOfUpdatingUserCapabilities?: Maybe<Scalars['Boolean']>;
  areIsCapableOfUpdatingUserNotes?: Maybe<Scalars['Boolean']>;
  areNotAllowPasswordChange?: Maybe<Scalars['Boolean']>;
  areNotEnabled?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfCreatingStandaloneAnswers?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfCreatingStandaloneQuestions?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfDeletingAllAnswers?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfDeletingCampaigns?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfDeletingGroups?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfDeletingProfessions?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfDeletingReviews?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfDeletingSkills?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfDeletingTemplates?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingCampaigns?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingGroupMembers?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingGroups?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingProfessionSkills?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingProfessions?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingReviews?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingSkills?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingTemplates?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingTranslations?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfInsertingUsers?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfManagingReports?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingActivities?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingActivitiesIps?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingAllReviews?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingCampaigns?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingGroups?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingQuestions?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingReviews?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingSkills?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingStandaloneAnswers?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingStandaloneQuestions?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingTemplates?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingUserDocuments?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingUserNotes?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfReadingUsers?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfSigningReports?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfUpdatingCompanies?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfUpdatingUserCapabilities?: Maybe<Scalars['Boolean']>;
  areNotIsCapableOfUpdatingUserNotes?: Maybe<Scalars['Boolean']>;
  avatarAttachmentId?: Maybe<Scalars['ID']>;
  avatarAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  avatarAttachmentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  avatarBlobId?: Maybe<Scalars['ID']>;
  avatarBlobIds?: Maybe<Array<Scalars['ID']>>;
  avatarBlobIdsStrict?: Maybe<Array<Scalars['ID']>>;
  companyId?: Maybe<Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']>>;
  companyIdsStrict?: Maybe<Array<Scalars['ID']>>;
  confirmationSentAfter?: Maybe<Scalars['String']>;
  confirmationSentAfterIncluding?: Maybe<Scalars['String']>;
  confirmationSentBefore?: Maybe<Scalars['String']>;
  confirmationSentBeforeIncluding?: Maybe<Scalars['String']>;
  confirmedAfter?: Maybe<Scalars['String']>;
  confirmedAfterIncluding?: Maybe<Scalars['String']>;
  confirmedBefore?: Maybe<Scalars['String']>;
  confirmedBeforeIncluding?: Maybe<Scalars['String']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  documentsAttachmentId?: Maybe<Scalars['ID']>;
  documentsAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  documentsAttachmentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  documentsBlobId?: Maybe<Scalars['ID']>;
  documentsBlobIds?: Maybe<Array<Scalars['ID']>>;
  documentsBlobIdsStrict?: Maybe<Array<Scalars['ID']>>;
  email?: Maybe<Array<Scalars['String']>>;
  eventId?: Maybe<Scalars['ID']>;
  eventIds?: Maybe<Array<Scalars['ID']>>;
  eventIdsStrict?: Maybe<Array<Scalars['ID']>>;
  groupId?: Maybe<Scalars['ID']>;
  groupIds?: Maybe<Array<Scalars['ID']>>;
  groupIdsStrict?: Maybe<Array<Scalars['ID']>>;
  havingAnswersMatching?: Maybe<Array<AnswerMatchingInput>>;
  ids?: Maybe<Array<Scalars['ID']>>;
  idsStrict?: Maybe<Array<Scalars['ID']>>;
  locale?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  notActivityIds?: Maybe<Array<Scalars['ID']>>;
  notAnswerIds?: Maybe<Array<Scalars['ID']>>;
  notAnswersAsCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  notAvatarAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  notAvatarBlobIds?: Maybe<Array<Scalars['ID']>>;
  notCompanyIds?: Maybe<Array<Scalars['ID']>>;
  notDocumentsAttachmentIds?: Maybe<Array<Scalars['ID']>>;
  notDocumentsBlobIds?: Maybe<Array<Scalars['ID']>>;
  notEmail?: Maybe<Array<Scalars['String']>>;
  notEventIds?: Maybe<Array<Scalars['ID']>>;
  notGroupIds?: Maybe<Array<Scalars['ID']>>;
  notIds?: Maybe<Array<Scalars['ID']>>;
  notLocale?: Maybe<Array<Scalars['String']>>;
  notName?: Maybe<Array<Scalars['String']>>;
  notProvider?: Maybe<Array<Scalars['String']>>;
  notReportIds?: Maybe<Array<Scalars['ID']>>;
  notReportsAsReferentIds?: Maybe<Array<Scalars['ID']>>;
  notReviewIds?: Maybe<Array<Scalars['ID']>>;
  notReviewReferentIds?: Maybe<Array<Scalars['ID']>>;
  notReviewSupervisorIds?: Maybe<Array<Scalars['ID']>>;
  notReviewUserIds?: Maybe<Array<Scalars['ID']>>;
  notReviewsAsCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  notReviewsAsReferentIds?: Maybe<Array<Scalars['ID']>>;
  notReviewsAsSupervisorIds?: Maybe<Array<Scalars['ID']>>;
  notSkillIds?: Maybe<Array<Scalars['ID']>>;
  notSkillQuestionsAsCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  notSlug?: Maybe<Array<Scalars['String']>>;
  notSlugIds?: Maybe<Array<Scalars['ID']>>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  provider?: Maybe<Array<Scalars['String']>>;
  q?: Maybe<Scalars['String']>;
  rememberCreatedAfter?: Maybe<Scalars['String']>;
  rememberCreatedAfterIncluding?: Maybe<Scalars['String']>;
  rememberCreatedBefore?: Maybe<Scalars['String']>;
  rememberCreatedBeforeIncluding?: Maybe<Scalars['String']>;
  reportId?: Maybe<Scalars['ID']>;
  reportIds?: Maybe<Array<Scalars['ID']>>;
  reportIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reportsAsReferentId?: Maybe<Scalars['ID']>;
  reportsAsReferentIds?: Maybe<Array<Scalars['ID']>>;
  reportsAsReferentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  resetPasswordSentAfter?: Maybe<Scalars['String']>;
  resetPasswordSentAfterIncluding?: Maybe<Scalars['String']>;
  resetPasswordSentBefore?: Maybe<Scalars['String']>;
  resetPasswordSentBeforeIncluding?: Maybe<Scalars['String']>;
  reviewId?: Maybe<Scalars['ID']>;
  reviewIds?: Maybe<Array<Scalars['ID']>>;
  reviewIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewReferentId?: Maybe<Scalars['ID']>;
  reviewReferentIds?: Maybe<Array<Scalars['ID']>>;
  reviewReferentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewSupervisorId?: Maybe<Scalars['ID']>;
  reviewSupervisorIds?: Maybe<Array<Scalars['ID']>>;
  reviewSupervisorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewUserId?: Maybe<Scalars['ID']>;
  reviewUserIds?: Maybe<Array<Scalars['ID']>>;
  reviewUserIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewsAsCollaboratorId?: Maybe<Scalars['ID']>;
  reviewsAsCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  reviewsAsCollaboratorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewsAsReferentId?: Maybe<Scalars['ID']>;
  reviewsAsReferentIds?: Maybe<Array<Scalars['ID']>>;
  reviewsAsReferentIdsStrict?: Maybe<Array<Scalars['ID']>>;
  reviewsAsSupervisorId?: Maybe<Scalars['ID']>;
  reviewsAsSupervisorIds?: Maybe<Array<Scalars['ID']>>;
  reviewsAsSupervisorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  skillId?: Maybe<Scalars['ID']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
  skillIdsStrict?: Maybe<Array<Scalars['ID']>>;
  skillQuestionsAsCollaboratorId?: Maybe<Scalars['ID']>;
  skillQuestionsAsCollaboratorIds?: Maybe<Array<Scalars['ID']>>;
  skillQuestionsAsCollaboratorIdsStrict?: Maybe<Array<Scalars['ID']>>;
  slug?: Maybe<Array<Scalars['String']>>;
  slugId?: Maybe<Scalars['ID']>;
  slugIds?: Maybe<Array<Scalars['ID']>>;
  slugIdsStrict?: Maybe<Array<Scalars['ID']>>;
  sortBy?: Maybe<Scalars['String']>;
  unconfirmedEmailAfter?: Maybe<Scalars['String']>;
  unconfirmedEmailAfterIncluding?: Maybe<Scalars['String']>;
  unconfirmedEmailBefore?: Maybe<Scalars['String']>;
  unconfirmedEmailBeforeIncluding?: Maybe<Scalars['String']>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
};

export type Question = {
  __typename?: 'Question';
  answerIds: Array<Scalars['ID']>;
  answers: Array<Answer>;
  answersCount: Scalars['Int'];
  companyId: Scalars['ID'];
  createdAt: Scalars['String'];
  defaultValue?: Maybe<Scalars['JSON']>;
  defaultValueSchema?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  digest: Scalars['String'];
  documentIds: Array<Scalars['ID']>;
  documents: Array<Document>;
  documentsCount: Scalars['Int'];
  expectedTimeUnit?: Maybe<ExpectedTimeUnitEnum>;
  expectedTimeValue?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  matchingAnswerIds: Array<Scalars['ID']>;
  matchingAnswers: Array<Answer>;
  matchingAnswersCount: Scalars['Int'];
  options?: Maybe<Scalars['JSON']>;
  optionsSchema?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  reportTypes: Array<ReportTypeEnum>;
  required: Scalars['Boolean'];
  skill?: Maybe<Skill>;
  skillId?: Maybe<Scalars['ID']>;
  timeTracked?: Maybe<Scalars['Boolean']>;
  type: QuestionTypeEnum;
  updatedAt: Scalars['String'];
  visibility: QuestionVisibility;
};

export type QuestionCollection = {
  __typename?: 'QuestionCollection';
  collection: Array<Question>;
  metadata: CollectionMetadata;
};

export type QuestionInput = {
  answersAttributes?: Maybe<Array<AnswerInput>>;
  companyId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  documentsBlobIds?: Maybe<Array<Scalars['String']>>;
  expectedTimeUnit?: Maybe<Scalars['String']>;
  expectedTimeValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['JSON']>;
  order: Scalars['Int'];
  reportTypes: Array<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  skillId?: Maybe<Scalars['ID']>;
  timeTracked?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  visibility?: Maybe<QuestionVisibility>;
};

export type QuestionOptionsConfiguration = {
  __typename?: 'QuestionOptionsConfiguration';
  createdAt: Scalars['String'];
  evaluationQuestionOptionsConfiguration?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  skillQuestionOptionsConfiguration?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['String'];
};

export type QuestionOptionsConfigurationInput = {
  evaluationQuestionOptionsConfiguration?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['ID']>;
  skillQuestionOptionsConfiguration?: Maybe<Scalars['JSON']>;
};

export type QuestionTypeEnum =
  /** Evaluation question */
  | 'QuestionEvaluation'
  /** Multiple choice question */
  | 'QuestionSelectorMultiple'
  /** Single choice question */
  | 'QuestionSelectorSingle'
  /** Skill question */
  | 'QuestionSkill'
  /** Text question */
  | 'QuestionText';

export type QuestionVisibility =
  /** Referents and collaborators can see the question */
  | 'all'
  /** Only the collaborator can see the question */
  | 'collaborator'
  /** Only referents can see the question */
  | 'referents';

export type Report = {
  __typename?: 'Report';
  answerIds: Array<Scalars['ID']>;
  answers: Array<Answer>;
  answersCount: Scalars['Int'];
  canCheck: Scalars['Boolean'];
  canDestroy: Scalars['Boolean'];
  canFill: Scalars['Boolean'];
  canReset: Scalars['Boolean'];
  canShow: Scalars['Boolean'];
  canSign: Scalars['Boolean'];
  canUpdate: Scalars['Boolean'];
  checkedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  document?: Maybe<Scalars['String']>;
  docusignEnvelopeStatus?: Maybe<DocusignEnvelopeStatusEnum>;
  filledAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  reportReferentIds: Array<Scalars['ID']>;
  reportReferents: Array<ReportReferent>;
  reportReferentsCount: Scalars['Int'];
  reportSignatories: Array<ReportSignatory>;
  reportSignatoriesCount: Scalars['Int'];
  reportSignatoryIds: Array<Scalars['ID']>;
  review: Review;
  reviewId: Scalars['ID'];
  template?: Maybe<Template>;
  templateId?: Maybe<Scalars['ID']>;
  type: ReportTypeEnum;
  updatedAt: Scalars['String'];
};

export type ReportCollection = {
  __typename?: 'ReportCollection';
  collection: Array<Report>;
  metadata: CollectionMetadata;
};

export type ReportReferent = {
  __typename?: 'ReportReferent';
  createdAt: Scalars['String'];
  filledAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  referent: User;
  referentId: Scalars['ID'];
  report: Report;
  reportId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type ReportSignatory = {
  __typename?: 'ReportSignatory';
  canShow: Scalars['Boolean'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  report: Report;
  reportId: Scalars['ID'];
  signatory?: Maybe<User>;
  signatoryId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['String'];
};

export type ReportTypeEnum =
  /** Final report */
  | 'FinalReport'
  /** First report */
  | 'FirstReport'
  /** Intermediate report */
  | 'IntermediateReport';

export type Review = {
  __typename?: 'Review';
  allowTemplateUpdateByCollaborator: Scalars['Boolean'];
  campaign: Campaign;
  campaignId: Scalars['ID'];
  canAddDocument: Scalars['Boolean'];
  canDeleteDocument: Scalars['Boolean'];
  canDestroy: Scalars['Boolean'];
  canInsert: Scalars['Boolean'];
  canShow: Scalars['Boolean'];
  collaborator?: Maybe<User>;
  collaboratorId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentIds: Array<Scalars['ID']>;
  documents: Array<Document>;
  documentsCount: Scalars['Int'];
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastCheckedReport?: Maybe<Report>;
  nextReportAt?: Maybe<Scalars['String']>;
  originalTemplate?: Maybe<Template>;
  originalTemplateId?: Maybe<Scalars['ID']>;
  referentIds: Array<Scalars['ID']>;
  referents: Array<User>;
  referentsCount: Scalars['Int'];
  reminderEnabled: Scalars['Boolean'];
  reminderGap: Scalars['Int'];
  reportIds: Array<Scalars['ID']>;
  reports: Array<Report>;
  reportsCount: Scalars['Int'];
  reviewReferentIds: Array<Scalars['ID']>;
  reviewReferents: Array<ReviewReferent>;
  reviewReferentsCount: Scalars['Int'];
  reviewSupervisorIds: Array<Scalars['ID']>;
  reviewSupervisors: Array<ReviewSupervisor>;
  reviewSupervisorsCount: Scalars['Int'];
  schedule?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  supervisorIds: Array<Scalars['ID']>;
  supervisors: Array<User>;
  supervisorsCount: Scalars['Int'];
  template: Template;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type ReviewCollection = {
  __typename?: 'ReviewCollection';
  collection: Array<Review>;
  metadata: CollectionMetadata;
};

export type ReviewReferent = {
  __typename?: 'ReviewReferent';
  emailNotificationsEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  review: Review;
  reviewId: Scalars['ID'];
  user: User;
  userId: Scalars['ID'];
};

export type ReviewSupervisor = {
  __typename?: 'ReviewSupervisor';
  emailNotificationsEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  review: Review;
  reviewId: Scalars['ID'];
  user: User;
  userId: Scalars['ID'];
};

export type ReviewUserInput = {
  emailNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type Section = {
  __typename?: 'Section';
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order: Scalars['Int'];
  questionIds: Array<Scalars['ID']>;
  questions: Array<Question>;
  questionsCount: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type SectionInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  order: Scalars['Int'];
  questionsAttributes?: Maybe<Array<QuestionInput>>;
  title?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SendConnectionLink */
export type SendConnectionLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

/** Autogenerated return type of SendConnectionLink */
export type SendConnectionLinkPayload = {
  __typename?: 'SendConnectionLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SignReport */
export type SignReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  document: Scalars['String'];
  filename: Scalars['String'];
  reportId: Scalars['ID'];
  signatoryIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of SignReport */
export type SignReportPayload = {
  __typename?: 'SignReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  report: Report;
};

export type Skill = {
  __typename?: 'Skill';
  answerIds: Array<Scalars['ID']>;
  answers: Array<Answer>;
  answersCount: Scalars['Int'];
  canDestroy: Scalars['Boolean'];
  canInsert: Scalars['Boolean'];
  collaboratorIds: Array<Scalars['ID']>;
  collaborators: Array<User>;
  collaboratorsCount: Scalars['Int'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  kind?: Maybe<SkillKindEnum>;
  locale: Scalars['String'];
  name: Scalars['String'];
  professionIds: Array<Scalars['ID']>;
  professions: Array<Profession>;
  professionsCount: Scalars['Int'];
  questionIds: Array<Scalars['ID']>;
  questions: Array<Question>;
  questionsCount: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type SkillCollection = {
  __typename?: 'SkillCollection';
  collection: Array<Skill>;
  metadata: CollectionMetadata;
};

export type SkillKindEnum =
  /** Hard Skill */
  | 'hard'
  /** Soft Skill */
  | 'soft';

export type Subscription = {
  __typename?: 'Subscription';
  /** A template was added */
  exampleSubscription: Template;
};

export type Template = {
  __typename?: 'Template';
  canDestroy: Scalars['Boolean'];
  canInsert: Scalars['Boolean'];
  canShow: Scalars['Boolean'];
  color: Scalars['String'];
  createdAt: Scalars['String'];
  favorite: Scalars['Boolean'];
  id: Scalars['ID'];
  reviewsAsOriginalTemplate: Array<Review>;
  reviewsAsOriginalTemplateCount: Scalars['Int'];
  reviewsAsOriginalTemplateIds: Array<Scalars['ID']>;
  sectionIds: Array<Scalars['ID']>;
  sections: Array<Section>;
  sectionsCount: Scalars['Int'];
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type TemplateCollection = {
  __typename?: 'TemplateCollection';
  collection: Array<Template>;
  metadata: CollectionMetadata;
};

export type TemplateInput = {
  color?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  favorite?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  sectionsAttributes?: Maybe<Array<SectionInput>>;
  title: Scalars['String'];
};

export type Theme = {
  __typename?: 'Theme';
  primary: Scalars['String'];
  secondary: Scalars['String'];
};

export type Translation = {
  __typename?: 'Translation';
  id: Scalars['ID'];
  key: Scalars['String'];
  locale: Scalars['String'];
  value: Scalars['String'];
};

/** Autogenerated input type of UpdateCompany */
export type UpdateCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  questionOptionsConfigurationsAttributes?: Maybe<Array<QuestionOptionsConfigurationInput>>;
  reminderEnabled?: Maybe<Scalars['Boolean']>;
  reminderGap?: Maybe<Scalars['Int']>;
  visualIdentity?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCompany */
export type UpdateCompanyPayload = {
  __typename?: 'UpdateCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  company: Company;
};

/** Autogenerated input type of UpdateReport */
export type UpdateReportInput = {
  answersAttributes?: Maybe<Array<AnswerInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateReport */
export type UpdateReportPayload = {
  __typename?: 'UpdateReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  report: Report;
};

/** Autogenerated input type of UpdateViewer */
export type UpdateViewerInput = {
  avatar?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateViewer */
export type UpdateViewerPayload = {
  __typename?: 'UpdateViewerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  viewer: Viewer;
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']>;
  canAddDocument: Scalars['Boolean'];
  canDeleteDocument: Scalars['Boolean'];
  canInsert: Scalars['Boolean'];
  canShow: Scalars['Boolean'];
  company: Company;
  companyId: Scalars['ID'];
  createdAt: Scalars['String'];
  documentIds: Array<Scalars['ID']>;
  documents: Array<Document>;
  documentsCount: Scalars['Int'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  groupIds: Array<Scalars['ID']>;
  groups: Array<Group>;
  groupsCount: Scalars['Int'];
  id: Scalars['ID'];
  isCapableOfCreatingStandaloneAnswers: Scalars['Boolean'];
  isCapableOfCreatingStandaloneQuestions: Scalars['Boolean'];
  isCapableOfDeletingAllAnswers: Scalars['Boolean'];
  isCapableOfDeletingCampaigns: Scalars['Boolean'];
  isCapableOfDeletingGroups: Scalars['Boolean'];
  isCapableOfDeletingProfessions: Scalars['Boolean'];
  isCapableOfDeletingReviews: Scalars['Boolean'];
  isCapableOfDeletingSkills: Scalars['Boolean'];
  isCapableOfDeletingTemplates: Scalars['Boolean'];
  isCapableOfInsertingCampaigns: Scalars['Boolean'];
  isCapableOfInsertingGroupMembers: Scalars['Boolean'];
  isCapableOfInsertingGroups: Scalars['Boolean'];
  isCapableOfInsertingProfessionSkills: Scalars['Boolean'];
  isCapableOfInsertingProfessions: Scalars['Boolean'];
  isCapableOfInsertingReviews: Scalars['Boolean'];
  isCapableOfInsertingSkills: Scalars['Boolean'];
  isCapableOfInsertingTemplates: Scalars['Boolean'];
  isCapableOfInsertingTranslations: Scalars['Boolean'];
  isCapableOfInsertingUsers: Scalars['Boolean'];
  isCapableOfManagingReports: Scalars['Boolean'];
  isCapableOfReadingActivities: Scalars['Boolean'];
  isCapableOfReadingActivitiesIps: Scalars['Boolean'];
  isCapableOfReadingAllReviews: Scalars['Boolean'];
  isCapableOfReadingCampaigns: Scalars['Boolean'];
  isCapableOfReadingGroups: Scalars['Boolean'];
  isCapableOfReadingQuestions: Scalars['Boolean'];
  isCapableOfReadingReviews: Scalars['Boolean'];
  isCapableOfReadingSkills: Scalars['Boolean'];
  isCapableOfReadingStandaloneAnswers: Scalars['Boolean'];
  isCapableOfReadingStandaloneQuestions: Scalars['Boolean'];
  isCapableOfReadingTemplates: Scalars['Boolean'];
  isCapableOfReadingUserDocuments: Scalars['Boolean'];
  isCapableOfReadingUserNotes: Scalars['Boolean'];
  isCapableOfReadingUsers: Scalars['Boolean'];
  isCapableOfSigningReports: Scalars['Boolean'];
  isCapableOfUpdatingCompanies: Scalars['Boolean'];
  isCapableOfUpdatingUserCapabilities: Scalars['Boolean'];
  isCapableOfUpdatingUserNotes: Scalars['Boolean'];
  locale?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  reviewsAsCollaborator: Array<Review>;
  reviewsAsCollaboratorCount: Scalars['Int'];
  reviewsAsCollaboratorIds: Array<Scalars['ID']>;
  reviewsAsReferent: Array<Review>;
  reviewsAsReferentCount: Scalars['Int'];
  reviewsAsReferentIds: Array<Scalars['ID']>;
  skillIds: Array<Scalars['ID']>;
  skills: Array<Skill>;
  skillsCount: Scalars['Int'];
  slug: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type UserCollection = {
  __typename?: 'UserCollection';
  collection: Array<User>;
  metadata: CollectionMetadata;
};

/** Autogenerated return type of UserLogin */
export type UserLoginPayload = {
  __typename?: 'UserLoginPayload';
  authenticatable: User;
  credentials: Credential;
};

/** Autogenerated return type of UserLogout */
export type UserLogoutPayload = {
  __typename?: 'UserLogoutPayload';
  authenticatable: User;
};

/** Autogenerated return type of UserResendConfirmation */
export type UserResendConfirmationPayload = {
  __typename?: 'UserResendConfirmationPayload';
  message: Scalars['String'];
};

/** Autogenerated return type of UserSendPasswordReset */
export type UserSendPasswordResetPayload = {
  __typename?: 'UserSendPasswordResetPayload';
  message: Scalars['String'];
};

/** Autogenerated return type of UserSignUp */
export type UserSignUpPayload = {
  __typename?: 'UserSignUpPayload';
  authenticatable: User;
  /** Authentication credentials. Null if after signUp resource is not active for authentication (e.g. Email confirmation required). */
  credentials?: Maybe<Credential>;
};

/** Autogenerated return type of UserUpdatePassword */
export type UserUpdatePasswordPayload = {
  __typename?: 'UserUpdatePasswordPayload';
  authenticatable: User;
};

export type Viewer = {
  __typename?: 'Viewer';
  avatar?: Maybe<Scalars['String']>;
  canAddDocument: Scalars['Boolean'];
  canDeleteDocument: Scalars['Boolean'];
  canInsert: Scalars['Boolean'];
  canShow: Scalars['Boolean'];
  company: Company;
  companyId: Scalars['ID'];
  createdAt: Scalars['String'];
  documentIds: Array<Scalars['ID']>;
  documents: Array<Document>;
  documentsCount: Scalars['Int'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  groupIds: Array<Scalars['ID']>;
  groups: Array<Group>;
  groupsCount: Scalars['Int'];
  id: Scalars['ID'];
  isCapableOfCreatingStandaloneAnswers: Scalars['Boolean'];
  isCapableOfCreatingStandaloneQuestions: Scalars['Boolean'];
  isCapableOfDeletingAllAnswers: Scalars['Boolean'];
  isCapableOfDeletingCampaigns: Scalars['Boolean'];
  isCapableOfDeletingGroups: Scalars['Boolean'];
  isCapableOfDeletingProfessions: Scalars['Boolean'];
  isCapableOfDeletingReviews: Scalars['Boolean'];
  isCapableOfDeletingSkills: Scalars['Boolean'];
  isCapableOfDeletingTemplates: Scalars['Boolean'];
  isCapableOfInsertingCampaigns: Scalars['Boolean'];
  isCapableOfInsertingGroupMembers: Scalars['Boolean'];
  isCapableOfInsertingGroups: Scalars['Boolean'];
  isCapableOfInsertingProfessionSkills: Scalars['Boolean'];
  isCapableOfInsertingProfessions: Scalars['Boolean'];
  isCapableOfInsertingReviews: Scalars['Boolean'];
  isCapableOfInsertingSkills: Scalars['Boolean'];
  isCapableOfInsertingTemplates: Scalars['Boolean'];
  isCapableOfInsertingTranslations: Scalars['Boolean'];
  isCapableOfInsertingUsers: Scalars['Boolean'];
  isCapableOfManagingReports: Scalars['Boolean'];
  isCapableOfReadingActivities: Scalars['Boolean'];
  isCapableOfReadingActivitiesIps: Scalars['Boolean'];
  isCapableOfReadingAllReviews: Scalars['Boolean'];
  isCapableOfReadingCampaigns: Scalars['Boolean'];
  isCapableOfReadingGroups: Scalars['Boolean'];
  isCapableOfReadingQuestions: Scalars['Boolean'];
  isCapableOfReadingReviews: Scalars['Boolean'];
  isCapableOfReadingSkills: Scalars['Boolean'];
  isCapableOfReadingStandaloneAnswers: Scalars['Boolean'];
  isCapableOfReadingStandaloneQuestions: Scalars['Boolean'];
  isCapableOfReadingTemplates: Scalars['Boolean'];
  isCapableOfReadingUserDocuments: Scalars['Boolean'];
  isCapableOfReadingUserNotes: Scalars['Boolean'];
  isCapableOfReadingUsers: Scalars['Boolean'];
  isCapableOfSigningReports: Scalars['Boolean'];
  isCapableOfUpdatingCompanies: Scalars['Boolean'];
  isCapableOfUpdatingUserCapabilities: Scalars['Boolean'];
  isCapableOfUpdatingUserNotes: Scalars['Boolean'];
  locale: Scalars['String'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  reviewsAsCollaborator: Array<Review>;
  reviewsAsCollaboratorCount: Scalars['Int'];
  reviewsAsCollaboratorIds: Array<Scalars['ID']>;
  reviewsAsReferent: Array<Review>;
  reviewsAsReferentCount: Scalars['Int'];
  reviewsAsReferentIds: Array<Scalars['ID']>;
  skillIds: Array<Scalars['ID']>;
  skills: Array<Skill>;
  skillsCount: Scalars['Int'];
  slug: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ActivityFragment = { __typename?: 'Activity', id: string, key: string, createdAt: string, updatedAt: string, recipientType: string, trackableType: string, owner: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, recipient: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number } | { __typename?: 'Company', id: string, name: string, visualIdentity?: string | null | undefined, theme?: { __typename?: 'Theme', primary: string, secondary: string } | null | undefined } | { __typename?: 'Review', id: string, collaborator?: { __typename?: 'User', id: string, name: string, slug: string } | null | undefined, campaign: { __typename?: 'Campaign', id: string, name: string } } | { __typename?: 'User' }, trackable: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number } | { __typename?: 'Company', id: string, name: string, visualIdentity?: string | null | undefined, theme?: { __typename?: 'Theme', primary: string, secondary: string } | null | undefined } | { __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> } | { __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined } | { __typename?: 'Review', id: string, collaborator?: { __typename?: 'User', id: string, name: string, slug: string } | null | undefined, campaign: { __typename?: 'Campaign', id: string, name: string } } | { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } };

export type ActivityReviewFragment = { __typename?: 'Review', id: string, collaborator?: { __typename?: 'User', id: string, name: string, slug: string } | null | undefined, campaign: { __typename?: 'Campaign', id: string, name: string } };

export type AnswerFragment = { __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } };

export type AnswerSummaryFragment = { __typename?: 'Answer', id: string, questionId: string, questionDigest: string, createdAt: string, updatedAt: string, type: AnswerTypeEnum, normalizedRating?: number | null | undefined, canDestroy: boolean, timeSpent?: number | null | undefined, isCollaborator: boolean, isEmpty: boolean, reportId?: string | null | undefined, value?: any | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, question: { __typename?: 'Question', id: string, label: string, type: QuestionTypeEnum, digest: string, visibility: QuestionVisibility, required: boolean, options?: any | null | undefined, expectedTimeValue?: number | null | undefined, skill?: { __typename?: 'Skill', id: string, name: string } | null | undefined } };

export type AnswerForMappingFragment = { __typename?: 'Answer', questionDigest: string, selector?: any | null | undefined, collaboratorId: string };

export type AnswerHistoryFragment = { __typename?: 'Answer', id: string, questionId: string, questionDigest: string, createdAt: string, updatedAt: string, type: AnswerTypeEnum, timeSpent?: number | null | undefined, isCollaborator: boolean, isDraft: boolean, userId: string, canDestroy: boolean, isEmpty: boolean, reportId?: string | null | undefined, value?: any | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, question: { __typename?: 'Question', id: string, label: string, type: QuestionTypeEnum, digest: string, visibility: QuestionVisibility, required: boolean, options?: any | null | undefined, expectedTimeValue?: number | null | undefined, skill?: { __typename?: 'Skill', id: string, name: string } | null | undefined } };

export type CampaignSummaryFragment = { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number };

export type CampaignListingFragment = { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, reviewsCount: number, canShow: boolean, canInsert: boolean, canDestroy: boolean };

export type CampaignMinimalFragment = { __typename?: 'Campaign', id: string, slug: string, name: string };

export type CollectionMetadataFragment = { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number };

export type CompanyMinimalFragment = { __typename?: 'Company', id: string, name: string, visualIdentity?: string | null | undefined, theme?: { __typename?: 'Theme', primary: string, secondary: string } | null | undefined };

export type CredentialFragment = { __typename?: 'Credential', accessToken: string, uid: string, tokenType: string, client: string, expiry: number };

export type DocumentFragment = { __typename?: 'Document', filename: string, id: string, blobId: number, url: string };

export type GroupFragment = { __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> };

export type GroupMinimalFragment = { __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number };

export type ProfessionSkillFragment = { __typename?: 'ProfessionSkill', id: string, profession: { __typename?: 'Profession', id: string, name: string, locale: string, canInsert: boolean, canDestroy: boolean, skills: Array<{ __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean }> }, skill: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } };

export type ProfessionFragment = { __typename?: 'Profession', id: string, name: string, locale: string, canInsert: boolean, canDestroy: boolean, skills: Array<{ __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean }> };

export type QuestionOptionsConfigurationFragment = { __typename?: 'QuestionOptionsConfiguration', id: string, locale?: string | null | undefined, skillQuestionOptionsConfiguration?: any | null | undefined, evaluationQuestionOptionsConfiguration?: any | null | undefined };

export type QuestionFragment = { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined };

export type QuestionMinimalFragment = { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, type: QuestionTypeEnum, digest: string, options?: any | null | undefined };

export type QuestionSummaryFragment = { __typename?: 'Question', id: string, label: string, type: QuestionTypeEnum, digest: string, visibility: QuestionVisibility, required: boolean, options?: any | null | undefined, expectedTimeValue?: number | null | undefined, skill?: { __typename?: 'Skill', id: string, name: string } | null | undefined };

export type ReportReferentFragment = { __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } };

export type ReportMinimalFragment = { __typename?: 'Report', id: string, updatedAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, review: { __typename?: 'Review', collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined }, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> };

export type ReportReviewFragment = { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } };

export type ReportFragment = { __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined };

export type ReviewReportFragment = { __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined };

export type ReviewReportFullFragment = { __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, createdAt: string, updatedAt: string, type: AnswerTypeEnum, normalizedRating?: number | null | undefined, canDestroy: boolean, timeSpent?: number | null | undefined, isCollaborator: boolean, isEmpty: boolean, reportId?: string | null | undefined, value?: any | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, question: { __typename?: 'Question', id: string, label: string, type: QuestionTypeEnum, digest: string, visibility: QuestionVisibility, required: boolean, options?: any | null | undefined, expectedTimeValue?: number | null | undefined, skill?: { __typename?: 'Skill', id: string, name: string } | null | undefined } }> };

export type ReviewSupervisorFragment = { __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } };

export type ReviewFragment = { __typename?: 'Review', id: string, description?: string | null | undefined, createdAt: string, startDate: string, endDate?: string | null | undefined, schedule?: string | null | undefined, nextReportAt?: string | null | undefined, canAddDocument: boolean, canDeleteDocument: boolean, canInsert: boolean, canDestroy: boolean, referentIds: Array<string>, reminderEnabled: boolean, reminderGap: number, allowTemplateUpdateByCollaborator: boolean, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string }, template: { __typename?: 'Template', id: string, slug: string, title: string, sections: Array<{ __typename?: 'Section', questions: Array<{ __typename?: 'Question', type: QuestionTypeEnum, label: string }> }> }, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, lastCheckedReport?: { __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined } | null | undefined, reports: Array<{ __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined }>, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }> };

export type ReviewFullFragment = { __typename?: 'Review', id: string, createdAt: string, updatedAt: string, startDate: string, endDate?: string | null | undefined, nextReportAt?: string | null | undefined, description?: string | null | undefined, schedule?: string | null | undefined, canAddDocument: boolean, canDeleteDocument: boolean, canInsert: boolean, canDestroy: boolean, referentIds: Array<string>, reminderEnabled: boolean, reminderGap: number, allowTemplateUpdateByCollaborator: boolean, template: { __typename?: 'Template', id: string, slug: string, title: string, sections: Array<{ __typename?: 'Section', questions: Array<{ __typename?: 'Question', type: QuestionTypeEnum, label: string }> }> }, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string }, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, lastCheckedReport?: { __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined } | null | undefined, reports: Array<{ __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, createdAt: string, updatedAt: string, type: AnswerTypeEnum, normalizedRating?: number | null | undefined, canDestroy: boolean, timeSpent?: number | null | undefined, isCollaborator: boolean, isEmpty: boolean, reportId?: string | null | undefined, value?: any | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, question: { __typename?: 'Question', id: string, label: string, type: QuestionTypeEnum, digest: string, visibility: QuestionVisibility, required: boolean, options?: any | null | undefined, expectedTimeValue?: number | null | undefined, skill?: { __typename?: 'Skill', id: string, name: string } | null | undefined } }> }> };

export type ReviewMinimalFragment = { __typename?: 'Review', id: string, endDate?: string | null | undefined, startDate: string, referentIds: Array<string>, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number }, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined };

export type SectionFragment = { __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> };

export type SkillFragment = { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean };

export type SkillMappingFragment = { __typename?: 'Skill', id: string, name: string };

export type TemplateFragment = { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> };

export type TemplateMinimalFragment = { __typename?: 'Template', id: string, slug: string, title: string, sections: Array<{ __typename?: 'Section', questions: Array<{ __typename?: 'Question', type: QuestionTypeEnum, label: string }> }> };

export type ThemeFragment = { __typename?: 'Theme', primary: string, secondary: string };

export type TranslationFragment = { __typename?: 'Translation', id: string, key: string, value: string, locale: string };

export type UserReviewFragment = { __typename?: 'User', id: string, slug: string, name: string, avatar?: string | null | undefined, email: string, locale?: string | null | undefined, enabled: boolean, notes?: string | null | undefined, canAddDocument: boolean, canInsert: boolean, isCapableOfCreatingStandaloneAnswers: boolean, isCapableOfCreatingStandaloneQuestions: boolean, isCapableOfDeletingAllAnswers: boolean, isCapableOfDeletingCampaigns: boolean, isCapableOfDeletingGroups: boolean, isCapableOfDeletingReviews: boolean, isCapableOfDeletingTemplates: boolean, isCapableOfInsertingCampaigns: boolean, isCapableOfInsertingGroups: boolean, isCapableOfInsertingProfessionSkills: boolean, isCapableOfInsertingProfessions: boolean, isCapableOfInsertingReviews: boolean, isCapableOfInsertingSkills: boolean, isCapableOfDeletingProfessions: boolean, isCapableOfDeletingSkills: boolean, isCapableOfInsertingTemplates: boolean, isCapableOfInsertingTranslations: boolean, isCapableOfInsertingUsers: boolean, isCapableOfReadingActivities: boolean, isCapableOfReadingActivitiesIps: boolean, isCapableOfReadingAllReviews: boolean, isCapableOfReadingCampaigns: boolean, isCapableOfReadingGroups: boolean, isCapableOfReadingSkills: boolean, isCapableOfReadingQuestions: boolean, isCapableOfReadingReviews: boolean, isCapableOfReadingStandaloneAnswers: boolean, isCapableOfReadingStandaloneQuestions: boolean, isCapableOfReadingTemplates: boolean, isCapableOfReadingUserDocuments: boolean, isCapableOfReadingUserNotes: boolean, isCapableOfManagingReports: boolean, isCapableOfReadingUsers: boolean, isCapableOfSigningReports: boolean, isCapableOfUpdatingCompanies: boolean, isCapableOfUpdatingUserCapabilities: boolean, isCapableOfUpdatingUserNotes: boolean, createdAt: string, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, company: { __typename?: 'Company', id: string, name: string }, groups: Array<{ __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> }>, reviewsAsCollaborator: Array<{ __typename?: 'Review', id: string, endDate?: string | null | undefined, startDate: string, referentIds: Array<string>, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number }, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined }>, reviewsAsReferent: Array<{ __typename?: 'Review', id: string, endDate?: string | null | undefined, startDate: string, referentIds: Array<string>, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number }, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined }> };

export type UserMinimalFragment = { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean };

export type UserSummaryFragment = { __typename?: 'User', id: string, slug: string, email: string, name: string, notes?: string | null | undefined, avatar?: string | null | undefined, canShow: boolean, canAddDocument: boolean, canInsert: boolean, createdAt: string, groups: Array<{ __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> }> };

export type ViewerFragment = { __typename?: 'Viewer', id: string, slug: string, name: string, locale: string, companyId: string, createdAt: string, email: string, avatar?: string | null | undefined, isCapableOfCreatingStandaloneAnswers: boolean, isCapableOfCreatingStandaloneQuestions: boolean, isCapableOfDeletingAllAnswers: boolean, isCapableOfDeletingCampaigns: boolean, isCapableOfDeletingGroups: boolean, isCapableOfDeletingReviews: boolean, isCapableOfDeletingTemplates: boolean, isCapableOfInsertingCampaigns: boolean, isCapableOfInsertingGroups: boolean, isCapableOfInsertingProfessionSkills: boolean, isCapableOfInsertingProfessions: boolean, isCapableOfInsertingReviews: boolean, isCapableOfInsertingSkills: boolean, isCapableOfInsertingTemplates: boolean, isCapableOfInsertingTranslations: boolean, isCapableOfInsertingUsers: boolean, isCapableOfReadingActivities: boolean, isCapableOfReadingActivitiesIps: boolean, isCapableOfReadingAllReviews: boolean, isCapableOfReadingCampaigns: boolean, isCapableOfReadingGroups: boolean, isCapableOfReadingSkills: boolean, isCapableOfReadingQuestions: boolean, isCapableOfReadingReviews: boolean, isCapableOfReadingStandaloneAnswers: boolean, isCapableOfReadingStandaloneQuestions: boolean, isCapableOfReadingTemplates: boolean, isCapableOfReadingUserDocuments: boolean, isCapableOfReadingUserNotes: boolean, isCapableOfReadingUsers: boolean, isCapableOfSigningReports: boolean, isCapableOfManagingReports: boolean, isCapableOfUpdatingCompanies: boolean, isCapableOfUpdatingUserCapabilities: boolean, isCapableOfUpdatingUserNotes: boolean, company: { __typename?: 'Company', id: string, name: string, locale?: string | null | undefined, reminderEnabled: boolean, reminderGap?: number | null | undefined, reportSigningEnabled: boolean, customTranslationsEnabled: boolean, inlineTemplateUpdateEnabled: boolean, usersCount: number, visualIdentity?: string | null | undefined, questionOptionsConfigurations: Array<{ __typename?: 'QuestionOptionsConfiguration', id: string, locale?: string | null | undefined, skillQuestionOptionsConfiguration?: any | null | undefined, evaluationQuestionOptionsConfiguration?: any | null | undefined }>, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, translations: Array<{ __typename?: 'Translation', id: string, key: string, value: string, locale: string }>, campaigns: Array<{ __typename?: 'Campaign', id: string, slug: string, name: string }>, groups: Array<{ __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number }>, theme?: { __typename?: 'Theme', primary: string, secondary: string } | null | undefined } };

export type GetActivitiesVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  direction?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
}>;


export type GetActivities = { __typename?: 'Query', activities: { __typename?: 'ActivityCollection', collection: Array<{ __typename?: 'Activity', id: string, key: string, createdAt: string, updatedAt: string, recipientType: string, trackableType: string, owner: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, recipient: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number } | { __typename?: 'Company', id: string, name: string, visualIdentity?: string | null | undefined, theme?: { __typename?: 'Theme', primary: string, secondary: string } | null | undefined } | { __typename?: 'Review', id: string, collaborator?: { __typename?: 'User', id: string, name: string, slug: string } | null | undefined, campaign: { __typename?: 'Campaign', id: string, name: string } } | { __typename?: 'User' }, trackable: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number } | { __typename?: 'Company', id: string, name: string, visualIdentity?: string | null | undefined, theme?: { __typename?: 'Theme', primary: string, secondary: string } | null | undefined } | { __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> } | { __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined } | { __typename?: 'Review', id: string, collaborator?: { __typename?: 'User', id: string, name: string, slug: string } | null | undefined, campaign: { __typename?: 'Campaign', id: string, name: string } } | { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number, currentPage: number } } };

export type InsertAnswerVariables = Exact<{
  input: InsertAnswerInput;
}>;


export type InsertAnswer = { __typename?: 'Mutation', insertAnswer?: { __typename?: 'InsertAnswerPayload', answer: { __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } } } | null | undefined };

export type DeleteAnswersVariables = Exact<{
  input: DeleteAnswersInput;
}>;


export type DeleteAnswers = { __typename?: 'Mutation', deleteAnswers?: { __typename?: 'DeleteAnswersPayload', ids: Array<string> } | null | undefined };

export type GetAnswersVariables = Exact<{
  skillIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  skillQ?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  questionDigest?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  isCheckedReport?: Maybe<Scalars['Boolean']>;
  lastCreatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  groupIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  normalizedRatingEqual?: Maybe<Scalars['Float']>;
  normalizedRatingLessThan?: Maybe<Scalars['Float']>;
  normalizedRatingGreaterThan?: Maybe<Scalars['Float']>;
  normalizedRatingLessThanOrEqualTo?: Maybe<Scalars['Float']>;
  normalizedRatingGreaterThanOrEqualTo?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['ID']>;
  collaboratorId?: Maybe<Scalars['ID']>;
  collaboratorIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  direction?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
}>;


export type GetAnswers = { __typename?: 'Query', answers: { __typename?: 'AnswerCollection', collection: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type GetAnswersHistoryVariables = Exact<{
  type?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  questionDigest?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  reviewId?: Maybe<Scalars['ID']>;
  collaboratorId?: Maybe<Scalars['ID']>;
  collaboratorIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  direction?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
}>;


export type GetAnswersHistory = { __typename?: 'Query', answers: { __typename?: 'AnswerCollection', collection: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, createdAt: string, updatedAt: string, type: AnswerTypeEnum, timeSpent?: number | null | undefined, isCollaborator: boolean, isDraft: boolean, userId: string, canDestroy: boolean, isEmpty: boolean, reportId?: string | null | undefined, value?: any | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, question: { __typename?: 'Question', id: string, label: string, type: QuestionTypeEnum, digest: string, visibility: QuestionVisibility, required: boolean, options?: any | null | undefined, expectedTimeValue?: number | null | undefined, skill?: { __typename?: 'Skill', id: string, name: string } | null | undefined } }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type GetAnswersForMappingVariables = Exact<{
  questionDigest?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  lastCreatedAt?: Maybe<Scalars['String']>;
  groupIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  isCollaborator?: Maybe<Scalars['Boolean']>;
}>;


export type GetAnswersForMapping = { __typename?: 'Query', answers: { __typename?: 'AnswerCollection', collection: Array<{ __typename?: 'Answer', questionDigest: string, selector?: any | null | undefined, collaboratorId: string }> } };

export type InsertCampaignVariables = Exact<{
  input: InsertCampaignInput;
}>;


export type InsertCampaign = { __typename?: 'Mutation', insertCampaign?: { __typename?: 'InsertCampaignPayload', campaign: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number } } | null | undefined };

export type DeleteCampaignVariables = Exact<{
  input: DeleteCampaignInput;
}>;


export type DeleteCampaign = { __typename?: 'Mutation', deleteCampaign?: { __typename?: 'DeleteCampaignPayload', id: string } | null | undefined };

export type GetCampaignVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCampaign = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number } };

export type GetCampaignsVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
}>;


export type GetCampaigns = { __typename?: 'Query', campaigns: { __typename?: 'CampaignCollection', collection: Array<{ __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, reviewsCount: number, canShow: boolean, canInsert: boolean, canDestroy: boolean }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type UpdateCompanyVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompany = { __typename?: 'Mutation', updateCompany?: { __typename?: 'UpdateCompanyPayload', company: { __typename?: 'Company', id: string, name: string, visualIdentity?: string | null | undefined, theme?: { __typename?: 'Theme', primary: string, secondary: string } | null | undefined } } | null | undefined };

export type GetCredentialVariables = Exact<{ [key: string]: never; }>;


export type GetCredential = { __typename?: 'Query', credential?: { __typename?: 'Credential', accessToken: string, uid: string, tokenType: string, client: string, expiry: number } | null | undefined };

export type DeleteGroupVariables = Exact<{
  input: DeleteGroupInput;
}>;


export type DeleteGroup = { __typename?: 'Mutation', deleteGroup?: { __typename?: 'DeleteGroupPayload', id?: string | null | undefined } | null | undefined };

export type InsertGroupVariables = Exact<{
  input: InsertGroupInput;
}>;


export type InsertGroup = { __typename?: 'Mutation', insertGroup?: { __typename?: 'InsertGroupPayload', group: { __typename?: 'Group', id: string } } | null | undefined };

export type GetGroupVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetGroup = { __typename?: 'Query', group: { __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> } };

export type GetGroupsVariables = Exact<{
  sortBy?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  createdAfter?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
}>;


export type GetGroups = { __typename?: 'Query', groups: { __typename?: 'GroupCollection', collection: Array<{ __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type InsertProfessionSkillVariables = Exact<{
  input: InsertProfessionSkillInput;
}>;


export type InsertProfessionSkill = { __typename?: 'Mutation', insertProfessionSkill?: { __typename?: 'InsertProfessionSkillPayload', professionSkill: { __typename?: 'ProfessionSkill', id: string, profession: { __typename?: 'Profession', id: string, name: string, locale: string, canInsert: boolean, canDestroy: boolean, skills: Array<{ __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean }> }, skill: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } } } | null | undefined };

export type DeleteProfessionSkillVariables = Exact<{
  input: DeleteProfessionSkillInput;
}>;


export type DeleteProfessionSkill = { __typename?: 'Mutation', deleteProfessionSkill?: { __typename?: 'DeleteProfessionSkillPayload', id?: string | null | undefined } | null | undefined };

export type InsertProfessionVariables = Exact<{
  input: InsertProfessionInput;
}>;


export type InsertProfession = { __typename?: 'Mutation', insertProfession?: { __typename?: 'InsertProfessionPayload', profession: { __typename?: 'Profession', id: string, name: string, locale: string, canInsert: boolean, canDestroy: boolean, skills: Array<{ __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean }> } } | null | undefined };

export type DeleteProfessionVariables = Exact<{
  input: DeleteProfessionInput;
}>;


export type DeleteProfession = { __typename?: 'Mutation', deleteProfession?: { __typename?: 'DeleteProfessionPayload', id: string } | null | undefined };

export type GetProfessionsVariables = Exact<{
  q?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
}>;


export type GetProfessions = { __typename?: 'Query', professions: { __typename?: 'ProfessionCollection', collection: Array<{ __typename?: 'Profession', id: string, name: string, locale: string, canInsert: boolean, canDestroy: boolean, skills: Array<{ __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean }> }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type CreateQuestionVariables = Exact<{
  input: CreateQuestionInput;
}>;


export type CreateQuestion = { __typename?: 'Mutation', createQuestion?: { __typename?: 'CreateQuestionPayload', question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined } } | null | undefined };

export type GetQuestionsVariables = Exact<{
  sectionId?: Maybe<Scalars['ID']>;
  sectionIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  sectionIdsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  notSectionIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  distinctByDigest?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['ID']>;
  companyIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  companyIdsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  notCompanyIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  skillId?: Maybe<Scalars['ID']>;
  skillIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  skillIdsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  notSkillIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  templateId?: Maybe<Scalars['ID']>;
  templateIdsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  templateIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  notTemplateIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  reviewId?: Maybe<Scalars['ID']>;
  reviewIdsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  reviewIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  notReviewIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  havingAnswers?: Maybe<Scalars['Boolean']>;
  answerId?: Maybe<Scalars['ID']>;
  answerIdsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  answerIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  notAnswerIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdAfterIncluding?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  createdBeforeIncluding?: Maybe<Scalars['String']>;
  updatedAfter?: Maybe<Scalars['String']>;
  updatedAfterIncluding?: Maybe<Scalars['String']>;
  updatedBefore?: Maybe<Scalars['String']>;
  updatedBeforeIncluding?: Maybe<Scalars['String']>;
  orderEqual?: Maybe<Scalars['Int']>;
  orderLessThan?: Maybe<Scalars['Int']>;
  orderLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  orderGreaterThan?: Maybe<Scalars['Int']>;
  orderGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  expectedTimeValueEqual?: Maybe<Scalars['Int']>;
  expectedTimeValueLessThan?: Maybe<Scalars['Int']>;
  expectedTimeValueLessThanOrEqualTo?: Maybe<Scalars['Int']>;
  expectedTimeValueGreaterThan?: Maybe<Scalars['Int']>;
  expectedTimeValueGreaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  areTimeTracked?: Maybe<Scalars['Boolean']>;
  areNotTimeTracked?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  notLabel?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  type?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  notType?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  reportTypes?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  notReportTypes?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  digest?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  notDigest?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  expectedTimeUnit?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  notExpectedTimeUnit?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  idsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  notIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  direction?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
}>;


export type GetQuestions = { __typename?: 'Query', questions: { __typename?: 'QuestionCollection', collection: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, type: QuestionTypeEnum, digest: string, options?: any | null | undefined }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number } } };

export type CreateReportVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReport = { __typename?: 'Mutation', createReport?: { __typename?: 'CreateReportPayload', report: { __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined } } | null | undefined };

export type DeleteReportVariables = Exact<{
  input: DeleteReportInput;
}>;


export type DeleteReport = { __typename?: 'Mutation', deleteReport?: { __typename?: 'DeleteReportPayload', id: string } | null | undefined };

export type FillReferentReportVariables = Exact<{
  input: FillReferentReportInput;
}>;


export type FillReferentReport = { __typename?: 'Mutation', fillReferentReport?: { __typename?: 'FillReferentReportPayload', report: { __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined } } | null | undefined };

export type FillReportVariables = Exact<{
  input: FillReportInput;
}>;


export type FillReport = { __typename?: 'Mutation', fillReport?: { __typename?: 'FillReportPayload', report: { __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined } } | null | undefined };

export type SignReportVariables = Exact<{
  input: SignReportInput;
}>;


export type SignReport = { __typename?: 'Mutation', signReport?: { __typename?: 'SignReportPayload', report: { __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined } } | null | undefined };

export type UpdateReportVariables = Exact<{
  input: UpdateReportInput;
}>;


export type UpdateReport = { __typename?: 'Mutation', updateReport?: { __typename?: 'UpdateReportPayload', report: { __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined } } | null | undefined };

export type GetReportVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetReport = { __typename?: 'Query', report: { __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined } };

export type GetReportsVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  createdAfter?: Maybe<Scalars['String']>;
  reviewId?: Maybe<Scalars['ID']>;
  lastCheckedAt?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
}>;


export type GetReports = { __typename?: 'Query', reports: { __typename?: 'ReportCollection', collection: Array<{ __typename?: 'Report', id: string, type: ReportTypeEnum, updatedAt: string, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, document?: string | null | undefined, canDestroy: boolean, canUpdate: boolean, canSign: boolean, canReset: boolean, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, review: { __typename?: 'Review', id: string, referentIds: Array<string>, templateId: string, campaignId: string, collaboratorId?: string | null | undefined, allowTemplateUpdateByCollaborator: boolean, reportsCount: number, lastCheckedReport?: { __typename?: 'Report', answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, skillId?: string | null | undefined, type: AnswerTypeEnum, updatedAt: string, createdAt: string, isCollaborator: boolean, isDraft: boolean, normalizedRating?: number | null | undefined, reportId?: string | null | undefined, userId: string, value?: any | null | undefined, timeSpent?: number | null | undefined, isEmpty: boolean, canDestroy: boolean, question: { __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> } | null | undefined, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } }, template?: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } | null | undefined }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type GetReportsMinimalVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  createdAfter?: Maybe<Scalars['String']>;
  reviewId?: Maybe<Scalars['ID']>;
  lastCheckedAt?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
}>;


export type GetReportsMinimal = { __typename?: 'Query', reports: { __typename?: 'ReportCollection', collection: Array<{ __typename?: 'Report', id: string, updatedAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, review: { __typename?: 'Review', collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined }, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }> }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type InsertReviewVariables = Exact<{
  input: InsertReviewInput;
}>;


export type InsertReview = { __typename?: 'Mutation', insertReview?: { __typename?: 'InsertReviewPayload', review: { __typename?: 'Review', id: string, description?: string | null | undefined, createdAt: string, startDate: string, endDate?: string | null | undefined, schedule?: string | null | undefined, nextReportAt?: string | null | undefined, canAddDocument: boolean, canDeleteDocument: boolean, canInsert: boolean, canDestroy: boolean, referentIds: Array<string>, reminderEnabled: boolean, reminderGap: number, allowTemplateUpdateByCollaborator: boolean, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string }, template: { __typename?: 'Template', id: string, slug: string, title: string, sections: Array<{ __typename?: 'Section', questions: Array<{ __typename?: 'Question', type: QuestionTypeEnum, label: string }> }> }, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, lastCheckedReport?: { __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined } | null | undefined, reports: Array<{ __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined }>, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }> } } | null | undefined };

export type DeleteReviewVariables = Exact<{
  input: DeleteReviewInput;
}>;


export type DeleteReview = { __typename?: 'Mutation', deleteReview?: { __typename?: 'DeleteReviewPayload', id: string } | null | undefined };

export type AddReviewDocumentVariables = Exact<{
  input: AddReviewDocumentInput;
}>;


export type AddReviewDocument = { __typename?: 'Mutation', addReviewDocument?: { __typename?: 'AddReviewDocumentPayload', document: { __typename?: 'Document', id: string, url: string } } | null | undefined };

export type DeleteReviewDocumentVariables = Exact<{
  input: DeleteReviewDocumentInput;
}>;


export type DeleteReviewDocument = { __typename?: 'Mutation', deleteReviewDocument?: { __typename?: 'DeleteReviewDocumentPayload', id: string } | null | undefined };

export type GetReviewVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetReview = { __typename?: 'Query', review: { __typename?: 'Review', id: string, description?: string | null | undefined, createdAt: string, startDate: string, endDate?: string | null | undefined, schedule?: string | null | undefined, nextReportAt?: string | null | undefined, canAddDocument: boolean, canDeleteDocument: boolean, canInsert: boolean, canDestroy: boolean, referentIds: Array<string>, reminderEnabled: boolean, reminderGap: number, allowTemplateUpdateByCollaborator: boolean, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string }, template: { __typename?: 'Template', id: string, slug: string, title: string, sections: Array<{ __typename?: 'Section', questions: Array<{ __typename?: 'Question', type: QuestionTypeEnum, label: string }> }> }, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, lastCheckedReport?: { __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined } | null | undefined, reports: Array<{ __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined }>, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }> } };

export type GetReviewFullVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetReviewFull = { __typename?: 'Query', review: { __typename?: 'Review', id: string, createdAt: string, updatedAt: string, startDate: string, endDate?: string | null | undefined, nextReportAt?: string | null | undefined, description?: string | null | undefined, schedule?: string | null | undefined, canAddDocument: boolean, canDeleteDocument: boolean, canInsert: boolean, canDestroy: boolean, referentIds: Array<string>, reminderEnabled: boolean, reminderGap: number, allowTemplateUpdateByCollaborator: boolean, template: { __typename?: 'Template', id: string, slug: string, title: string, sections: Array<{ __typename?: 'Section', questions: Array<{ __typename?: 'Question', type: QuestionTypeEnum, label: string }> }> }, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string }, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, lastCheckedReport?: { __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined } | null | undefined, reports: Array<{ __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined, reportReferents: Array<{ __typename?: 'ReportReferent', id: string, filledAt?: string | null | undefined, createdAt: string, updatedAt: string, referent: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, answers: Array<{ __typename?: 'Answer', id: string, questionId: string, questionDigest: string, createdAt: string, updatedAt: string, type: AnswerTypeEnum, normalizedRating?: number | null | undefined, canDestroy: boolean, timeSpent?: number | null | undefined, isCollaborator: boolean, isEmpty: boolean, reportId?: string | null | undefined, value?: any | null | undefined, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, report?: { __typename?: 'Report', createdAt: string, checkedAt?: string | null | undefined } | null | undefined, collaborator: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }, question: { __typename?: 'Question', id: string, label: string, type: QuestionTypeEnum, digest: string, visibility: QuestionVisibility, required: boolean, options?: any | null | undefined, expectedTimeValue?: number | null | undefined, skill?: { __typename?: 'Skill', id: string, name: string } | null | undefined } }> }> } };

export type GetReviewsVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  direction?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  sortBy?: Maybe<Scalars['String']>;
}>;


export type GetReviews = { __typename?: 'Query', reviews: { __typename?: 'ReviewCollection', collection: Array<{ __typename?: 'Review', id: string, description?: string | null | undefined, createdAt: string, startDate: string, endDate?: string | null | undefined, schedule?: string | null | undefined, nextReportAt?: string | null | undefined, canAddDocument: boolean, canDeleteDocument: boolean, canInsert: boolean, canDestroy: boolean, referentIds: Array<string>, reminderEnabled: boolean, reminderGap: number, allowTemplateUpdateByCollaborator: boolean, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string }, template: { __typename?: 'Template', id: string, slug: string, title: string, sections: Array<{ __typename?: 'Section', questions: Array<{ __typename?: 'Question', type: QuestionTypeEnum, label: string }> }> }, referents: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined, reviewSupervisors: Array<{ __typename?: 'ReviewSupervisor', id: string, emailNotificationsEnabled: boolean, user: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } }>, lastCheckedReport?: { __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined } | null | undefined, reports: Array<{ __typename?: 'Report', id: string, type: ReportTypeEnum, createdAt: string, filledAt?: string | null | undefined, checkedAt?: string | null | undefined, docusignEnvelopeStatus?: DocusignEnvelopeStatusEnum | null | undefined }>, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }> }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type InsertSkillVariables = Exact<{
  input: InsertSkillInput;
}>;


export type InsertSkill = { __typename?: 'Mutation', insertSkill?: { __typename?: 'InsertSkillPayload', skill: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } } | null | undefined };

export type DeleteSkillVariables = Exact<{
  input: DeleteSkillInput;
}>;


export type DeleteSkill = { __typename?: 'Mutation', deleteSkill?: { __typename?: 'DeleteSkillPayload', id: string } | null | undefined };

export type GetSkillMappingsVariables = Exact<{
  q?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  havingAnswers?: Maybe<Scalars['Boolean']>;
  ids?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetSkillMappings = { __typename?: 'Query', skills: { __typename?: 'SkillCollection', collection: Array<{ __typename?: 'Skill', id: string, name: string }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type GetSkillsVariables = Exact<{
  q?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  idsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetSkills = { __typename?: 'Query', skills: { __typename?: 'SkillCollection', collection: Array<{ __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean }> } };

export type GetSkillsWithProfessionsVariables = Exact<{
  q?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
}>;


export type GetSkillsWithProfessions = { __typename?: 'Query', skills: { __typename?: 'SkillCollection', collection: Array<{ __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean, professions: Array<{ __typename?: 'Profession', id: string, name: string, locale: string, canInsert: boolean, canDestroy: boolean, skills: Array<{ __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean }> }>, collaborators: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type InsertTemplateVariables = Exact<{
  input: InsertTemplateInput;
}>;


export type InsertTemplate = { __typename?: 'Mutation', insertTemplate?: { __typename?: 'InsertTemplatePayload', template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } } | null | undefined };

export type DeleteTemplateVariables = Exact<{
  input: DeleteTemplateInput;
}>;


export type DeleteTemplate = { __typename?: 'Mutation', deleteTemplate?: { __typename?: 'DeleteTemplatePayload', id: string } | null | undefined };

export type GetTemplateVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTemplate = { __typename?: 'Query', template: { __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> } };

export type GetTemplatesVariables = Exact<{
  reviewId?: Maybe<Scalars['ID']>;
  q?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  areFavorite?: Maybe<Scalars['Boolean']>;
}>;


export type GetTemplates = { __typename?: 'Query', templates: { __typename?: 'TemplateCollection', collection: Array<{ __typename?: 'Template', id: string, slug: string, createdAt: string, updatedAt: string, favorite: boolean, title: string, canInsert: boolean, canDestroy: boolean, sections: Array<{ __typename?: 'Section', id: string, title?: string | null | undefined, description?: string | null | undefined, order: number, questions: Array<{ __typename?: 'Question', id: string, label: string, description?: string | null | undefined, order: number, reportTypes: Array<ReportTypeEnum>, defaultValue?: any | null | undefined, defaultValueSchema?: string | null | undefined, options?: any | null | undefined, optionsSchema?: string | null | undefined, timeTracked?: boolean | null | undefined, visibility: QuestionVisibility, type: QuestionTypeEnum, digest: string, skillId?: string | null | undefined, expectedTimeValue?: number | null | undefined, expectedTimeUnit?: ExpectedTimeUnitEnum | null | undefined, required: boolean, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, skill?: { __typename?: 'Skill', id: string, kind?: SkillKindEnum | null | undefined, locale: string, name: string, updatedAt: string, createdAt: string, canInsert: boolean, canDestroy: boolean } | null | undefined }> }> }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type InsertTranslationVariables = Exact<{
  input: InsertTranslationInput;
}>;


export type InsertTranslation = { __typename?: 'Mutation', insertTranslation?: { __typename?: 'InsertTranslationPayload', translation: { __typename?: 'Translation', id: string, key: string, value: string, locale: string } } | null | undefined };

export type DeleteAvatarVariables = Exact<{
  input: DeleteAvatarInput;
}>;


export type DeleteAvatar = { __typename?: 'Mutation', deleteAvatar?: { __typename?: 'DeleteAvatarPayload', user: { __typename?: 'User', id: string, avatar?: string | null | undefined } } | null | undefined };

export type DeleteCredentialVariables = Exact<{ [key: string]: never; }>;


export type DeleteCredential = { __typename?: 'Mutation', deleteCredential?: string | null | undefined };

export type InsertUserVariables = Exact<{
  input: InsertUserInput;
}>;


export type InsertUser = { __typename?: 'Mutation', insertUser?: { __typename?: 'InsertUserPayload', user: { __typename?: 'User', isCapableOfCreatingStandaloneAnswers: boolean, isCapableOfCreatingStandaloneQuestions: boolean, isCapableOfDeletingAllAnswers: boolean, isCapableOfDeletingCampaigns: boolean, isCapableOfDeletingGroups: boolean, isCapableOfDeletingReviews: boolean, isCapableOfDeletingTemplates: boolean, isCapableOfInsertingCampaigns: boolean, isCapableOfInsertingGroups: boolean, isCapableOfInsertingProfessionSkills: boolean, isCapableOfInsertingProfessions: boolean, isCapableOfInsertingReviews: boolean, isCapableOfInsertingSkills: boolean, isCapableOfInsertingTemplates: boolean, isCapableOfInsertingTranslations: boolean, isCapableOfInsertingUsers: boolean, isCapableOfReadingActivities: boolean, isCapableOfReadingActivitiesIps: boolean, isCapableOfReadingAllReviews: boolean, isCapableOfReadingCampaigns: boolean, isCapableOfReadingGroups: boolean, isCapableOfReadingSkills: boolean, isCapableOfReadingQuestions: boolean, isCapableOfReadingReviews: boolean, isCapableOfReadingStandaloneAnswers: boolean, isCapableOfReadingStandaloneQuestions: boolean, isCapableOfReadingTemplates: boolean, isCapableOfReadingUserDocuments: boolean, isCapableOfReadingUserNotes: boolean, isCapableOfReadingUsers: boolean, isCapableOfSigningReports: boolean, isCapableOfUpdatingCompanies: boolean, isCapableOfUpdatingUserCapabilities: boolean, isCapableOfUpdatingUserNotes: boolean, id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } } | null | undefined };

export type SendConnectionLinkVariables = Exact<{
  input: SendConnectionLinkInput;
}>;


export type SendConnectionLink = { __typename?: 'Mutation', sendConnectionLink?: { __typename?: 'SendConnectionLinkPayload', success: boolean } | null | undefined };

export type SetCredentialVariables = Exact<{
  accessToken: Scalars['String'];
  tokenType: Scalars['String'];
  client: Scalars['String'];
  expiry: Scalars['Int'];
  uid?: Maybe<Scalars['String']>;
}>;


export type SetCredential = { __typename?: 'Mutation', setCredential?: string | null | undefined };

export type UserLoginVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type UserLogin = { __typename?: 'Mutation', userLogin?: { __typename?: 'UserLoginPayload', credentials: { __typename?: 'Credential', accessToken: string, uid: string, tokenType: string, client: string, expiry: number } } | null | undefined };

export type UserSendPasswordResetVariables = Exact<{
  email: Scalars['String'];
  redirectUrl: Scalars['String'];
}>;


export type UserSendPasswordReset = { __typename?: 'Mutation', userSendPasswordReset?: { __typename?: 'UserSendPasswordResetPayload', message: string } | null | undefined };

export type UserUpdatePasswordVariables = Exact<{
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  currentPassword?: Maybe<Scalars['String']>;
}>;


export type UserUpdatePassword = { __typename?: 'Mutation', userUpdatePassword?: { __typename?: 'UserUpdatePasswordPayload', authenticatable: { __typename?: 'User', id: string } } | null | undefined };

export type AddUserDocumentVariables = Exact<{
  input: AddUserDocumentInput;
}>;


export type AddUserDocument = { __typename?: 'Mutation', addUserDocument?: { __typename?: 'AddUserDocumentPayload', document: { __typename?: 'Document', id: string, url: string } } | null | undefined };

export type DeleteUserDocumentVariables = Exact<{
  input: DeleteUserDocumentInput;
}>;


export type DeleteUserDocument = { __typename?: 'Mutation', deleteUserDocument?: { __typename?: 'DeleteUserDocumentPayload', id: string } | null | undefined };

export type GetUserVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUser = { __typename?: 'Query', user: { __typename?: 'User', id: string, slug: string, name: string, avatar?: string | null | undefined, email: string, locale?: string | null | undefined, enabled: boolean, notes?: string | null | undefined, canAddDocument: boolean, canInsert: boolean, isCapableOfCreatingStandaloneAnswers: boolean, isCapableOfCreatingStandaloneQuestions: boolean, isCapableOfDeletingAllAnswers: boolean, isCapableOfDeletingCampaigns: boolean, isCapableOfDeletingGroups: boolean, isCapableOfDeletingReviews: boolean, isCapableOfDeletingTemplates: boolean, isCapableOfInsertingCampaigns: boolean, isCapableOfInsertingGroups: boolean, isCapableOfInsertingProfessionSkills: boolean, isCapableOfInsertingProfessions: boolean, isCapableOfInsertingReviews: boolean, isCapableOfInsertingSkills: boolean, isCapableOfDeletingProfessions: boolean, isCapableOfDeletingSkills: boolean, isCapableOfInsertingTemplates: boolean, isCapableOfInsertingTranslations: boolean, isCapableOfInsertingUsers: boolean, isCapableOfReadingActivities: boolean, isCapableOfReadingActivitiesIps: boolean, isCapableOfReadingAllReviews: boolean, isCapableOfReadingCampaigns: boolean, isCapableOfReadingGroups: boolean, isCapableOfReadingSkills: boolean, isCapableOfReadingQuestions: boolean, isCapableOfReadingReviews: boolean, isCapableOfReadingStandaloneAnswers: boolean, isCapableOfReadingStandaloneQuestions: boolean, isCapableOfReadingTemplates: boolean, isCapableOfReadingUserDocuments: boolean, isCapableOfReadingUserNotes: boolean, isCapableOfManagingReports: boolean, isCapableOfReadingUsers: boolean, isCapableOfSigningReports: boolean, isCapableOfUpdatingCompanies: boolean, isCapableOfUpdatingUserCapabilities: boolean, isCapableOfUpdatingUserNotes: boolean, createdAt: string, documents: Array<{ __typename?: 'Document', filename: string, id: string, blobId: number, url: string }>, company: { __typename?: 'Company', id: string, name: string }, groups: Array<{ __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> }>, reviewsAsCollaborator: Array<{ __typename?: 'Review', id: string, endDate?: string | null | undefined, startDate: string, referentIds: Array<string>, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number }, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined }>, reviewsAsReferent: Array<{ __typename?: 'Review', id: string, endDate?: string | null | undefined, startDate: string, referentIds: Array<string>, campaign: { __typename?: 'Campaign', id: string, slug: string, name: string, description?: string | null | undefined, canShow: boolean, canInsert: boolean, canDestroy: boolean, reviewsCount: number, reminderGap?: number | null | undefined, reminderEnabled?: boolean | null | undefined, unfilledReportsCount: number, openReportsCount: number, reportsCount: number }, collaborator?: { __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean } | null | undefined }> } };

export type GetUsersVariables = Exact<{
  companyId?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  idsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  notIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  q?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
  skillId?: Maybe<Scalars['ID']>;
  direction?: Maybe<Scalars['String']>;
  havingAnswersMatching?: Maybe<Array<AnswerMatchingInput> | AnswerMatchingInput>;
}>;


export type GetUsers = { __typename?: 'Query', users: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string, slug: string, email: string, name: string, notes?: string | null | undefined, avatar?: string | null | undefined, canShow: boolean, canAddDocument: boolean, canInsert: boolean, createdAt: string, groups: Array<{ __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> }> }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type GetUsersMinimalVariables = Exact<{
  companyId?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  idsStrict?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  notIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  q?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
  per?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
  skillId?: Maybe<Scalars['ID']>;
  direction?: Maybe<Scalars['String']>;
  havingAnswersMatching?: Maybe<Array<AnswerMatchingInput> | AnswerMatchingInput>;
}>;


export type GetUsersMinimal = { __typename?: 'Query', users: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string, slug: string, email: string, name: string, notes?: string | null | undefined, avatar?: string | null | undefined, canShow: boolean, canAddDocument: boolean, canInsert: boolean, createdAt: string, groups: Array<{ __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number, description?: string | null | undefined, canInsert: boolean, canDestroy: boolean, canShow: boolean, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }> }> }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type GetPublicUserVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetPublicUser = { __typename?: 'Query', publicUser?: { __typename?: 'PublicUser', email: string, samlRedirectUrl?: string | null | undefined } | null | undefined };

export type GetViewerVariables = Exact<{ [key: string]: never; }>;


export type GetViewer = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id: string, slug: string, name: string, locale: string, companyId: string, createdAt: string, email: string, avatar?: string | null | undefined, isCapableOfCreatingStandaloneAnswers: boolean, isCapableOfCreatingStandaloneQuestions: boolean, isCapableOfDeletingAllAnswers: boolean, isCapableOfDeletingCampaigns: boolean, isCapableOfDeletingGroups: boolean, isCapableOfDeletingReviews: boolean, isCapableOfDeletingTemplates: boolean, isCapableOfInsertingCampaigns: boolean, isCapableOfInsertingGroups: boolean, isCapableOfInsertingProfessionSkills: boolean, isCapableOfInsertingProfessions: boolean, isCapableOfInsertingReviews: boolean, isCapableOfInsertingSkills: boolean, isCapableOfInsertingTemplates: boolean, isCapableOfInsertingTranslations: boolean, isCapableOfInsertingUsers: boolean, isCapableOfReadingActivities: boolean, isCapableOfReadingActivitiesIps: boolean, isCapableOfReadingAllReviews: boolean, isCapableOfReadingCampaigns: boolean, isCapableOfReadingGroups: boolean, isCapableOfReadingSkills: boolean, isCapableOfReadingQuestions: boolean, isCapableOfReadingReviews: boolean, isCapableOfReadingStandaloneAnswers: boolean, isCapableOfReadingStandaloneQuestions: boolean, isCapableOfReadingTemplates: boolean, isCapableOfReadingUserDocuments: boolean, isCapableOfReadingUserNotes: boolean, isCapableOfReadingUsers: boolean, isCapableOfSigningReports: boolean, isCapableOfManagingReports: boolean, isCapableOfUpdatingCompanies: boolean, isCapableOfUpdatingUserCapabilities: boolean, isCapableOfUpdatingUserNotes: boolean, company: { __typename?: 'Company', id: string, name: string, locale?: string | null | undefined, reminderEnabled: boolean, reminderGap?: number | null | undefined, reportSigningEnabled: boolean, customTranslationsEnabled: boolean, inlineTemplateUpdateEnabled: boolean, usersCount: number, visualIdentity?: string | null | undefined, questionOptionsConfigurations: Array<{ __typename?: 'QuestionOptionsConfiguration', id: string, locale?: string | null | undefined, skillQuestionOptionsConfiguration?: any | null | undefined, evaluationQuestionOptionsConfiguration?: any | null | undefined }>, users: Array<{ __typename?: 'User', id: string, slug: string, name: string, email: string, avatar?: string | null | undefined, enabled: boolean }>, translations: Array<{ __typename?: 'Translation', id: string, key: string, value: string, locale: string }>, campaigns: Array<{ __typename?: 'Campaign', id: string, slug: string, name: string }>, groups: Array<{ __typename?: 'Group', id: string, kind: GroupKindEnum, name: string, usersCount: number }>, theme?: { __typename?: 'Theme', primary: string, secondary: string } | null | undefined } } };

export const UserMinimalFragment = gql`
    fragment UserMinimalFragment on User {
  id
  slug
  name
  email
  avatar
  enabled
}
    `;
export const CompanyMinimalFragment = gql`
    fragment CompanyMinimalFragment on Company {
  id
  name
  visualIdentity
  theme {
    primary
    secondary
  }
}
    `;
export const ActivityReviewFragment = gql`
    fragment ActivityReviewFragment on Review {
  id
  collaborator {
    id
    name
    slug
  }
  campaign {
    id
    name
  }
}
    `;
export const CampaignSummaryFragment = gql`
    fragment CampaignSummaryFragment on Campaign {
  id
  slug
  name
  description
  canShow
  canInsert
  canDestroy
  reviewsCount
  reminderGap
  reminderEnabled
  unfilledReportsCount
  openReportsCount
  reportsCount
}
    `;
export const DocumentFragment = gql`
    fragment DocumentFragment on Document {
  filename
  id
  blobId
  url
}
    `;
export const SkillFragment = gql`
    fragment SkillFragment on Skill {
  id
  kind
  locale
  name
  updatedAt
  createdAt
  canInsert
  canDestroy
}
    `;
export const QuestionFragment = gql`
    fragment QuestionFragment on Question {
  id
  label
  description
  order
  reportTypes
  defaultValue
  defaultValueSchema
  options
  optionsSchema
  timeTracked
  visibility
  type
  digest
  skillId
  expectedTimeValue
  expectedTimeUnit
  required
  documents {
    ...DocumentFragment
  }
  skill {
    ...SkillFragment
  }
}
    ${DocumentFragment}
${SkillFragment}`;
export const SectionFragment = gql`
    fragment SectionFragment on Section {
  id
  title
  description
  order
  questions {
    ...QuestionFragment
  }
}
    ${QuestionFragment}`;
export const TemplateFragment = gql`
    fragment TemplateFragment on Template {
  id
  slug
  createdAt
  updatedAt
  favorite
  title
  canInsert
  canDestroy
  sections {
    ...SectionFragment
  }
}
    ${SectionFragment}`;
export const AnswerFragment = gql`
    fragment AnswerFragment on Answer {
  id
  questionId
  questionDigest
  question {
    ...QuestionFragment
  }
  skillId
  type
  updatedAt
  createdAt
  isCollaborator
  isDraft
  normalizedRating
  reportId
  report {
    createdAt
    checkedAt
  }
  userId
  user {
    ...UserMinimalFragment
  }
  collaborator {
    ...UserMinimalFragment
  }
  value
  timeSpent
  isEmpty
  canDestroy
}
    ${QuestionFragment}
${UserMinimalFragment}`;
export const ReportReferentFragment = gql`
    fragment ReportReferentFragment on ReportReferent {
  id
  filledAt
  referent {
    ...UserMinimalFragment
  }
  createdAt
  updatedAt
}
    ${UserMinimalFragment}`;
export const ReviewSupervisorFragment = gql`
    fragment ReviewSupervisorFragment on ReviewSupervisor {
  id
  emailNotificationsEnabled
  user {
    ...UserMinimalFragment
  }
}
    ${UserMinimalFragment}`;
export const ReportReviewFragment = gql`
    fragment ReportReviewFragment on Review {
  id
  referentIds
  templateId
  campaignId
  collaboratorId
  allowTemplateUpdateByCollaborator
  reportsCount
  lastCheckedReport {
    answers {
      ...AnswerFragment
    }
  }
  collaborator {
    ...UserMinimalFragment
  }
  referents {
    ...UserMinimalFragment
  }
  reviewSupervisors {
    ...ReviewSupervisorFragment
  }
  template {
    ...TemplateFragment
  }
}
    ${AnswerFragment}
${UserMinimalFragment}
${ReviewSupervisorFragment}
${TemplateFragment}`;
export const ReportFragment = gql`
    fragment ReportFragment on Report {
  id
  type
  updatedAt
  createdAt
  filledAt
  checkedAt
  docusignEnvelopeStatus
  document
  canDestroy
  canUpdate
  canSign
  canReset
  answers {
    ...AnswerFragment
  }
  reportReferents {
    ...ReportReferentFragment
  }
  review {
    ...ReportReviewFragment
  }
  template {
    ...TemplateFragment
  }
}
    ${AnswerFragment}
${ReportReferentFragment}
${ReportReviewFragment}
${TemplateFragment}`;
export const GroupFragment = gql`
    fragment GroupFragment on Group {
  id
  kind
  name
  usersCount
  description
  canInsert
  canDestroy
  canShow
  users {
    ...UserMinimalFragment
  }
}
    ${UserMinimalFragment}`;
export const ActivityFragment = gql`
    fragment ActivityFragment on Activity {
  id
  key
  createdAt
  updatedAt
  owner {
    ...UserMinimalFragment
  }
  recipientType
  recipient {
    ... on Company {
      ...CompanyMinimalFragment
    }
    ... on Review {
      ...ActivityReviewFragment
    }
    ... on Campaign {
      ...CampaignSummaryFragment
    }
  }
  trackableType
  trackable {
    ... on Company {
      ...CompanyMinimalFragment
    }
    ... on User {
      ...UserMinimalFragment
    }
    ... on Review {
      ...ActivityReviewFragment
    }
    ... on Campaign {
      ...CampaignSummaryFragment
    }
    ... on Template {
      ...TemplateFragment
    }
    ... on Report {
      ...ReportFragment
    }
    ... on Group {
      ...GroupFragment
    }
  }
}
    ${UserMinimalFragment}
${CompanyMinimalFragment}
${ActivityReviewFragment}
${CampaignSummaryFragment}
${TemplateFragment}
${ReportFragment}
${GroupFragment}`;
export const AnswerForMappingFragment = gql`
    fragment AnswerForMappingFragment on Answer {
  questionDigest
  selector
  collaboratorId
}
    `;
export const QuestionSummaryFragment = gql`
    fragment QuestionSummaryFragment on Question {
  id
  label
  type
  digest
  visibility
  required
  skill {
    id
    name
  }
  options
  expectedTimeValue
}
    `;
export const AnswerHistoryFragment = gql`
    fragment AnswerHistoryFragment on Answer {
  id
  questionId
  questionDigest
  createdAt
  updatedAt
  type
  user {
    ...UserMinimalFragment
  }
  report {
    createdAt
    checkedAt
  }
  collaborator {
    ...UserMinimalFragment
  }
  timeSpent
  isCollaborator
  isDraft
  userId
  canDestroy
  isEmpty
  reportId
  value
  question {
    ...QuestionSummaryFragment
  }
}
    ${UserMinimalFragment}
${QuestionSummaryFragment}`;
export const CampaignListingFragment = gql`
    fragment CampaignListingFragment on Campaign {
  id
  slug
  name
  description
  reviewsCount
  canShow
  canInsert
  canDestroy
}
    `;
export const CollectionMetadataFragment = gql`
    fragment CollectionMetadataFragment on CollectionMetadata {
  totalPages
  totalCount
  currentPage
  limitValue
}
    `;
export const CredentialFragment = gql`
    fragment CredentialFragment on Credential {
  accessToken
  uid
  tokenType
  client
  expiry
}
    `;
export const ProfessionFragment = gql`
    fragment ProfessionFragment on Profession {
  id
  name
  locale
  canInsert
  canDestroy
  skills {
    ...SkillFragment
  }
}
    ${SkillFragment}`;
export const ProfessionSkillFragment = gql`
    fragment ProfessionSkillFragment on ProfessionSkill {
  id
  profession {
    ...ProfessionFragment
  }
  skill {
    ...SkillFragment
  }
}
    ${ProfessionFragment}
${SkillFragment}`;
export const QuestionMinimalFragment = gql`
    fragment QuestionMinimalFragment on Question {
  id
  label
  description
  type
  digest
  options
}
    `;
export const ReportMinimalFragment = gql`
    fragment ReportMinimalFragment on Report {
  id
  updatedAt
  filledAt
  checkedAt
  review {
    collaborator {
      ...UserMinimalFragment
    }
  }
  reportReferents {
    ...ReportReferentFragment
  }
}
    ${UserMinimalFragment}
${ReportReferentFragment}`;
export const CampaignMinimalFragment = gql`
    fragment CampaignMinimalFragment on Campaign {
  id
  slug
  name
}
    `;
export const TemplateMinimalFragment = gql`
    fragment TemplateMinimalFragment on Template {
  id
  slug
  title
  sections {
    questions {
      type
      label
    }
  }
}
    `;
export const ReviewReportFragment = gql`
    fragment ReviewReportFragment on Report {
  id
  type
  createdAt
  filledAt
  checkedAt
  docusignEnvelopeStatus
}
    `;
export const ReviewFragment = gql`
    fragment ReviewFragment on Review {
  id
  description
  createdAt
  startDate
  endDate
  schedule
  nextReportAt
  canAddDocument
  canDeleteDocument
  canInsert
  canDestroy
  referentIds
  reminderEnabled
  reminderGap
  allowTemplateUpdateByCollaborator
  campaign {
    ...CampaignMinimalFragment
  }
  template {
    ...TemplateMinimalFragment
  }
  referents {
    ...UserMinimalFragment
  }
  collaborator {
    ...UserMinimalFragment
  }
  reviewSupervisors {
    ...ReviewSupervisorFragment
  }
  lastCheckedReport {
    ...ReviewReportFragment
  }
  reports {
    ...ReviewReportFragment
  }
  documents {
    ...DocumentFragment
  }
}
    ${CampaignMinimalFragment}
${TemplateMinimalFragment}
${UserMinimalFragment}
${ReviewSupervisorFragment}
${ReviewReportFragment}
${DocumentFragment}`;
export const AnswerSummaryFragment = gql`
    fragment AnswerSummaryFragment on Answer {
  id
  questionId
  questionDigest
  createdAt
  updatedAt
  type
  normalizedRating
  canDestroy
  user {
    ...UserMinimalFragment
  }
  report {
    createdAt
    checkedAt
  }
  collaborator {
    ...UserMinimalFragment
  }
  timeSpent
  isCollaborator
  isEmpty
  reportId
  value
  question {
    ...QuestionSummaryFragment
  }
}
    ${UserMinimalFragment}
${QuestionSummaryFragment}`;
export const ReviewReportFullFragment = gql`
    fragment ReviewReportFullFragment on Report {
  id
  type
  createdAt
  filledAt
  checkedAt
  docusignEnvelopeStatus
  reportReferents {
    ...ReportReferentFragment
  }
  answers {
    ...AnswerSummaryFragment
  }
}
    ${ReportReferentFragment}
${AnswerSummaryFragment}`;
export const ReviewFullFragment = gql`
    fragment ReviewFullFragment on Review {
  id
  createdAt
  updatedAt
  startDate
  endDate
  nextReportAt
  description
  schedule
  canAddDocument
  canDeleteDocument
  canInsert
  canDestroy
  referentIds
  reminderEnabled
  reminderGap
  allowTemplateUpdateByCollaborator
  template {
    ...TemplateMinimalFragment
  }
  documents {
    ...DocumentFragment
  }
  collaborator {
    ...UserMinimalFragment
  }
  referents {
    ...UserMinimalFragment
  }
  campaign {
    ...CampaignMinimalFragment
  }
  reviewSupervisors {
    ...ReviewSupervisorFragment
  }
  lastCheckedReport {
    ...ReviewReportFragment
  }
  reports {
    ...ReviewReportFullFragment
  }
}
    ${TemplateMinimalFragment}
${DocumentFragment}
${UserMinimalFragment}
${CampaignMinimalFragment}
${ReviewSupervisorFragment}
${ReviewReportFragment}
${ReviewReportFullFragment}`;
export const SkillMappingFragment = gql`
    fragment SkillMappingFragment on Skill {
  id
  name
}
    `;
export const ReviewMinimalFragment = gql`
    fragment ReviewMinimalFragment on Review {
  id
  endDate
  startDate
  referentIds
  campaign {
    ...CampaignSummaryFragment
  }
  collaborator {
    ...UserMinimalFragment
  }
}
    ${CampaignSummaryFragment}
${UserMinimalFragment}`;
export const UserReviewFragment = gql`
    fragment UserReviewFragment on User {
  id
  slug
  name
  avatar
  email
  locale
  enabled
  notes
  canAddDocument
  canInsert
  isCapableOfCreatingStandaloneAnswers
  isCapableOfCreatingStandaloneQuestions
  isCapableOfDeletingAllAnswers
  isCapableOfDeletingCampaigns
  isCapableOfDeletingGroups
  isCapableOfDeletingReviews
  isCapableOfDeletingTemplates
  isCapableOfInsertingCampaigns
  isCapableOfInsertingGroups
  isCapableOfInsertingProfessionSkills
  isCapableOfInsertingProfessions
  isCapableOfInsertingReviews
  isCapableOfInsertingSkills
  isCapableOfDeletingProfessions
  isCapableOfDeletingSkills
  isCapableOfInsertingTemplates
  isCapableOfInsertingTranslations
  isCapableOfInsertingUsers
  isCapableOfReadingActivities
  isCapableOfReadingActivitiesIps
  isCapableOfReadingAllReviews
  isCapableOfReadingCampaigns
  isCapableOfReadingGroups
  isCapableOfReadingSkills
  isCapableOfReadingQuestions
  isCapableOfReadingReviews
  isCapableOfReadingStandaloneAnswers
  isCapableOfReadingStandaloneQuestions
  isCapableOfReadingTemplates
  isCapableOfReadingUserDocuments
  isCapableOfReadingUserNotes
  isCapableOfManagingReports
  isCapableOfReadingUsers
  isCapableOfSigningReports
  isCapableOfUpdatingCompanies
  isCapableOfUpdatingUserCapabilities
  isCapableOfUpdatingUserNotes
  documents {
    ...DocumentFragment
  }
  createdAt
  company {
    id
    name
  }
  groups {
    ...GroupFragment
  }
  reviewsAsCollaborator {
    ...ReviewMinimalFragment
  }
  reviewsAsReferent {
    ...ReviewMinimalFragment
  }
}
    ${DocumentFragment}
${GroupFragment}
${ReviewMinimalFragment}`;
export const UserSummaryFragment = gql`
    fragment UserSummaryFragment on User {
  id
  slug
  email
  name
  notes
  avatar
  canShow
  canAddDocument
  canInsert
  createdAt
  groups {
    ...GroupFragment
  }
}
    ${GroupFragment}`;
export const QuestionOptionsConfigurationFragment = gql`
    fragment QuestionOptionsConfigurationFragment on QuestionOptionsConfiguration {
  id
  locale
  skillQuestionOptionsConfiguration
  evaluationQuestionOptionsConfiguration
}
    `;
export const TranslationFragment = gql`
    fragment TranslationFragment on Translation {
  id
  key
  value
  locale
}
    `;
export const GroupMinimalFragment = gql`
    fragment GroupMinimalFragment on Group {
  id
  kind
  name
  usersCount
}
    `;
export const ThemeFragment = gql`
    fragment ThemeFragment on Theme {
  primary
  secondary
}
    `;
export const ViewerFragment = gql`
    fragment ViewerFragment on Viewer {
  id
  slug
  name
  locale
  companyId
  createdAt
  email
  avatar
  isCapableOfCreatingStandaloneAnswers
  isCapableOfCreatingStandaloneQuestions
  isCapableOfDeletingAllAnswers
  isCapableOfDeletingCampaigns
  isCapableOfDeletingGroups
  isCapableOfDeletingReviews
  isCapableOfDeletingTemplates
  isCapableOfInsertingCampaigns
  isCapableOfInsertingGroups
  isCapableOfInsertingProfessionSkills
  isCapableOfInsertingProfessions
  isCapableOfInsertingReviews
  isCapableOfInsertingSkills
  isCapableOfInsertingTemplates
  isCapableOfInsertingTranslations
  isCapableOfInsertingUsers
  isCapableOfReadingActivities
  isCapableOfReadingActivitiesIps
  isCapableOfReadingAllReviews
  isCapableOfReadingCampaigns
  isCapableOfReadingGroups
  isCapableOfReadingSkills
  isCapableOfReadingQuestions
  isCapableOfReadingReviews
  isCapableOfReadingStandaloneAnswers
  isCapableOfReadingStandaloneQuestions
  isCapableOfReadingTemplates
  isCapableOfReadingUserDocuments
  isCapableOfReadingUserNotes
  isCapableOfReadingUsers
  isCapableOfSigningReports
  isCapableOfManagingReports
  isCapableOfUpdatingCompanies
  isCapableOfUpdatingUserCapabilities
  isCapableOfUpdatingUserNotes
  company {
    id
    name
    locale
    reminderEnabled
    reminderGap
    reportSigningEnabled
    customTranslationsEnabled
    inlineTemplateUpdateEnabled
    usersCount
    questionOptionsConfigurations {
      ...QuestionOptionsConfigurationFragment
    }
    users {
      ...UserMinimalFragment
    }
    translations {
      ...TranslationFragment
    }
    campaigns {
      ...CampaignMinimalFragment
    }
    groups {
      ...GroupMinimalFragment
    }
    visualIdentity
    theme {
      ...ThemeFragment
    }
  }
}
    ${QuestionOptionsConfigurationFragment}
${UserMinimalFragment}
${TranslationFragment}
${CampaignMinimalFragment}
${GroupMinimalFragment}
${ThemeFragment}`;
export const GetActivitiesDocument = gql`
    query getActivities($page: Int, $per: Int, $direction: String, $sortBy: String) {
  activities(per: $per, page: $page, direction: $direction, sortBy: $sortBy) {
    collection {
      ...ActivityFragment
    }
    metadata {
      totalCount
      currentPage
    }
  }
}
    ${ActivityFragment}`;

/**
 * __useGetActivities__
 *
 * To run a query within a React component, call `useGetActivities` and pass it any options that fit your needs.
 * When your component renders, `useGetActivities` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivities({
 *   variables: {
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      direction: // value for 'direction'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetActivities(baseOptions?: Apollo.QueryHookOptions<GetActivities, GetActivitiesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivities, GetActivitiesVariables>(GetActivitiesDocument, options);
      }
export function useGetActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivities, GetActivitiesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivities, GetActivitiesVariables>(GetActivitiesDocument, options);
        }
export type GetActivitiesHookResult = ReturnType<typeof useGetActivities>;
export type GetActivitiesLazyQueryHookResult = ReturnType<typeof useGetActivitiesLazyQuery>;
export type GetActivitiesQueryResult = Apollo.QueryResult<GetActivities, GetActivitiesVariables>;
export function refetchGetActivities(variables?: GetActivitiesVariables) {
      return { query: GetActivitiesDocument, variables: variables }
    }
export const InsertAnswerDocument = gql`
    mutation insertAnswer($input: InsertAnswerInput!) {
  insertAnswer(input: $input) {
    answer {
      ...AnswerFragment
    }
  }
}
    ${AnswerFragment}`;
export type InsertAnswerMutationFn = Apollo.MutationFunction<InsertAnswer, InsertAnswerVariables>;

/**
 * __useInsertAnswer__
 *
 * To run a mutation, you first call `useInsertAnswer` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAnswer` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAnswer, { data, loading, error }] = useInsertAnswer({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertAnswer(baseOptions?: Apollo.MutationHookOptions<InsertAnswer, InsertAnswerVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAnswer, InsertAnswerVariables>(InsertAnswerDocument, options);
      }
export type InsertAnswerHookResult = ReturnType<typeof useInsertAnswer>;
export type InsertAnswerMutationResult = Apollo.MutationResult<InsertAnswer>;
export type InsertAnswerMutationOptions = Apollo.BaseMutationOptions<InsertAnswer, InsertAnswerVariables>;
export const DeleteAnswersDocument = gql`
    mutation deleteAnswers($input: DeleteAnswersInput!) {
  deleteAnswers(input: $input) {
    ids
  }
}
    `;
export type DeleteAnswersMutationFn = Apollo.MutationFunction<DeleteAnswers, DeleteAnswersVariables>;

/**
 * __useDeleteAnswers__
 *
 * To run a mutation, you first call `useDeleteAnswers` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnswers` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnswers, { data, loading, error }] = useDeleteAnswers({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnswers(baseOptions?: Apollo.MutationHookOptions<DeleteAnswers, DeleteAnswersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnswers, DeleteAnswersVariables>(DeleteAnswersDocument, options);
      }
export type DeleteAnswersHookResult = ReturnType<typeof useDeleteAnswers>;
export type DeleteAnswersMutationResult = Apollo.MutationResult<DeleteAnswers>;
export type DeleteAnswersMutationOptions = Apollo.BaseMutationOptions<DeleteAnswers, DeleteAnswersVariables>;
export const GetAnswersDocument = gql`
    query getAnswers($skillIds: [ID!], $skillQ: String, $type: [String!], $questionDigest: [String!], $isCheckedReport: Boolean, $lastCreatedAt: String, $userId: ID, $groupIds: [ID!], $normalizedRatingEqual: Float, $normalizedRatingLessThan: Float, $normalizedRatingGreaterThan: Float, $normalizedRatingLessThanOrEqualTo: Float, $normalizedRatingGreaterThanOrEqualTo: Float, $reviewId: ID, $collaboratorId: ID, $collaboratorIds: [ID!], $direction: String, $sortBy: String) {
  answers(
    skillIds: $skillIds
    skillQ: $skillQ
    type: $type
    questionDigest: $questionDigest
    isCheckedReport: $isCheckedReport
    lastCreatedAt: $lastCreatedAt
    userId: $userId
    groupIds: $groupIds
    normalizedRatingEqual: $normalizedRatingEqual
    normalizedRatingLessThan: $normalizedRatingLessThan
    normalizedRatingGreaterThan: $normalizedRatingGreaterThan
    normalizedRatingLessThanOrEqualTo: $normalizedRatingLessThanOrEqualTo
    normalizedRatingGreaterThanOrEqualTo: $normalizedRatingGreaterThanOrEqualTo
    reviewId: $reviewId
    collaboratorId: $collaboratorId
    collaboratorIds: $collaboratorIds
    direction: $direction
    sortBy: $sortBy
  ) {
    collection {
      ...AnswerFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${AnswerFragment}`;

/**
 * __useGetAnswers__
 *
 * To run a query within a React component, call `useGetAnswers` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswers({
 *   variables: {
 *      skillIds: // value for 'skillIds'
 *      skillQ: // value for 'skillQ'
 *      type: // value for 'type'
 *      questionDigest: // value for 'questionDigest'
 *      isCheckedReport: // value for 'isCheckedReport'
 *      lastCreatedAt: // value for 'lastCreatedAt'
 *      userId: // value for 'userId'
 *      groupIds: // value for 'groupIds'
 *      normalizedRatingEqual: // value for 'normalizedRatingEqual'
 *      normalizedRatingLessThan: // value for 'normalizedRatingLessThan'
 *      normalizedRatingGreaterThan: // value for 'normalizedRatingGreaterThan'
 *      normalizedRatingLessThanOrEqualTo: // value for 'normalizedRatingLessThanOrEqualTo'
 *      normalizedRatingGreaterThanOrEqualTo: // value for 'normalizedRatingGreaterThanOrEqualTo'
 *      reviewId: // value for 'reviewId'
 *      collaboratorId: // value for 'collaboratorId'
 *      collaboratorIds: // value for 'collaboratorIds'
 *      direction: // value for 'direction'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetAnswers(baseOptions?: Apollo.QueryHookOptions<GetAnswers, GetAnswersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswers, GetAnswersVariables>(GetAnswersDocument, options);
      }
export function useGetAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswers, GetAnswersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswers, GetAnswersVariables>(GetAnswersDocument, options);
        }
export type GetAnswersHookResult = ReturnType<typeof useGetAnswers>;
export type GetAnswersLazyQueryHookResult = ReturnType<typeof useGetAnswersLazyQuery>;
export type GetAnswersQueryResult = Apollo.QueryResult<GetAnswers, GetAnswersVariables>;
export function refetchGetAnswers(variables?: GetAnswersVariables) {
      return { query: GetAnswersDocument, variables: variables }
    }
export const GetAnswersHistoryDocument = gql`
    query getAnswersHistory($type: [String!], $questionDigest: [String!], $userId: ID, $reviewId: ID, $collaboratorId: ID, $collaboratorIds: [ID!], $direction: String, $sortBy: String) {
  answers(
    type: $type
    questionDigest: $questionDigest
    userId: $userId
    reviewId: $reviewId
    collaboratorId: $collaboratorId
    collaboratorIds: $collaboratorIds
    direction: $direction
    sortBy: $sortBy
  ) {
    collection {
      ...AnswerHistoryFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${AnswerHistoryFragment}`;

/**
 * __useGetAnswersHistory__
 *
 * To run a query within a React component, call `useGetAnswersHistory` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersHistory` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersHistory({
 *   variables: {
 *      type: // value for 'type'
 *      questionDigest: // value for 'questionDigest'
 *      userId: // value for 'userId'
 *      reviewId: // value for 'reviewId'
 *      collaboratorId: // value for 'collaboratorId'
 *      collaboratorIds: // value for 'collaboratorIds'
 *      direction: // value for 'direction'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetAnswersHistory(baseOptions?: Apollo.QueryHookOptions<GetAnswersHistory, GetAnswersHistoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswersHistory, GetAnswersHistoryVariables>(GetAnswersHistoryDocument, options);
      }
export function useGetAnswersHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswersHistory, GetAnswersHistoryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswersHistory, GetAnswersHistoryVariables>(GetAnswersHistoryDocument, options);
        }
export type GetAnswersHistoryHookResult = ReturnType<typeof useGetAnswersHistory>;
export type GetAnswersHistoryLazyQueryHookResult = ReturnType<typeof useGetAnswersHistoryLazyQuery>;
export type GetAnswersHistoryQueryResult = Apollo.QueryResult<GetAnswersHistory, GetAnswersHistoryVariables>;
export function refetchGetAnswersHistory(variables?: GetAnswersHistoryVariables) {
      return { query: GetAnswersHistoryDocument, variables: variables }
    }
export const GetAnswersForMappingDocument = gql`
    query getAnswersForMapping($questionDigest: [String!], $lastCreatedAt: String, $groupIds: [ID!], $isCollaborator: Boolean) {
  answers(
    questionDigest: $questionDigest
    lastCreatedAt: $lastCreatedAt
    groupIds: $groupIds
    isCollaborator: $isCollaborator
  ) {
    collection {
      ...AnswerForMappingFragment
    }
  }
}
    ${AnswerForMappingFragment}`;

/**
 * __useGetAnswersForMapping__
 *
 * To run a query within a React component, call `useGetAnswersForMapping` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersForMapping` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersForMapping({
 *   variables: {
 *      questionDigest: // value for 'questionDigest'
 *      lastCreatedAt: // value for 'lastCreatedAt'
 *      groupIds: // value for 'groupIds'
 *      isCollaborator: // value for 'isCollaborator'
 *   },
 * });
 */
export function useGetAnswersForMapping(baseOptions?: Apollo.QueryHookOptions<GetAnswersForMapping, GetAnswersForMappingVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswersForMapping, GetAnswersForMappingVariables>(GetAnswersForMappingDocument, options);
      }
export function useGetAnswersForMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswersForMapping, GetAnswersForMappingVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswersForMapping, GetAnswersForMappingVariables>(GetAnswersForMappingDocument, options);
        }
export type GetAnswersForMappingHookResult = ReturnType<typeof useGetAnswersForMapping>;
export type GetAnswersForMappingLazyQueryHookResult = ReturnType<typeof useGetAnswersForMappingLazyQuery>;
export type GetAnswersForMappingQueryResult = Apollo.QueryResult<GetAnswersForMapping, GetAnswersForMappingVariables>;
export function refetchGetAnswersForMapping(variables?: GetAnswersForMappingVariables) {
      return { query: GetAnswersForMappingDocument, variables: variables }
    }
export const InsertCampaignDocument = gql`
    mutation insertCampaign($input: InsertCampaignInput!) {
  insertCampaign(input: $input) {
    campaign {
      ...CampaignSummaryFragment
    }
  }
}
    ${CampaignSummaryFragment}`;
export type InsertCampaignMutationFn = Apollo.MutationFunction<InsertCampaign, InsertCampaignVariables>;

/**
 * __useInsertCampaign__
 *
 * To run a mutation, you first call `useInsertCampaign` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCampaign` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCampaign, { data, loading, error }] = useInsertCampaign({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertCampaign(baseOptions?: Apollo.MutationHookOptions<InsertCampaign, InsertCampaignVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCampaign, InsertCampaignVariables>(InsertCampaignDocument, options);
      }
export type InsertCampaignHookResult = ReturnType<typeof useInsertCampaign>;
export type InsertCampaignMutationResult = Apollo.MutationResult<InsertCampaign>;
export type InsertCampaignMutationOptions = Apollo.BaseMutationOptions<InsertCampaign, InsertCampaignVariables>;
export const DeleteCampaignDocument = gql`
    mutation deleteCampaign($input: DeleteCampaignInput!) {
  deleteCampaign(input: $input) {
    id
  }
}
    `;
export type DeleteCampaignMutationFn = Apollo.MutationFunction<DeleteCampaign, DeleteCampaignVariables>;

/**
 * __useDeleteCampaign__
 *
 * To run a mutation, you first call `useDeleteCampaign` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaign` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaign, { data, loading, error }] = useDeleteCampaign({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCampaign(baseOptions?: Apollo.MutationHookOptions<DeleteCampaign, DeleteCampaignVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaign, DeleteCampaignVariables>(DeleteCampaignDocument, options);
      }
export type DeleteCampaignHookResult = ReturnType<typeof useDeleteCampaign>;
export type DeleteCampaignMutationResult = Apollo.MutationResult<DeleteCampaign>;
export type DeleteCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteCampaign, DeleteCampaignVariables>;
export const GetCampaignDocument = gql`
    query getCampaign($id: ID!) {
  campaign(id: $id) {
    ...CampaignSummaryFragment
  }
}
    ${CampaignSummaryFragment}`;

/**
 * __useGetCampaign__
 *
 * To run a query within a React component, call `useGetCampaign` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaign` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaign({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaign(baseOptions: Apollo.QueryHookOptions<GetCampaign, GetCampaignVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaign, GetCampaignVariables>(GetCampaignDocument, options);
      }
export function useGetCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaign, GetCampaignVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaign, GetCampaignVariables>(GetCampaignDocument, options);
        }
export type GetCampaignHookResult = ReturnType<typeof useGetCampaign>;
export type GetCampaignLazyQueryHookResult = ReturnType<typeof useGetCampaignLazyQuery>;
export type GetCampaignQueryResult = Apollo.QueryResult<GetCampaign, GetCampaignVariables>;
export function refetchGetCampaign(variables?: GetCampaignVariables) {
      return { query: GetCampaignDocument, variables: variables }
    }
export const GetCampaignsDocument = gql`
    query getCampaigns($page: Int, $per: Int, $q: String, $sortBy: String, $direction: String) {
  campaigns(page: $page, per: $per, q: $q, sortBy: $sortBy, direction: $direction) {
    collection {
      ...CampaignListingFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${CampaignListingFragment}`;

/**
 * __useGetCampaigns__
 *
 * To run a query within a React component, call `useGetCampaigns` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaigns` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaigns({
 *   variables: {
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      q: // value for 'q'
 *      sortBy: // value for 'sortBy'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useGetCampaigns(baseOptions?: Apollo.QueryHookOptions<GetCampaigns, GetCampaignsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaigns, GetCampaignsVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaigns, GetCampaignsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaigns, GetCampaignsVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsHookResult = ReturnType<typeof useGetCampaigns>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<GetCampaigns, GetCampaignsVariables>;
export function refetchGetCampaigns(variables?: GetCampaignsVariables) {
      return { query: GetCampaignsDocument, variables: variables }
    }
export const UpdateCompanyDocument = gql`
    mutation updateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    company {
      ...CompanyMinimalFragment
    }
  }
}
    ${CompanyMinimalFragment}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompany, UpdateCompanyVariables>;

/**
 * __useUpdateCompany__
 *
 * To run a mutation, you first call `useUpdateCompany` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompany` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompany, { data, loading, error }] = useUpdateCompany({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompany(baseOptions?: Apollo.MutationHookOptions<UpdateCompany, UpdateCompanyVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompany, UpdateCompanyVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyHookResult = ReturnType<typeof useUpdateCompany>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompany>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompany, UpdateCompanyVariables>;
export const GetCredentialDocument = gql`
    query getCredential @client {
  credential @client(always: true) {
    ...CredentialFragment
  }
}
    ${CredentialFragment}`;

/**
 * __useGetCredential__
 *
 * To run a query within a React component, call `useGetCredential` and pass it any options that fit your needs.
 * When your component renders, `useGetCredential` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCredential({
 *   variables: {
 *   },
 * });
 */
export function useGetCredential(baseOptions?: Apollo.QueryHookOptions<GetCredential, GetCredentialVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCredential, GetCredentialVariables>(GetCredentialDocument, options);
      }
export function useGetCredentialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCredential, GetCredentialVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCredential, GetCredentialVariables>(GetCredentialDocument, options);
        }
export type GetCredentialHookResult = ReturnType<typeof useGetCredential>;
export type GetCredentialLazyQueryHookResult = ReturnType<typeof useGetCredentialLazyQuery>;
export type GetCredentialQueryResult = Apollo.QueryResult<GetCredential, GetCredentialVariables>;
export function refetchGetCredential(variables?: GetCredentialVariables) {
      return { query: GetCredentialDocument, variables: variables }
    }
export const DeleteGroupDocument = gql`
    mutation deleteGroup($input: DeleteGroupInput!) {
  deleteGroup(input: $input) {
    id
  }
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroup, DeleteGroupVariables>;

/**
 * __useDeleteGroup__
 *
 * To run a mutation, you first call `useDeleteGroup` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroup` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroup, { data, loading, error }] = useDeleteGroup({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGroup(baseOptions?: Apollo.MutationHookOptions<DeleteGroup, DeleteGroupVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroup, DeleteGroupVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupHookResult = ReturnType<typeof useDeleteGroup>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroup>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroup, DeleteGroupVariables>;
export const InsertGroupDocument = gql`
    mutation insertGroup($input: InsertGroupInput!) {
  insertGroup(input: $input) {
    group {
      id
    }
  }
}
    `;
export type InsertGroupMutationFn = Apollo.MutationFunction<InsertGroup, InsertGroupVariables>;

/**
 * __useInsertGroup__
 *
 * To run a mutation, you first call `useInsertGroup` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertGroup` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGroup, { data, loading, error }] = useInsertGroup({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertGroup(baseOptions?: Apollo.MutationHookOptions<InsertGroup, InsertGroupVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertGroup, InsertGroupVariables>(InsertGroupDocument, options);
      }
export type InsertGroupHookResult = ReturnType<typeof useInsertGroup>;
export type InsertGroupMutationResult = Apollo.MutationResult<InsertGroup>;
export type InsertGroupMutationOptions = Apollo.BaseMutationOptions<InsertGroup, InsertGroupVariables>;
export const GetGroupDocument = gql`
    query getGroup($id: ID!) {
  group(id: $id) {
    ...GroupFragment
  }
}
    ${GroupFragment}`;

/**
 * __useGetGroup__
 *
 * To run a query within a React component, call `useGetGroup` and pass it any options that fit your needs.
 * When your component renders, `useGetGroup` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroup({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroup(baseOptions: Apollo.QueryHookOptions<GetGroup, GetGroupVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroup, GetGroupVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroup, GetGroupVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroup, GetGroupVariables>(GetGroupDocument, options);
        }
export type GetGroupHookResult = ReturnType<typeof useGetGroup>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroup, GetGroupVariables>;
export function refetchGetGroup(variables?: GetGroupVariables) {
      return { query: GetGroupDocument, variables: variables }
    }
export const GetGroupsDocument = gql`
    query getGroups($sortBy: String, $direction: String, $page: Int, $per: Int, $q: String, $createdAfter: String, $companyId: ID) {
  groups(
    sortBy: $sortBy
    direction: $direction
    q: $q
    createdAfter: $createdAfter
    companyId: $companyId
    page: $page
    per: $per
  ) {
    collection {
      ...GroupFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${GroupFragment}`;

/**
 * __useGetGroups__
 *
 * To run a query within a React component, call `useGetGroups` and pass it any options that fit your needs.
 * When your component renders, `useGetGroups` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroups({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      direction: // value for 'direction'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      q: // value for 'q'
 *      createdAfter: // value for 'createdAfter'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetGroups(baseOptions?: Apollo.QueryHookOptions<GetGroups, GetGroupsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroups, GetGroupsVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroups, GetGroupsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroups, GetGroupsVariables>(GetGroupsDocument, options);
        }
export type GetGroupsHookResult = ReturnType<typeof useGetGroups>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroups, GetGroupsVariables>;
export function refetchGetGroups(variables?: GetGroupsVariables) {
      return { query: GetGroupsDocument, variables: variables }
    }
export const InsertProfessionSkillDocument = gql`
    mutation insertProfessionSkill($input: InsertProfessionSkillInput!) {
  insertProfessionSkill(input: $input) {
    professionSkill {
      ...ProfessionSkillFragment
    }
  }
}
    ${ProfessionSkillFragment}`;
export type InsertProfessionSkillMutationFn = Apollo.MutationFunction<InsertProfessionSkill, InsertProfessionSkillVariables>;

/**
 * __useInsertProfessionSkill__
 *
 * To run a mutation, you first call `useInsertProfessionSkill` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertProfessionSkill` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertProfessionSkill, { data, loading, error }] = useInsertProfessionSkill({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertProfessionSkill(baseOptions?: Apollo.MutationHookOptions<InsertProfessionSkill, InsertProfessionSkillVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertProfessionSkill, InsertProfessionSkillVariables>(InsertProfessionSkillDocument, options);
      }
export type InsertProfessionSkillHookResult = ReturnType<typeof useInsertProfessionSkill>;
export type InsertProfessionSkillMutationResult = Apollo.MutationResult<InsertProfessionSkill>;
export type InsertProfessionSkillMutationOptions = Apollo.BaseMutationOptions<InsertProfessionSkill, InsertProfessionSkillVariables>;
export const DeleteProfessionSkillDocument = gql`
    mutation deleteProfessionSkill($input: DeleteProfessionSkillInput!) {
  deleteProfessionSkill(input: $input) {
    id
  }
}
    `;
export type DeleteProfessionSkillMutationFn = Apollo.MutationFunction<DeleteProfessionSkill, DeleteProfessionSkillVariables>;

/**
 * __useDeleteProfessionSkill__
 *
 * To run a mutation, you first call `useDeleteProfessionSkill` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfessionSkill` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfessionSkill, { data, loading, error }] = useDeleteProfessionSkill({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProfessionSkill(baseOptions?: Apollo.MutationHookOptions<DeleteProfessionSkill, DeleteProfessionSkillVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProfessionSkill, DeleteProfessionSkillVariables>(DeleteProfessionSkillDocument, options);
      }
export type DeleteProfessionSkillHookResult = ReturnType<typeof useDeleteProfessionSkill>;
export type DeleteProfessionSkillMutationResult = Apollo.MutationResult<DeleteProfessionSkill>;
export type DeleteProfessionSkillMutationOptions = Apollo.BaseMutationOptions<DeleteProfessionSkill, DeleteProfessionSkillVariables>;
export const InsertProfessionDocument = gql`
    mutation insertProfession($input: InsertProfessionInput!) {
  insertProfession(input: $input) {
    profession {
      ...ProfessionFragment
    }
  }
}
    ${ProfessionFragment}`;
export type InsertProfessionMutationFn = Apollo.MutationFunction<InsertProfession, InsertProfessionVariables>;

/**
 * __useInsertProfession__
 *
 * To run a mutation, you first call `useInsertProfession` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertProfession` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertProfession, { data, loading, error }] = useInsertProfession({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertProfession(baseOptions?: Apollo.MutationHookOptions<InsertProfession, InsertProfessionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertProfession, InsertProfessionVariables>(InsertProfessionDocument, options);
      }
export type InsertProfessionHookResult = ReturnType<typeof useInsertProfession>;
export type InsertProfessionMutationResult = Apollo.MutationResult<InsertProfession>;
export type InsertProfessionMutationOptions = Apollo.BaseMutationOptions<InsertProfession, InsertProfessionVariables>;
export const DeleteProfessionDocument = gql`
    mutation deleteProfession($input: DeleteProfessionInput!) {
  deleteProfession(input: $input) {
    id
  }
}
    `;
export type DeleteProfessionMutationFn = Apollo.MutationFunction<DeleteProfession, DeleteProfessionVariables>;

/**
 * __useDeleteProfession__
 *
 * To run a mutation, you first call `useDeleteProfession` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfession` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfession, { data, loading, error }] = useDeleteProfession({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProfession(baseOptions?: Apollo.MutationHookOptions<DeleteProfession, DeleteProfessionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProfession, DeleteProfessionVariables>(DeleteProfessionDocument, options);
      }
export type DeleteProfessionHookResult = ReturnType<typeof useDeleteProfession>;
export type DeleteProfessionMutationResult = Apollo.MutationResult<DeleteProfession>;
export type DeleteProfessionMutationOptions = Apollo.BaseMutationOptions<DeleteProfession, DeleteProfessionVariables>;
export const GetProfessionsDocument = gql`
    query getProfessions($q: String, $locale: String, $page: Int, $per: Int, $sortBy: String, $direction: String) {
  professions(
    q: $q
    locale: $locale
    page: $page
    per: $per
    sortBy: $sortBy
    direction: $direction
  ) {
    collection {
      ...ProfessionFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${ProfessionFragment}`;

/**
 * __useGetProfessions__
 *
 * To run a query within a React component, call `useGetProfessions` and pass it any options that fit your needs.
 * When your component renders, `useGetProfessions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfessions({
 *   variables: {
 *      q: // value for 'q'
 *      locale: // value for 'locale'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      sortBy: // value for 'sortBy'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useGetProfessions(baseOptions?: Apollo.QueryHookOptions<GetProfessions, GetProfessionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfessions, GetProfessionsVariables>(GetProfessionsDocument, options);
      }
export function useGetProfessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfessions, GetProfessionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfessions, GetProfessionsVariables>(GetProfessionsDocument, options);
        }
export type GetProfessionsHookResult = ReturnType<typeof useGetProfessions>;
export type GetProfessionsLazyQueryHookResult = ReturnType<typeof useGetProfessionsLazyQuery>;
export type GetProfessionsQueryResult = Apollo.QueryResult<GetProfessions, GetProfessionsVariables>;
export function refetchGetProfessions(variables?: GetProfessionsVariables) {
      return { query: GetProfessionsDocument, variables: variables }
    }
export const CreateQuestionDocument = gql`
    mutation createQuestion($input: CreateQuestionInput!) {
  createQuestion(input: $input) {
    question {
      ...QuestionFragment
    }
  }
}
    ${QuestionFragment}`;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestion, CreateQuestionVariables>;

/**
 * __useCreateQuestion__
 *
 * To run a mutation, you first call `useCreateQuestion` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestion` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestion, { data, loading, error }] = useCreateQuestion({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestion(baseOptions?: Apollo.MutationHookOptions<CreateQuestion, CreateQuestionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestion, CreateQuestionVariables>(CreateQuestionDocument, options);
      }
export type CreateQuestionHookResult = ReturnType<typeof useCreateQuestion>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestion>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestion, CreateQuestionVariables>;
export const GetQuestionsDocument = gql`
    query getQuestions($sectionId: ID, $sectionIds: [ID!], $sectionIdsStrict: [ID!], $notSectionIds: [ID!], $distinctByDigest: Boolean, $companyId: ID, $companyIds: [ID!], $companyIdsStrict: [ID!], $notCompanyIds: [ID!], $skillId: ID, $skillIds: [ID!], $skillIdsStrict: [ID!], $notSkillIds: [ID!], $templateId: ID, $templateIdsStrict: [ID!], $templateIds: [ID!], $notTemplateIds: [ID!], $reviewId: ID, $reviewIdsStrict: [ID!], $reviewIds: [ID!], $notReviewIds: [ID!], $havingAnswers: Boolean, $answerId: ID, $answerIdsStrict: [ID!], $answerIds: [ID!], $notAnswerIds: [ID!], $createdAfter: String, $createdAfterIncluding: String, $createdBefore: String, $createdBeforeIncluding: String, $updatedAfter: String, $updatedAfterIncluding: String, $updatedBefore: String, $updatedBeforeIncluding: String, $orderEqual: Int, $orderLessThan: Int, $orderLessThanOrEqualTo: Int, $orderGreaterThan: Int, $orderGreaterThanOrEqualTo: Int, $expectedTimeValueEqual: Int, $expectedTimeValueLessThan: Int, $expectedTimeValueLessThanOrEqualTo: Int, $expectedTimeValueGreaterThan: Int, $expectedTimeValueGreaterThanOrEqualTo: Int, $areTimeTracked: Boolean, $areNotTimeTracked: Boolean, $label: [String!], $notLabel: [String!], $type: [String!], $notType: [String!], $reportTypes: [String!], $notReportTypes: [String!], $digest: [String!], $notDigest: [String!], $expectedTimeUnit: [String!], $notExpectedTimeUnit: [String!], $ids: [ID!], $idsStrict: [ID!], $notIds: [ID!], $direction: String, $page: Int, $per: Int) {
  questions(
    sectionId: $sectionId
    sectionIds: $sectionIds
    sectionIdsStrict: $sectionIdsStrict
    notSectionIds: $notSectionIds
    distinctByDigest: $distinctByDigest
    companyId: $companyId
    companyIds: $companyIds
    companyIdsStrict: $companyIdsStrict
    notCompanyIds: $notCompanyIds
    skillId: $skillId
    skillIds: $skillIds
    skillIdsStrict: $skillIdsStrict
    notSkillIds: $notSkillIds
    templateId: $templateId
    templateIdsStrict: $templateIdsStrict
    templateIds: $templateIds
    notTemplateIds: $notTemplateIds
    reviewId: $reviewId
    reviewIdsStrict: $reviewIdsStrict
    reviewIds: $reviewIds
    notReviewIds: $notReviewIds
    havingAnswers: $havingAnswers
    answerId: $answerId
    answerIdsStrict: $answerIdsStrict
    answerIds: $answerIds
    notAnswerIds: $notAnswerIds
    createdAfter: $createdAfter
    createdAfterIncluding: $createdAfterIncluding
    createdBefore: $createdBefore
    createdBeforeIncluding: $createdBeforeIncluding
    updatedAfter: $updatedAfter
    updatedAfterIncluding: $updatedAfterIncluding
    updatedBefore: $updatedBefore
    updatedBeforeIncluding: $updatedBeforeIncluding
    orderEqual: $orderEqual
    orderLessThan: $orderLessThan
    orderLessThanOrEqualTo: $orderLessThanOrEqualTo
    orderGreaterThan: $orderGreaterThan
    orderGreaterThanOrEqualTo: $orderGreaterThanOrEqualTo
    expectedTimeValueEqual: $expectedTimeValueEqual
    expectedTimeValueLessThan: $expectedTimeValueLessThan
    expectedTimeValueLessThanOrEqualTo: $expectedTimeValueLessThanOrEqualTo
    expectedTimeValueGreaterThan: $expectedTimeValueGreaterThan
    expectedTimeValueGreaterThanOrEqualTo: $expectedTimeValueGreaterThanOrEqualTo
    areTimeTracked: $areTimeTracked
    areNotTimeTracked: $areNotTimeTracked
    label: $label
    notLabel: $notLabel
    type: $type
    notType: $notType
    reportTypes: $reportTypes
    notReportTypes: $notReportTypes
    digest: $digest
    notDigest: $notDigest
    expectedTimeUnit: $expectedTimeUnit
    notExpectedTimeUnit: $notExpectedTimeUnit
    ids: $ids
    idsStrict: $idsStrict
    notIds: $notIds
    direction: $direction
    page: $page
    per: $per
  ) {
    collection {
      ...QuestionMinimalFragment
    }
    metadata {
      ...CollectionMetadataFragment
    }
  }
}
    ${QuestionMinimalFragment}
${CollectionMetadataFragment}`;

/**
 * __useGetQuestions__
 *
 * To run a query within a React component, call `useGetQuestions` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestions({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *      sectionIds: // value for 'sectionIds'
 *      sectionIdsStrict: // value for 'sectionIdsStrict'
 *      notSectionIds: // value for 'notSectionIds'
 *      distinctByDigest: // value for 'distinctByDigest'
 *      companyId: // value for 'companyId'
 *      companyIds: // value for 'companyIds'
 *      companyIdsStrict: // value for 'companyIdsStrict'
 *      notCompanyIds: // value for 'notCompanyIds'
 *      skillId: // value for 'skillId'
 *      skillIds: // value for 'skillIds'
 *      skillIdsStrict: // value for 'skillIdsStrict'
 *      notSkillIds: // value for 'notSkillIds'
 *      templateId: // value for 'templateId'
 *      templateIdsStrict: // value for 'templateIdsStrict'
 *      templateIds: // value for 'templateIds'
 *      notTemplateIds: // value for 'notTemplateIds'
 *      reviewId: // value for 'reviewId'
 *      reviewIdsStrict: // value for 'reviewIdsStrict'
 *      reviewIds: // value for 'reviewIds'
 *      notReviewIds: // value for 'notReviewIds'
 *      havingAnswers: // value for 'havingAnswers'
 *      answerId: // value for 'answerId'
 *      answerIdsStrict: // value for 'answerIdsStrict'
 *      answerIds: // value for 'answerIds'
 *      notAnswerIds: // value for 'notAnswerIds'
 *      createdAfter: // value for 'createdAfter'
 *      createdAfterIncluding: // value for 'createdAfterIncluding'
 *      createdBefore: // value for 'createdBefore'
 *      createdBeforeIncluding: // value for 'createdBeforeIncluding'
 *      updatedAfter: // value for 'updatedAfter'
 *      updatedAfterIncluding: // value for 'updatedAfterIncluding'
 *      updatedBefore: // value for 'updatedBefore'
 *      updatedBeforeIncluding: // value for 'updatedBeforeIncluding'
 *      orderEqual: // value for 'orderEqual'
 *      orderLessThan: // value for 'orderLessThan'
 *      orderLessThanOrEqualTo: // value for 'orderLessThanOrEqualTo'
 *      orderGreaterThan: // value for 'orderGreaterThan'
 *      orderGreaterThanOrEqualTo: // value for 'orderGreaterThanOrEqualTo'
 *      expectedTimeValueEqual: // value for 'expectedTimeValueEqual'
 *      expectedTimeValueLessThan: // value for 'expectedTimeValueLessThan'
 *      expectedTimeValueLessThanOrEqualTo: // value for 'expectedTimeValueLessThanOrEqualTo'
 *      expectedTimeValueGreaterThan: // value for 'expectedTimeValueGreaterThan'
 *      expectedTimeValueGreaterThanOrEqualTo: // value for 'expectedTimeValueGreaterThanOrEqualTo'
 *      areTimeTracked: // value for 'areTimeTracked'
 *      areNotTimeTracked: // value for 'areNotTimeTracked'
 *      label: // value for 'label'
 *      notLabel: // value for 'notLabel'
 *      type: // value for 'type'
 *      notType: // value for 'notType'
 *      reportTypes: // value for 'reportTypes'
 *      notReportTypes: // value for 'notReportTypes'
 *      digest: // value for 'digest'
 *      notDigest: // value for 'notDigest'
 *      expectedTimeUnit: // value for 'expectedTimeUnit'
 *      notExpectedTimeUnit: // value for 'notExpectedTimeUnit'
 *      ids: // value for 'ids'
 *      idsStrict: // value for 'idsStrict'
 *      notIds: // value for 'notIds'
 *      direction: // value for 'direction'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *   },
 * });
 */
export function useGetQuestions(baseOptions?: Apollo.QueryHookOptions<GetQuestions, GetQuestionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestions, GetQuestionsVariables>(GetQuestionsDocument, options);
      }
export function useGetQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestions, GetQuestionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestions, GetQuestionsVariables>(GetQuestionsDocument, options);
        }
export type GetQuestionsHookResult = ReturnType<typeof useGetQuestions>;
export type GetQuestionsLazyQueryHookResult = ReturnType<typeof useGetQuestionsLazyQuery>;
export type GetQuestionsQueryResult = Apollo.QueryResult<GetQuestions, GetQuestionsVariables>;
export function refetchGetQuestions(variables?: GetQuestionsVariables) {
      return { query: GetQuestionsDocument, variables: variables }
    }
export const CreateReportDocument = gql`
    mutation createReport($input: CreateReportInput!) {
  createReport(input: $input) {
    report {
      ...ReportFragment
    }
  }
}
    ${ReportFragment}`;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReport, CreateReportVariables>;

/**
 * __useCreateReport__
 *
 * To run a mutation, you first call `useCreateReport` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReport` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReport, { data, loading, error }] = useCreateReport({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReport(baseOptions?: Apollo.MutationHookOptions<CreateReport, CreateReportVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReport, CreateReportVariables>(CreateReportDocument, options);
      }
export type CreateReportHookResult = ReturnType<typeof useCreateReport>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReport>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReport, CreateReportVariables>;
export const DeleteReportDocument = gql`
    mutation deleteReport($input: DeleteReportInput!) {
  deleteReport(input: $input) {
    id
  }
}
    `;
export type DeleteReportMutationFn = Apollo.MutationFunction<DeleteReport, DeleteReportVariables>;

/**
 * __useDeleteReport__
 *
 * To run a mutation, you first call `useDeleteReport` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReport` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReport, { data, loading, error }] = useDeleteReport({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReport(baseOptions?: Apollo.MutationHookOptions<DeleteReport, DeleteReportVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReport, DeleteReportVariables>(DeleteReportDocument, options);
      }
export type DeleteReportHookResult = ReturnType<typeof useDeleteReport>;
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReport>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<DeleteReport, DeleteReportVariables>;
export const FillReferentReportDocument = gql`
    mutation fillReferentReport($input: FillReferentReportInput!) {
  fillReferentReport(input: $input) {
    report {
      ...ReportFragment
    }
  }
}
    ${ReportFragment}`;
export type FillReferentReportMutationFn = Apollo.MutationFunction<FillReferentReport, FillReferentReportVariables>;

/**
 * __useFillReferentReport__
 *
 * To run a mutation, you first call `useFillReferentReport` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillReferentReport` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillReferentReport, { data, loading, error }] = useFillReferentReport({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFillReferentReport(baseOptions?: Apollo.MutationHookOptions<FillReferentReport, FillReferentReportVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FillReferentReport, FillReferentReportVariables>(FillReferentReportDocument, options);
      }
export type FillReferentReportHookResult = ReturnType<typeof useFillReferentReport>;
export type FillReferentReportMutationResult = Apollo.MutationResult<FillReferentReport>;
export type FillReferentReportMutationOptions = Apollo.BaseMutationOptions<FillReferentReport, FillReferentReportVariables>;
export const FillReportDocument = gql`
    mutation fillReport($input: FillReportInput!) {
  fillReport(input: $input) {
    report {
      ...ReportFragment
    }
  }
}
    ${ReportFragment}`;
export type FillReportMutationFn = Apollo.MutationFunction<FillReport, FillReportVariables>;

/**
 * __useFillReport__
 *
 * To run a mutation, you first call `useFillReport` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillReport` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillReport, { data, loading, error }] = useFillReport({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFillReport(baseOptions?: Apollo.MutationHookOptions<FillReport, FillReportVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FillReport, FillReportVariables>(FillReportDocument, options);
      }
export type FillReportHookResult = ReturnType<typeof useFillReport>;
export type FillReportMutationResult = Apollo.MutationResult<FillReport>;
export type FillReportMutationOptions = Apollo.BaseMutationOptions<FillReport, FillReportVariables>;
export const SignReportDocument = gql`
    mutation signReport($input: SignReportInput!) {
  signReport(input: $input) {
    report {
      ...ReportFragment
    }
  }
}
    ${ReportFragment}`;
export type SignReportMutationFn = Apollo.MutationFunction<SignReport, SignReportVariables>;

/**
 * __useSignReport__
 *
 * To run a mutation, you first call `useSignReport` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignReport` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signReport, { data, loading, error }] = useSignReport({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignReport(baseOptions?: Apollo.MutationHookOptions<SignReport, SignReportVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignReport, SignReportVariables>(SignReportDocument, options);
      }
export type SignReportHookResult = ReturnType<typeof useSignReport>;
export type SignReportMutationResult = Apollo.MutationResult<SignReport>;
export type SignReportMutationOptions = Apollo.BaseMutationOptions<SignReport, SignReportVariables>;
export const UpdateReportDocument = gql`
    mutation updateReport($input: UpdateReportInput!) {
  updateReport(input: $input) {
    report {
      ...ReportFragment
    }
  }
}
    ${ReportFragment}`;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReport, UpdateReportVariables>;

/**
 * __useUpdateReport__
 *
 * To run a mutation, you first call `useUpdateReport` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReport` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReport, { data, loading, error }] = useUpdateReport({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReport(baseOptions?: Apollo.MutationHookOptions<UpdateReport, UpdateReportVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReport, UpdateReportVariables>(UpdateReportDocument, options);
      }
export type UpdateReportHookResult = ReturnType<typeof useUpdateReport>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReport>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<UpdateReport, UpdateReportVariables>;
export const GetReportDocument = gql`
    query getReport($id: ID!) {
  report(id: $id) {
    ...ReportFragment
  }
}
    ${ReportFragment}`;

/**
 * __useGetReport__
 *
 * To run a query within a React component, call `useGetReport` and pass it any options that fit your needs.
 * When your component renders, `useGetReport` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReport({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReport(baseOptions: Apollo.QueryHookOptions<GetReport, GetReportVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReport, GetReportVariables>(GetReportDocument, options);
      }
export function useGetReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReport, GetReportVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReport, GetReportVariables>(GetReportDocument, options);
        }
export type GetReportHookResult = ReturnType<typeof useGetReport>;
export type GetReportLazyQueryHookResult = ReturnType<typeof useGetReportLazyQuery>;
export type GetReportQueryResult = Apollo.QueryResult<GetReport, GetReportVariables>;
export function refetchGetReport(variables?: GetReportVariables) {
      return { query: GetReportDocument, variables: variables }
    }
export const GetReportsDocument = gql`
    query getReports($page: Int, $per: Int, $createdAfter: String, $reviewId: ID, $lastCheckedAt: String, $campaignId: ID) {
  reports(
    page: $page
    per: $per
    createdAfter: $createdAfter
    reviewId: $reviewId
    lastCheckedAt: $lastCheckedAt
    campaignId: $campaignId
  ) {
    collection {
      ...ReportFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${ReportFragment}`;

/**
 * __useGetReports__
 *
 * To run a query within a React component, call `useGetReports` and pass it any options that fit your needs.
 * When your component renders, `useGetReports` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReports({
 *   variables: {
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      createdAfter: // value for 'createdAfter'
 *      reviewId: // value for 'reviewId'
 *      lastCheckedAt: // value for 'lastCheckedAt'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetReports(baseOptions?: Apollo.QueryHookOptions<GetReports, GetReportsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReports, GetReportsVariables>(GetReportsDocument, options);
      }
export function useGetReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReports, GetReportsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReports, GetReportsVariables>(GetReportsDocument, options);
        }
export type GetReportsHookResult = ReturnType<typeof useGetReports>;
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>;
export type GetReportsQueryResult = Apollo.QueryResult<GetReports, GetReportsVariables>;
export function refetchGetReports(variables?: GetReportsVariables) {
      return { query: GetReportsDocument, variables: variables }
    }
export const GetReportsMinimalDocument = gql`
    query getReportsMinimal($page: Int, $per: Int, $createdAfter: String, $reviewId: ID, $lastCheckedAt: String, $campaignId: ID) {
  reports(
    page: $page
    per: $per
    createdAfter: $createdAfter
    reviewId: $reviewId
    lastCheckedAt: $lastCheckedAt
    campaignId: $campaignId
  ) {
    collection {
      ...ReportMinimalFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${ReportMinimalFragment}`;

/**
 * __useGetReportsMinimal__
 *
 * To run a query within a React component, call `useGetReportsMinimal` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsMinimal` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsMinimal({
 *   variables: {
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      createdAfter: // value for 'createdAfter'
 *      reviewId: // value for 'reviewId'
 *      lastCheckedAt: // value for 'lastCheckedAt'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetReportsMinimal(baseOptions?: Apollo.QueryHookOptions<GetReportsMinimal, GetReportsMinimalVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsMinimal, GetReportsMinimalVariables>(GetReportsMinimalDocument, options);
      }
export function useGetReportsMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsMinimal, GetReportsMinimalVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsMinimal, GetReportsMinimalVariables>(GetReportsMinimalDocument, options);
        }
export type GetReportsMinimalHookResult = ReturnType<typeof useGetReportsMinimal>;
export type GetReportsMinimalLazyQueryHookResult = ReturnType<typeof useGetReportsMinimalLazyQuery>;
export type GetReportsMinimalQueryResult = Apollo.QueryResult<GetReportsMinimal, GetReportsMinimalVariables>;
export function refetchGetReportsMinimal(variables?: GetReportsMinimalVariables) {
      return { query: GetReportsMinimalDocument, variables: variables }
    }
export const InsertReviewDocument = gql`
    mutation insertReview($input: InsertReviewInput!) {
  insertReview(input: $input) {
    review {
      ...ReviewFragment
    }
  }
}
    ${ReviewFragment}`;
export type InsertReviewMutationFn = Apollo.MutationFunction<InsertReview, InsertReviewVariables>;

/**
 * __useInsertReview__
 *
 * To run a mutation, you first call `useInsertReview` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertReview` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertReview, { data, loading, error }] = useInsertReview({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertReview(baseOptions?: Apollo.MutationHookOptions<InsertReview, InsertReviewVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertReview, InsertReviewVariables>(InsertReviewDocument, options);
      }
export type InsertReviewHookResult = ReturnType<typeof useInsertReview>;
export type InsertReviewMutationResult = Apollo.MutationResult<InsertReview>;
export type InsertReviewMutationOptions = Apollo.BaseMutationOptions<InsertReview, InsertReviewVariables>;
export const DeleteReviewDocument = gql`
    mutation deleteReview($input: DeleteReviewInput!) {
  deleteReview(input: $input) {
    id
  }
}
    `;
export type DeleteReviewMutationFn = Apollo.MutationFunction<DeleteReview, DeleteReviewVariables>;

/**
 * __useDeleteReview__
 *
 * To run a mutation, you first call `useDeleteReview` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReview` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReview, { data, loading, error }] = useDeleteReview({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReview(baseOptions?: Apollo.MutationHookOptions<DeleteReview, DeleteReviewVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReview, DeleteReviewVariables>(DeleteReviewDocument, options);
      }
export type DeleteReviewHookResult = ReturnType<typeof useDeleteReview>;
export type DeleteReviewMutationResult = Apollo.MutationResult<DeleteReview>;
export type DeleteReviewMutationOptions = Apollo.BaseMutationOptions<DeleteReview, DeleteReviewVariables>;
export const AddReviewDocumentDocument = gql`
    mutation addReviewDocument($input: AddReviewDocumentInput!) {
  addReviewDocument(input: $input) {
    document {
      id
      url
    }
  }
}
    `;
export type AddReviewDocumentMutationFn = Apollo.MutationFunction<AddReviewDocument, AddReviewDocumentVariables>;

/**
 * __useAddReviewDocument__
 *
 * To run a mutation, you first call `useAddReviewDocument` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReviewDocument` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReviewDocument, { data, loading, error }] = useAddReviewDocument({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddReviewDocument(baseOptions?: Apollo.MutationHookOptions<AddReviewDocument, AddReviewDocumentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReviewDocument, AddReviewDocumentVariables>(AddReviewDocumentDocument, options);
      }
export type AddReviewDocumentHookResult = ReturnType<typeof useAddReviewDocument>;
export type AddReviewDocumentMutationResult = Apollo.MutationResult<AddReviewDocument>;
export type AddReviewDocumentMutationOptions = Apollo.BaseMutationOptions<AddReviewDocument, AddReviewDocumentVariables>;
export const DeleteReviewDocumentDocument = gql`
    mutation deleteReviewDocument($input: DeleteReviewDocumentInput!) {
  deleteReviewDocument(input: $input) {
    id
  }
}
    `;
export type DeleteReviewDocumentMutationFn = Apollo.MutationFunction<DeleteReviewDocument, DeleteReviewDocumentVariables>;

/**
 * __useDeleteReviewDocument__
 *
 * To run a mutation, you first call `useDeleteReviewDocument` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewDocument` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewDocument, { data, loading, error }] = useDeleteReviewDocument({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReviewDocument(baseOptions?: Apollo.MutationHookOptions<DeleteReviewDocument, DeleteReviewDocumentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReviewDocument, DeleteReviewDocumentVariables>(DeleteReviewDocumentDocument, options);
      }
export type DeleteReviewDocumentHookResult = ReturnType<typeof useDeleteReviewDocument>;
export type DeleteReviewDocumentMutationResult = Apollo.MutationResult<DeleteReviewDocument>;
export type DeleteReviewDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteReviewDocument, DeleteReviewDocumentVariables>;
export const GetReviewDocument = gql`
    query getReview($id: ID!) {
  review(id: $id) {
    ...ReviewFragment
  }
}
    ${ReviewFragment}`;

/**
 * __useGetReview__
 *
 * To run a query within a React component, call `useGetReview` and pass it any options that fit your needs.
 * When your component renders, `useGetReview` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReview({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReview(baseOptions: Apollo.QueryHookOptions<GetReview, GetReviewVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReview, GetReviewVariables>(GetReviewDocument, options);
      }
export function useGetReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReview, GetReviewVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReview, GetReviewVariables>(GetReviewDocument, options);
        }
export type GetReviewHookResult = ReturnType<typeof useGetReview>;
export type GetReviewLazyQueryHookResult = ReturnType<typeof useGetReviewLazyQuery>;
export type GetReviewQueryResult = Apollo.QueryResult<GetReview, GetReviewVariables>;
export function refetchGetReview(variables?: GetReviewVariables) {
      return { query: GetReviewDocument, variables: variables }
    }
export const GetReviewFullDocument = gql`
    query getReviewFull($id: ID!) {
  review(id: $id) {
    ...ReviewFullFragment
  }
}
    ${ReviewFullFragment}`;

/**
 * __useGetReviewFull__
 *
 * To run a query within a React component, call `useGetReviewFull` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewFull` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewFull({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReviewFull(baseOptions: Apollo.QueryHookOptions<GetReviewFull, GetReviewFullVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewFull, GetReviewFullVariables>(GetReviewFullDocument, options);
      }
export function useGetReviewFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewFull, GetReviewFullVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewFull, GetReviewFullVariables>(GetReviewFullDocument, options);
        }
export type GetReviewFullHookResult = ReturnType<typeof useGetReviewFull>;
export type GetReviewFullLazyQueryHookResult = ReturnType<typeof useGetReviewFullLazyQuery>;
export type GetReviewFullQueryResult = Apollo.QueryResult<GetReviewFull, GetReviewFullVariables>;
export function refetchGetReviewFull(variables?: GetReviewFullVariables) {
      return { query: GetReviewFullDocument, variables: variables }
    }
export const GetReviewsDocument = gql`
    query getReviews($page: Int, $per: Int, $direction: String, $campaignId: ID, $sortBy: String) {
  reviews(
    page: $page
    per: $per
    direction: $direction
    campaignId: $campaignId
    sortBy: $sortBy
  ) {
    collection {
      ...ReviewFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${ReviewFragment}`;

/**
 * __useGetReviews__
 *
 * To run a query within a React component, call `useGetReviews` and pass it any options that fit your needs.
 * When your component renders, `useGetReviews` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviews({
 *   variables: {
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      direction: // value for 'direction'
 *      campaignId: // value for 'campaignId'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetReviews(baseOptions?: Apollo.QueryHookOptions<GetReviews, GetReviewsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviews, GetReviewsVariables>(GetReviewsDocument, options);
      }
export function useGetReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviews, GetReviewsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviews, GetReviewsVariables>(GetReviewsDocument, options);
        }
export type GetReviewsHookResult = ReturnType<typeof useGetReviews>;
export type GetReviewsLazyQueryHookResult = ReturnType<typeof useGetReviewsLazyQuery>;
export type GetReviewsQueryResult = Apollo.QueryResult<GetReviews, GetReviewsVariables>;
export function refetchGetReviews(variables?: GetReviewsVariables) {
      return { query: GetReviewsDocument, variables: variables }
    }
export const InsertSkillDocument = gql`
    mutation insertSkill($input: InsertSkillInput!) {
  insertSkill(input: $input) {
    skill {
      ...SkillFragment
    }
  }
}
    ${SkillFragment}`;
export type InsertSkillMutationFn = Apollo.MutationFunction<InsertSkill, InsertSkillVariables>;

/**
 * __useInsertSkill__
 *
 * To run a mutation, you first call `useInsertSkill` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSkill` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSkill, { data, loading, error }] = useInsertSkill({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertSkill(baseOptions?: Apollo.MutationHookOptions<InsertSkill, InsertSkillVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSkill, InsertSkillVariables>(InsertSkillDocument, options);
      }
export type InsertSkillHookResult = ReturnType<typeof useInsertSkill>;
export type InsertSkillMutationResult = Apollo.MutationResult<InsertSkill>;
export type InsertSkillMutationOptions = Apollo.BaseMutationOptions<InsertSkill, InsertSkillVariables>;
export const DeleteSkillDocument = gql`
    mutation deleteSkill($input: DeleteSkillInput!) {
  deleteSkill(input: $input) {
    id
  }
}
    `;
export type DeleteSkillMutationFn = Apollo.MutationFunction<DeleteSkill, DeleteSkillVariables>;

/**
 * __useDeleteSkill__
 *
 * To run a mutation, you first call `useDeleteSkill` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkill` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkill, { data, loading, error }] = useDeleteSkill({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSkill(baseOptions?: Apollo.MutationHookOptions<DeleteSkill, DeleteSkillVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSkill, DeleteSkillVariables>(DeleteSkillDocument, options);
      }
export type DeleteSkillHookResult = ReturnType<typeof useDeleteSkill>;
export type DeleteSkillMutationResult = Apollo.MutationResult<DeleteSkill>;
export type DeleteSkillMutationOptions = Apollo.BaseMutationOptions<DeleteSkill, DeleteSkillVariables>;
export const GetSkillMappingsDocument = gql`
    query getSkillMappings($q: String, $page: Int, $per: Int, $havingAnswers: Boolean, $ids: [ID!]) {
  skills(q: $q, page: $page, per: $per, havingAnswers: $havingAnswers, ids: $ids) {
    collection {
      ...SkillMappingFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${SkillMappingFragment}`;

/**
 * __useGetSkillMappings__
 *
 * To run a query within a React component, call `useGetSkillMappings` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillMappings` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillMappings({
 *   variables: {
 *      q: // value for 'q'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      havingAnswers: // value for 'havingAnswers'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetSkillMappings(baseOptions?: Apollo.QueryHookOptions<GetSkillMappings, GetSkillMappingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillMappings, GetSkillMappingsVariables>(GetSkillMappingsDocument, options);
      }
export function useGetSkillMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillMappings, GetSkillMappingsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillMappings, GetSkillMappingsVariables>(GetSkillMappingsDocument, options);
        }
export type GetSkillMappingsHookResult = ReturnType<typeof useGetSkillMappings>;
export type GetSkillMappingsLazyQueryHookResult = ReturnType<typeof useGetSkillMappingsLazyQuery>;
export type GetSkillMappingsQueryResult = Apollo.QueryResult<GetSkillMappings, GetSkillMappingsVariables>;
export function refetchGetSkillMappings(variables?: GetSkillMappingsVariables) {
      return { query: GetSkillMappingsDocument, variables: variables }
    }
export const GetSkillsDocument = gql`
    query getSkills($q: String, $sortBy: String, $direction: String, $locale: String, $page: Int, $per: Int, $idsStrict: [ID!]) {
  skills(
    q: $q
    locale: $locale
    sortBy: $sortBy
    direction: $direction
    page: $page
    per: $per
    idsStrict: $idsStrict
  ) {
    collection {
      ...SkillFragment
    }
  }
}
    ${SkillFragment}`;

/**
 * __useGetSkills__
 *
 * To run a query within a React component, call `useGetSkills` and pass it any options that fit your needs.
 * When your component renders, `useGetSkills` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkills({
 *   variables: {
 *      q: // value for 'q'
 *      sortBy: // value for 'sortBy'
 *      direction: // value for 'direction'
 *      locale: // value for 'locale'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      idsStrict: // value for 'idsStrict'
 *   },
 * });
 */
export function useGetSkills(baseOptions?: Apollo.QueryHookOptions<GetSkills, GetSkillsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkills, GetSkillsVariables>(GetSkillsDocument, options);
      }
export function useGetSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkills, GetSkillsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkills, GetSkillsVariables>(GetSkillsDocument, options);
        }
export type GetSkillsHookResult = ReturnType<typeof useGetSkills>;
export type GetSkillsLazyQueryHookResult = ReturnType<typeof useGetSkillsLazyQuery>;
export type GetSkillsQueryResult = Apollo.QueryResult<GetSkills, GetSkillsVariables>;
export function refetchGetSkills(variables?: GetSkillsVariables) {
      return { query: GetSkillsDocument, variables: variables }
    }
export const GetSkillsWithProfessionsDocument = gql`
    query getSkillsWithProfessions($q: String, $sortBy: String, $direction: String, $locale: String, $page: Int, $per: Int) {
  skills(
    q: $q
    locale: $locale
    sortBy: $sortBy
    direction: $direction
    page: $page
    per: $per
  ) {
    collection {
      ...SkillFragment
      professions {
        ...ProfessionFragment
      }
      collaborators {
        ...UserMinimalFragment
      }
    }
    metadata {
      totalCount
    }
  }
}
    ${SkillFragment}
${ProfessionFragment}
${UserMinimalFragment}`;

/**
 * __useGetSkillsWithProfessions__
 *
 * To run a query within a React component, call `useGetSkillsWithProfessions` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsWithProfessions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsWithProfessions({
 *   variables: {
 *      q: // value for 'q'
 *      sortBy: // value for 'sortBy'
 *      direction: // value for 'direction'
 *      locale: // value for 'locale'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *   },
 * });
 */
export function useGetSkillsWithProfessions(baseOptions?: Apollo.QueryHookOptions<GetSkillsWithProfessions, GetSkillsWithProfessionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillsWithProfessions, GetSkillsWithProfessionsVariables>(GetSkillsWithProfessionsDocument, options);
      }
export function useGetSkillsWithProfessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillsWithProfessions, GetSkillsWithProfessionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillsWithProfessions, GetSkillsWithProfessionsVariables>(GetSkillsWithProfessionsDocument, options);
        }
export type GetSkillsWithProfessionsHookResult = ReturnType<typeof useGetSkillsWithProfessions>;
export type GetSkillsWithProfessionsLazyQueryHookResult = ReturnType<typeof useGetSkillsWithProfessionsLazyQuery>;
export type GetSkillsWithProfessionsQueryResult = Apollo.QueryResult<GetSkillsWithProfessions, GetSkillsWithProfessionsVariables>;
export function refetchGetSkillsWithProfessions(variables?: GetSkillsWithProfessionsVariables) {
      return { query: GetSkillsWithProfessionsDocument, variables: variables }
    }
export const InsertTemplateDocument = gql`
    mutation insertTemplate($input: InsertTemplateInput!) {
  insertTemplate(input: $input) {
    template {
      ...TemplateFragment
    }
  }
}
    ${TemplateFragment}`;
export type InsertTemplateMutationFn = Apollo.MutationFunction<InsertTemplate, InsertTemplateVariables>;

/**
 * __useInsertTemplate__
 *
 * To run a mutation, you first call `useInsertTemplate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTemplate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTemplate, { data, loading, error }] = useInsertTemplate({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertTemplate(baseOptions?: Apollo.MutationHookOptions<InsertTemplate, InsertTemplateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertTemplate, InsertTemplateVariables>(InsertTemplateDocument, options);
      }
export type InsertTemplateHookResult = ReturnType<typeof useInsertTemplate>;
export type InsertTemplateMutationResult = Apollo.MutationResult<InsertTemplate>;
export type InsertTemplateMutationOptions = Apollo.BaseMutationOptions<InsertTemplate, InsertTemplateVariables>;
export const DeleteTemplateDocument = gql`
    mutation deleteTemplate($input: DeleteTemplateInput!) {
  deleteTemplate(input: $input) {
    id
  }
}
    `;
export type DeleteTemplateMutationFn = Apollo.MutationFunction<DeleteTemplate, DeleteTemplateVariables>;

/**
 * __useDeleteTemplate__
 *
 * To run a mutation, you first call `useDeleteTemplate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplate, { data, loading, error }] = useDeleteTemplate({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplate(baseOptions?: Apollo.MutationHookOptions<DeleteTemplate, DeleteTemplateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplate, DeleteTemplateVariables>(DeleteTemplateDocument, options);
      }
export type DeleteTemplateHookResult = ReturnType<typeof useDeleteTemplate>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<DeleteTemplate>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTemplate, DeleteTemplateVariables>;
export const GetTemplateDocument = gql`
    query getTemplate($id: ID!) {
  template(id: $id) {
    ...TemplateFragment
  }
}
    ${TemplateFragment}`;

/**
 * __useGetTemplate__
 *
 * To run a query within a React component, call `useGetTemplate` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplate` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplate({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTemplate(baseOptions: Apollo.QueryHookOptions<GetTemplate, GetTemplateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplate, GetTemplateVariables>(GetTemplateDocument, options);
      }
export function useGetTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplate, GetTemplateVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplate, GetTemplateVariables>(GetTemplateDocument, options);
        }
export type GetTemplateHookResult = ReturnType<typeof useGetTemplate>;
export type GetTemplateLazyQueryHookResult = ReturnType<typeof useGetTemplateLazyQuery>;
export type GetTemplateQueryResult = Apollo.QueryResult<GetTemplate, GetTemplateVariables>;
export function refetchGetTemplate(variables?: GetTemplateVariables) {
      return { query: GetTemplateDocument, variables: variables }
    }
export const GetTemplatesDocument = gql`
    query getTemplates($reviewId: ID, $q: String, $page: Int, $per: Int, $sortBy: String, $direction: String, $areFavorite: Boolean) {
  templates(
    page: $page
    per: $per
    sortBy: $sortBy
    direction: $direction
    q: $q
    reviewId: $reviewId
    areFavorite: $areFavorite
  ) {
    collection {
      ...TemplateFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${TemplateFragment}`;

/**
 * __useGetTemplates__
 *
 * To run a query within a React component, call `useGetTemplates` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplates` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplates({
 *   variables: {
 *      reviewId: // value for 'reviewId'
 *      q: // value for 'q'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      sortBy: // value for 'sortBy'
 *      direction: // value for 'direction'
 *      areFavorite: // value for 'areFavorite'
 *   },
 * });
 */
export function useGetTemplates(baseOptions?: Apollo.QueryHookOptions<GetTemplates, GetTemplatesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplates, GetTemplatesVariables>(GetTemplatesDocument, options);
      }
export function useGetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplates, GetTemplatesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplates, GetTemplatesVariables>(GetTemplatesDocument, options);
        }
export type GetTemplatesHookResult = ReturnType<typeof useGetTemplates>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplates, GetTemplatesVariables>;
export function refetchGetTemplates(variables?: GetTemplatesVariables) {
      return { query: GetTemplatesDocument, variables: variables }
    }
export const InsertTranslationDocument = gql`
    mutation insertTranslation($input: InsertTranslationInput!) {
  insertTranslation(input: $input) {
    translation {
      ...TranslationFragment
    }
  }
}
    ${TranslationFragment}`;
export type InsertTranslationMutationFn = Apollo.MutationFunction<InsertTranslation, InsertTranslationVariables>;

/**
 * __useInsertTranslation__
 *
 * To run a mutation, you first call `useInsertTranslation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTranslation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTranslation, { data, loading, error }] = useInsertTranslation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertTranslation(baseOptions?: Apollo.MutationHookOptions<InsertTranslation, InsertTranslationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertTranslation, InsertTranslationVariables>(InsertTranslationDocument, options);
      }
export type InsertTranslationHookResult = ReturnType<typeof useInsertTranslation>;
export type InsertTranslationMutationResult = Apollo.MutationResult<InsertTranslation>;
export type InsertTranslationMutationOptions = Apollo.BaseMutationOptions<InsertTranslation, InsertTranslationVariables>;
export const DeleteAvatarDocument = gql`
    mutation deleteAvatar($input: DeleteAvatarInput!) {
  deleteAvatar(input: $input) {
    user {
      id
      avatar
    }
  }
}
    `;
export type DeleteAvatarMutationFn = Apollo.MutationFunction<DeleteAvatar, DeleteAvatarVariables>;

/**
 * __useDeleteAvatar__
 *
 * To run a mutation, you first call `useDeleteAvatar` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAvatar` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAvatar, { data, loading, error }] = useDeleteAvatar({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAvatar(baseOptions?: Apollo.MutationHookOptions<DeleteAvatar, DeleteAvatarVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAvatar, DeleteAvatarVariables>(DeleteAvatarDocument, options);
      }
export type DeleteAvatarHookResult = ReturnType<typeof useDeleteAvatar>;
export type DeleteAvatarMutationResult = Apollo.MutationResult<DeleteAvatar>;
export type DeleteAvatarMutationOptions = Apollo.BaseMutationOptions<DeleteAvatar, DeleteAvatarVariables>;
export const DeleteCredentialDocument = gql`
    mutation deleteCredential {
  deleteCredential @client
}
    `;
export type DeleteCredentialMutationFn = Apollo.MutationFunction<DeleteCredential, DeleteCredentialVariables>;

/**
 * __useDeleteCredential__
 *
 * To run a mutation, you first call `useDeleteCredential` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCredential` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCredential, { data, loading, error }] = useDeleteCredential({
 *   variables: {
 *   },
 * });
 */
export function useDeleteCredential(baseOptions?: Apollo.MutationHookOptions<DeleteCredential, DeleteCredentialVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCredential, DeleteCredentialVariables>(DeleteCredentialDocument, options);
      }
export type DeleteCredentialHookResult = ReturnType<typeof useDeleteCredential>;
export type DeleteCredentialMutationResult = Apollo.MutationResult<DeleteCredential>;
export type DeleteCredentialMutationOptions = Apollo.BaseMutationOptions<DeleteCredential, DeleteCredentialVariables>;
export const InsertUserDocument = gql`
    mutation insertUser($input: InsertUserInput!) {
  insertUser(input: $input) {
    user {
      ...UserMinimalFragment
      isCapableOfCreatingStandaloneAnswers
      isCapableOfCreatingStandaloneQuestions
      isCapableOfDeletingAllAnswers
      isCapableOfDeletingCampaigns
      isCapableOfDeletingGroups
      isCapableOfDeletingReviews
      isCapableOfDeletingTemplates
      isCapableOfInsertingCampaigns
      isCapableOfInsertingGroups
      isCapableOfInsertingProfessionSkills
      isCapableOfInsertingProfessions
      isCapableOfInsertingReviews
      isCapableOfInsertingSkills
      isCapableOfInsertingTemplates
      isCapableOfInsertingTranslations
      isCapableOfInsertingUsers
      isCapableOfReadingActivities
      isCapableOfReadingActivitiesIps
      isCapableOfReadingAllReviews
      isCapableOfReadingCampaigns
      isCapableOfReadingGroups
      isCapableOfReadingSkills
      isCapableOfReadingQuestions
      isCapableOfReadingReviews
      isCapableOfReadingStandaloneAnswers
      isCapableOfReadingStandaloneQuestions
      isCapableOfReadingTemplates
      isCapableOfReadingUserDocuments
      isCapableOfReadingUserNotes
      isCapableOfReadingUsers
      isCapableOfSigningReports
      isCapableOfUpdatingCompanies
      isCapableOfUpdatingUserCapabilities
      isCapableOfUpdatingUserNotes
    }
  }
}
    ${UserMinimalFragment}`;
export type InsertUserMutationFn = Apollo.MutationFunction<InsertUser, InsertUserVariables>;

/**
 * __useInsertUser__
 *
 * To run a mutation, you first call `useInsertUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUser, { data, loading, error }] = useInsertUser({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertUser(baseOptions?: Apollo.MutationHookOptions<InsertUser, InsertUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUser, InsertUserVariables>(InsertUserDocument, options);
      }
export type InsertUserHookResult = ReturnType<typeof useInsertUser>;
export type InsertUserMutationResult = Apollo.MutationResult<InsertUser>;
export type InsertUserMutationOptions = Apollo.BaseMutationOptions<InsertUser, InsertUserVariables>;
export const SendConnectionLinkDocument = gql`
    mutation sendConnectionLink($input: SendConnectionLinkInput!) {
  sendConnectionLink(input: $input) {
    success
  }
}
    `;
export type SendConnectionLinkMutationFn = Apollo.MutationFunction<SendConnectionLink, SendConnectionLinkVariables>;

/**
 * __useSendConnectionLink__
 *
 * To run a mutation, you first call `useSendConnectionLink` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConnectionLink` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConnectionLink, { data, loading, error }] = useSendConnectionLink({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendConnectionLink(baseOptions?: Apollo.MutationHookOptions<SendConnectionLink, SendConnectionLinkVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendConnectionLink, SendConnectionLinkVariables>(SendConnectionLinkDocument, options);
      }
export type SendConnectionLinkHookResult = ReturnType<typeof useSendConnectionLink>;
export type SendConnectionLinkMutationResult = Apollo.MutationResult<SendConnectionLink>;
export type SendConnectionLinkMutationOptions = Apollo.BaseMutationOptions<SendConnectionLink, SendConnectionLinkVariables>;
export const SetCredentialDocument = gql`
    mutation setCredential($accessToken: String!, $tokenType: String!, $client: String!, $expiry: Int!, $uid: String) {
  setCredential(
    accessToken: $accessToken
    tokenType: $tokenType
    client: $client
    expiry: $expiry
    uid: $uid
  ) @client
}
    `;
export type SetCredentialMutationFn = Apollo.MutationFunction<SetCredential, SetCredentialVariables>;

/**
 * __useSetCredential__
 *
 * To run a mutation, you first call `useSetCredential` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCredential` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCredential, { data, loading, error }] = useSetCredential({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      tokenType: // value for 'tokenType'
 *      client: // value for 'client'
 *      expiry: // value for 'expiry'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useSetCredential(baseOptions?: Apollo.MutationHookOptions<SetCredential, SetCredentialVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCredential, SetCredentialVariables>(SetCredentialDocument, options);
      }
export type SetCredentialHookResult = ReturnType<typeof useSetCredential>;
export type SetCredentialMutationResult = Apollo.MutationResult<SetCredential>;
export type SetCredentialMutationOptions = Apollo.BaseMutationOptions<SetCredential, SetCredentialVariables>;
export const UserLoginDocument = gql`
    mutation userLogin($email: String!, $password: String!) {
  userLogin(email: $email, password: $password) {
    credentials {
      ...CredentialFragment
    }
  }
}
    ${CredentialFragment}`;
export type UserLoginMutationFn = Apollo.MutationFunction<UserLogin, UserLoginVariables>;

/**
 * __useUserLogin__
 *
 * To run a mutation, you first call `useUserLogin` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLogin` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLogin, { data, loading, error }] = useUserLogin({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUserLogin(baseOptions?: Apollo.MutationHookOptions<UserLogin, UserLoginVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserLogin, UserLoginVariables>(UserLoginDocument, options);
      }
export type UserLoginHookResult = ReturnType<typeof useUserLogin>;
export type UserLoginMutationResult = Apollo.MutationResult<UserLogin>;
export type UserLoginMutationOptions = Apollo.BaseMutationOptions<UserLogin, UserLoginVariables>;
export const UserSendPasswordResetDocument = gql`
    mutation userSendPasswordReset($email: String!, $redirectUrl: String!) {
  userSendPasswordReset(email: $email, redirectUrl: $redirectUrl) {
    message
  }
}
    `;
export type UserSendPasswordResetMutationFn = Apollo.MutationFunction<UserSendPasswordReset, UserSendPasswordResetVariables>;

/**
 * __useUserSendPasswordReset__
 *
 * To run a mutation, you first call `useUserSendPasswordReset` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSendPasswordReset` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSendPasswordReset, { data, loading, error }] = useUserSendPasswordReset({
 *   variables: {
 *      email: // value for 'email'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useUserSendPasswordReset(baseOptions?: Apollo.MutationHookOptions<UserSendPasswordReset, UserSendPasswordResetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSendPasswordReset, UserSendPasswordResetVariables>(UserSendPasswordResetDocument, options);
      }
export type UserSendPasswordResetHookResult = ReturnType<typeof useUserSendPasswordReset>;
export type UserSendPasswordResetMutationResult = Apollo.MutationResult<UserSendPasswordReset>;
export type UserSendPasswordResetMutationOptions = Apollo.BaseMutationOptions<UserSendPasswordReset, UserSendPasswordResetVariables>;
export const UserUpdatePasswordDocument = gql`
    mutation userUpdatePassword($password: String!, $passwordConfirmation: String!, $currentPassword: String) {
  userUpdatePassword(
    password: $password
    passwordConfirmation: $passwordConfirmation
    currentPassword: $currentPassword
  ) {
    authenticatable {
      id
    }
  }
}
    `;
export type UserUpdatePasswordMutationFn = Apollo.MutationFunction<UserUpdatePassword, UserUpdatePasswordVariables>;

/**
 * __useUserUpdatePassword__
 *
 * To run a mutation, you first call `useUserUpdatePassword` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatePassword` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdatePassword, { data, loading, error }] = useUserUpdatePassword({
 *   variables: {
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      currentPassword: // value for 'currentPassword'
 *   },
 * });
 */
export function useUserUpdatePassword(baseOptions?: Apollo.MutationHookOptions<UserUpdatePassword, UserUpdatePasswordVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdatePassword, UserUpdatePasswordVariables>(UserUpdatePasswordDocument, options);
      }
export type UserUpdatePasswordHookResult = ReturnType<typeof useUserUpdatePassword>;
export type UserUpdatePasswordMutationResult = Apollo.MutationResult<UserUpdatePassword>;
export type UserUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UserUpdatePassword, UserUpdatePasswordVariables>;
export const AddUserDocumentDocument = gql`
    mutation AddUserDocument($input: AddUserDocumentInput!) {
  addUserDocument(input: $input) {
    document {
      id
      url
    }
  }
}
    `;
export type AddUserDocumentMutationFn = Apollo.MutationFunction<AddUserDocument, AddUserDocumentVariables>;

/**
 * __useAddUserDocument__
 *
 * To run a mutation, you first call `useAddUserDocument` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserDocument` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserDocument, { data, loading, error }] = useAddUserDocument({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserDocument(baseOptions?: Apollo.MutationHookOptions<AddUserDocument, AddUserDocumentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserDocument, AddUserDocumentVariables>(AddUserDocumentDocument, options);
      }
export type AddUserDocumentHookResult = ReturnType<typeof useAddUserDocument>;
export type AddUserDocumentMutationResult = Apollo.MutationResult<AddUserDocument>;
export type AddUserDocumentMutationOptions = Apollo.BaseMutationOptions<AddUserDocument, AddUserDocumentVariables>;
export const DeleteUserDocumentDocument = gql`
    mutation deleteUserDocument($input: DeleteUserDocumentInput!) {
  deleteUserDocument(input: $input) {
    id
  }
}
    `;
export type DeleteUserDocumentMutationFn = Apollo.MutationFunction<DeleteUserDocument, DeleteUserDocumentVariables>;

/**
 * __useDeleteUserDocument__
 *
 * To run a mutation, you first call `useDeleteUserDocument` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDocument` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDocument, { data, loading, error }] = useDeleteUserDocument({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserDocument(baseOptions?: Apollo.MutationHookOptions<DeleteUserDocument, DeleteUserDocumentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserDocument, DeleteUserDocumentVariables>(DeleteUserDocumentDocument, options);
      }
export type DeleteUserDocumentHookResult = ReturnType<typeof useDeleteUserDocument>;
export type DeleteUserDocumentMutationResult = Apollo.MutationResult<DeleteUserDocument>;
export type DeleteUserDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteUserDocument, DeleteUserDocumentVariables>;
export const GetUserDocument = gql`
    query getUser($id: ID!) {
  user(id: $id) {
    ...UserReviewFragment
  }
}
    ${UserReviewFragment}`;

/**
 * __useGetUser__
 *
 * To run a query within a React component, call `useGetUser` and pass it any options that fit your needs.
 * When your component renders, `useGetUser` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUser({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUser(baseOptions: Apollo.QueryHookOptions<GetUser, GetUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUser, GetUserVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUser, GetUserVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUser, GetUserVariables>(GetUserDocument, options);
        }
export type GetUserHookResult = ReturnType<typeof useGetUser>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUser, GetUserVariables>;
export function refetchGetUser(variables?: GetUserVariables) {
      return { query: GetUserDocument, variables: variables }
    }
export const GetUsersDocument = gql`
    query getUsers($companyId: ID, $ids: [ID!], $idsStrict: [ID!], $notIds: [ID!], $q: String, $groupId: ID, $groupIds: [ID!], $page: Int, $per: Int, $sortBy: String, $skillId: ID, $direction: String, $havingAnswersMatching: [AnswerMatchingInput!]) {
  users(
    companyId: $companyId
    q: $q
    groupId: $groupId
    groupIds: $groupIds
    ids: $ids
    idsStrict: $idsStrict
    notIds: $notIds
    page: $page
    per: $per
    sortBy: $sortBy
    skillId: $skillId
    direction: $direction
    havingAnswersMatching: $havingAnswersMatching
  ) {
    collection {
      ...UserSummaryFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${UserSummaryFragment}`;

/**
 * __useGetUsers__
 *
 * To run a query within a React component, call `useGetUsers` and pass it any options that fit your needs.
 * When your component renders, `useGetUsers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsers({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      ids: // value for 'ids'
 *      idsStrict: // value for 'idsStrict'
 *      notIds: // value for 'notIds'
 *      q: // value for 'q'
 *      groupId: // value for 'groupId'
 *      groupIds: // value for 'groupIds'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      sortBy: // value for 'sortBy'
 *      skillId: // value for 'skillId'
 *      direction: // value for 'direction'
 *      havingAnswersMatching: // value for 'havingAnswersMatching'
 *   },
 * });
 */
export function useGetUsers(baseOptions?: Apollo.QueryHookOptions<GetUsers, GetUsersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsers, GetUsersVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsers, GetUsersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsers, GetUsersVariables>(GetUsersDocument, options);
        }
export type GetUsersHookResult = ReturnType<typeof useGetUsers>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsers, GetUsersVariables>;
export function refetchGetUsers(variables?: GetUsersVariables) {
      return { query: GetUsersDocument, variables: variables }
    }
export const GetUsersMinimalDocument = gql`
    query getUsersMinimal($companyId: ID, $ids: [ID!], $idsStrict: [ID!], $notIds: [ID!], $q: String, $groupId: ID, $groupIds: [ID!], $page: Int, $per: Int, $sortBy: String, $skillId: ID, $direction: String, $havingAnswersMatching: [AnswerMatchingInput!]) {
  users(
    companyId: $companyId
    q: $q
    groupId: $groupId
    groupIds: $groupIds
    ids: $ids
    idsStrict: $idsStrict
    notIds: $notIds
    page: $page
    per: $per
    sortBy: $sortBy
    skillId: $skillId
    direction: $direction
    havingAnswersMatching: $havingAnswersMatching
  ) {
    collection {
      ...UserSummaryFragment
    }
    metadata {
      totalCount
    }
  }
}
    ${UserSummaryFragment}`;

/**
 * __useGetUsersMinimal__
 *
 * To run a query within a React component, call `useGetUsersMinimal` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersMinimal` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersMinimal({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      ids: // value for 'ids'
 *      idsStrict: // value for 'idsStrict'
 *      notIds: // value for 'notIds'
 *      q: // value for 'q'
 *      groupId: // value for 'groupId'
 *      groupIds: // value for 'groupIds'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      sortBy: // value for 'sortBy'
 *      skillId: // value for 'skillId'
 *      direction: // value for 'direction'
 *      havingAnswersMatching: // value for 'havingAnswersMatching'
 *   },
 * });
 */
export function useGetUsersMinimal(baseOptions?: Apollo.QueryHookOptions<GetUsersMinimal, GetUsersMinimalVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersMinimal, GetUsersMinimalVariables>(GetUsersMinimalDocument, options);
      }
export function useGetUsersMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersMinimal, GetUsersMinimalVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersMinimal, GetUsersMinimalVariables>(GetUsersMinimalDocument, options);
        }
export type GetUsersMinimalHookResult = ReturnType<typeof useGetUsersMinimal>;
export type GetUsersMinimalLazyQueryHookResult = ReturnType<typeof useGetUsersMinimalLazyQuery>;
export type GetUsersMinimalQueryResult = Apollo.QueryResult<GetUsersMinimal, GetUsersMinimalVariables>;
export function refetchGetUsersMinimal(variables?: GetUsersMinimalVariables) {
      return { query: GetUsersMinimalDocument, variables: variables }
    }
export const GetPublicUserDocument = gql`
    query getPublicUser($email: String!) {
  publicUser(email: $email) {
    email
    samlRedirectUrl
  }
}
    `;

/**
 * __useGetPublicUser__
 *
 * To run a query within a React component, call `useGetPublicUser` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicUser` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicUser({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetPublicUser(baseOptions: Apollo.QueryHookOptions<GetPublicUser, GetPublicUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicUser, GetPublicUserVariables>(GetPublicUserDocument, options);
      }
export function useGetPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicUser, GetPublicUserVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicUser, GetPublicUserVariables>(GetPublicUserDocument, options);
        }
export type GetPublicUserHookResult = ReturnType<typeof useGetPublicUser>;
export type GetPublicUserLazyQueryHookResult = ReturnType<typeof useGetPublicUserLazyQuery>;
export type GetPublicUserQueryResult = Apollo.QueryResult<GetPublicUser, GetPublicUserVariables>;
export function refetchGetPublicUser(variables?: GetPublicUserVariables) {
      return { query: GetPublicUserDocument, variables: variables }
    }
export const GetViewerDocument = gql`
    query getViewer {
  viewer {
    ...ViewerFragment
  }
}
    ${ViewerFragment}`;

/**
 * __useGetViewer__
 *
 * To run a query within a React component, call `useGetViewer` and pass it any options that fit your needs.
 * When your component renders, `useGetViewer` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewer({
 *   variables: {
 *   },
 * });
 */
export function useGetViewer(baseOptions?: Apollo.QueryHookOptions<GetViewer, GetViewerVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewer, GetViewerVariables>(GetViewerDocument, options);
      }
export function useGetViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewer, GetViewerVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewer, GetViewerVariables>(GetViewerDocument, options);
        }
export type GetViewerHookResult = ReturnType<typeof useGetViewer>;
export type GetViewerLazyQueryHookResult = ReturnType<typeof useGetViewerLazyQuery>;
export type GetViewerQueryResult = Apollo.QueryResult<GetViewer, GetViewerVariables>;
export function refetchGetViewer(variables?: GetViewerVariables) {
      return { query: GetViewerDocument, variables: variables }
    }